/* eslint quotes: 0 */
// prettier-ignore
export default {
en: { translation: {
  "common.buyTickets": "Buy tickets",
  "common.cancel": "cancel",
  "common.done": "done",
  "common.ok": "ok",
  "clubOne.level": "Club one {{level}}",
  "clubOne.points.points": "pts.",
  "clubOne.points.hint": "You can use Club One points to pay for bonus trips.",
  "clubOne.switchToCompanyCustomer.warning": "You will be logged out.",
  "clubOne.switchToCompanyCustomer.title": "Switch to company customer",
  "clubOne.loginLink": "Sign in with club one",
  "clubOne.title": "Club One customer",
  "companyCustomer.agentId": "Agent ID",
  "companyCustomer.agentId.error": "Agent ID cannot be found",
  "companyCustomer.agentId.pattern": "You can use only numbers",
  "companyCustomer.error": "Company customer with given credentials cannot be found",
  "companyCustomer.id": "Company ID",
  "companyCustomer.login": "Log in",
  "companyCustomer.title": "Company customer",
  "deliveryDetails.clubOneAnonymous.text": "Tickets are sent to email address provided below.",
  "deliveryDetails.clubOneLogged.text": "Tickets are sent to email address below",
  "deliveryDetails.companyCustomerAnonymous.text": "Tickets are sent to email address below.",
  "deliveryDetails.companyCustomerLogged.text": "Tickets are sent to email address below.",
  "deliveryDetails.form.email.label": "e-mail address",
  "deliveryDetails.form.error.emailPattern": "Address seems to be incomplete.",
  "deliveryDetails.form.error.namePattern": "For name you can use letters, ' and -.",
  "deliveryDetails.form.error.required": "This field is required.",
  "deliveryDetails.form.firstName.label": "first name",
  "deliveryDetails.form.lastName.label": "last name",
  "deliveryDetails.title": "Delivery details",
  "description.passenger": "One passenger serial-ticket is valid for one passenger one-way trip.",
  "description.vehicle": "One vehicle serial-ticket is valid for one-way travel of one vehicle and does not include a passenger ticket.",
  "hero.mainTitle": "Serial-tickets",
  "hero.subtitle": "One serial-ticket allows one passenger/vehicle to travel one-way in the chosen direction.",
  "hint.clubOne.error": "There was an error while loading this component. Try to reload the page or continue without signing in. We apoligize for the inconvenience. ",
  "hint.clubOne.text": "Club One members get discounts and collect bonus points that can be used for purchasing new trips. <a href=\"https://www.tallinksilja.com/what-is-club-one\" target=\"_blank\">Read more and become a member.</a>",
  "mainPage.title": "Serial Tickets",
  "mobile.back": "← Back",
  "mobile.done": "Continue",
  "price.description": "Tickets",
  "price.amount": "Amount",
  "price.discount": "Discount",
  "price.price": "Price",
  "price.regular": "Regular price",
  "price.giftCard": "Gift card",
  "serialTicketName.passenger.business": "Ticket in Business Lounge",
  "serialTicketName.passenger.comfort": "Ticket in Comfort Lounge",
  "serialTicketName.passenger.star": "Ticket  in Star Class",
  "serialTicketName.vehicle.CAR": "ticket for passenger car \n(up to ↔5 m ↕1,9 m)",
  "serialTicketName.vehicle.CAR XL": "ticket for passenger car \n(up to ↔5,5 m ↕2,4 m)",
  "serialTicketName.vehicle.VAN": "ticket for van \n(up to ↔7 m ↕2,4 m)",
  "signIn.button": "sign in",
  "signOut.link": "sign out →",
  "signInWithCompanyId.link": "sign in USING COMPANY ID →\n",
  "srt.termsAndConditions.title": "Terms and conditions of Tallink serial tickets ",
  "termsAndConditions.text": "<li>Serial-ticket is valid for 8x, 14x or 24x one-way trips on the Tallinn-Helsinki or Helsinki-Tallinn routes.</li>\n<li>Serial ticket is valid on all Tallinn-Helsinki or Helsinki-Tallinn departures.</li>\n<li>Serial ticket is not personalized, therefore can be shared with friends, family or colleagues.</li>\n<li>One passenger serial ticket is valid for one passenger on one-way trip.</li>\n<li>One vehicle serial ticket is valid for one vehicle on one-way travel and does not include a passenger ticket.</li>\n<li>Serial tickets are valid for one year.</li>\n<li>Serial tickets can be purchased from Tallink’s sales agencies, call center and website.</li>\n<li>With a serial ticket, you can purchase a trip from Tallink’s sales agencies, call center and website.\n<li>You can use up to six serial tickets in one booking.</li>\n<li>For online booking, serial ticket is always valid from the first direction, passenger and car.</li>\n<li>There is no penalty fee for changing the ticket paid with a serial ticket and you can change the ticket until the end of the check-in.</li>\n",
  "type.passenger": "traveller tickets",
  "type.vehicle": "car tickets",
  "voucherPanel.header": "Gift cards",
  "voucherPanel.link.addAnotherVoucher": "+ Add another code",
  "voucherPanel.link.addVoucher": "I have a promotional code or gift card",
  "voucherPanel.voucher.button.add": "Add",
  "voucherPanel.voucher.hint": "The gift card can be used on multiple purchases until the funds are used up.<br>\nThe gift card has <b>{{amountLeft}} €</b>.<br>\nValid until <b>{{expirationDate}}</b>.",
  "voucherPanel.voucher.label": "Gift-card code",
  "voucherPanel.voucher.validate.callToCallCenter": "To use a gift card, please call +49 40 547 541 222",
  "voucherPanel.voucher.validate.error": "Please check the code",
  "payment.unsuccessful.description": "Something went wrong with your payment process. Make sure you have enough funds to complete the order and try again.",
  "payment.unsuccessful.title": "payment unsuccessful",
  "payment.cancelled.title": "This order has not been paid",
  "payment.title": "Payment options",
  "payment.paymentServiceMethods.title": "Cards",
  "payment.paymentServiceMethods.combined.title": "Banks / Cards",
  "payment.disclaimer": "By pressing the payment button, you agree with <a href=\"https://www.tallinksilja.com/good-to-know\" target=\"_blank\">terms and conditions</a> and <a href=\"https://en.tallink.com/good-to-know#16661470\" target=\"_blank\">security regulations</a>. Under 18 years old passenger, please remember to read the <a href=\"https://www.tallinksilja.com/good-to-know#16658622\" target=\"_blank\">age regulations</a>. ",
  "payment.disclaimer.Extra.TallinkGrupp": "Under 18 years old passenger, please remember to read the <a href=\"https://www.tallinksilja.com/good-to-know#16658622\" target=\"_blank\">age regulations</a>. By pressing the payment button, you agree with <a href=\"https://www.tallinksilja.com/good-to-know\" target=\"_blank\">terms and conditions</a> and <a href=\"https://en.tallink.com/good-to-know#16661470\" target=\"_blank\">security regulations</a>.<br>\nThe combination of travel services offered to you is a package within the meaning of Directive (EU) 2015/2302.<br>\nTherefore, you will benefit from all EU rights applying to packages. AS Tallink Grupp will be fully responsible for the proper performance of the package as a whole.<br>\nAdditionally, as required by law, AS Tallink Grupp  has protection in place to refund your payments and, where transport is included in the package, to ensure your repatriation in the event that it becomes.<br>\n<a href=\"https://www.tallinksilja.com/packaged-tours-tallink-grupp\" target=\"_blank\">View the terms of travel packages</a>.",
  "payment.disclaimer.Extra.TallinkSiljaOY": "Under 18 years old passenger, please remember to read the <a href=\"https://www.tallinksilja.com/good-to-know#16658622\" target=\"_blank\">age regulations</a>. By pressing the payment button, you agree with <a href=\"https://www.tallinksilja.com/good-to-know\" target=\"_blank\">terms and conditions</a> and <a href=\"https://en.tallink.com/good-to-know#16661470\" target=\"_blank\">security regulations</a>.<br>\nThe combination of travel services offered to you is a package within the meaning of Directive (EU) 2015/2302.<br>\nTherefore, you will benefit from all EU rights applying to packages. Tallink Silja Oy will be fully responsible for the proper performance of the package as a whole.<br>\nAdditionally, as required by law, Tallink Silja Oy has protection in place to refund your payments and, where transport is included in the package, to ensure your repatriation in the event that it becomes.<br>\n<a href=\"https://en.tallink.com/packaged-tours-tallink-silja\" target=\"_blank\">View the terms of travel packages</a>.",
  "passengerDistribution.errors.WITHOUT_ADULT": "At least one adult required per cabin",
  "passengerDistribution.errors.WITHOUT_CABIN": "Please assign the remaining {nrOfPassengersWithoutCabin} {nrOfPassengersWithoutCabin, plural, =0{passengers} one{passenger} other{passengers}} into cabins.",
  "passengerDistribution.notification.childWithoutOwnBed": "Child will not have its own bed.",
  "payment.klarna.title": "Klarna",
  "payment.onlineBanks.list.aktia": "Aktia",
  "payment.onlineBanks.list.alandsbanken": "Ålandsbanken",
  "payment.onlineBanks.list.coop": "COOP Pank",
  "payment.onlineBanks.list.danskebankEE": "Danske Bank",
  "payment.onlineBanks.list.danskebankFI": "Danske Bank",
  "payment.onlineBanks.list.handelsbanken": "Handelsbanken",
  "payment.onlineBanks.list.kultaraha": "Osuuspankki",
  "payment.onlineBanks.list.lahitapiola": "LähiTapiola",
  "payment.onlineBanks.list.lhv": "LHV",
  "payment.onlineBanks.list.luminor": "Luminor",
  "payment.onlineBanks.list.nordea": "Nordea",
  "payment.onlineBanks.list.saastopankki": "Säästöpankki",
  "payment.onlineBanks.list.seb": "SEB",
  "payment.onlineBanks.list.spankki": "S-Pankki",
  "payment.onlineBanks.list.swedbank": "Swedbank",
  "payment.invoice.title": "Payment method",
  "payment.type.invoice": "I want to pay with invoice",
  "payment.reference.title": "Your reference number",
  "payment.reference.disclaimer": "By pressing the payment button, you agree with <a href=\"https://www.tallinksilja.com/good-to-know\" target=\"_blank\">terms and conditions</a>and <a href=\"https://en.tallink.com/good-to-know#16661470\" target=\"_blank\">security regulations</a>.",
  "payment.type.card": "I want to pay with card",
  "payment.klarna.options.title": "The available payment options depend on your booking, the most common options are:",
  "payment.klarna.options.list": "<li>Invoice payment</li><li>Part payment</li>",
  "payment.klarna.policy": "By confirming this booking you agree that your reservation data will be transferred to Klarna for checking available payment options. Read more <a href=\"https://cdn.klarna.com/1.0/shared/content/policy/data/en_fi/privacy_statement.pdf\" target=\"_blank\">about Klarna's use of your data</a>.",
  "payment.klarna.mobile.title": "Klarna lets you pay easily and securely with your mobile phone",
  "paymentPage.total": "Total",
  "paymentPage.confirm.freeReservation": "Confirm order",
  "paymentPage.confirm.onlyPayment": "Pay",
  "paymentPage.confirm.onlyPayment.withInvoice": "Confirm",
  "confirmation.thankYouCallout.title": "Thank you for your purchase!",
  "confirmation.thankYouCallout.paidTotal": "paid total",
  "confirmation.thankYouCallout.message": "Payment was successful and your order is confirmed. See confirmation PDF (sent to <b>{{email}}</b>) for full details.",
  "confirmation.orderConfirmation": "Order confirmation",
  "confirmation.summary.downloadPdf": "Download PDF",
  "confirmation.summary.bookTrip": "book a trip",
  "confirmation.summary.disclaimer": "You can use your purchase immediately. Go ahead, book your trip now.",
  "confirmation.summary.email": "E-mail address",
  "confirmation.summary.contactPerson": "Contact person  ",
  "confirmation.summary.securityCode": "Security code",
  "confirmation.summary.orderNumber": "Order number",
  "otherPaymentMethod": "Other payment method",
  "paymentMethod": "Payment method",
  "remove": "Remove",
  "answer.yes": "Yes",
  "answer.no": "No",
  "button.send": "Send",
  "button.withoutPrice.notChosen": "Select",
  "button.withoutPrice.chosen": "Selected",
  "button.add": "Add",
  "clubOne.level.BRONZE": "Bronze",
  "clubOne.level.SILVER": "Silver",
  "clubOne.level.GOLD": "Gold",
  "clubOne.level.title": "Club one",
  "currency.EUR": "€",
  "currency.LAT": "Ls",
  "currency.LVL": "Ls",
  "currency.RUB": "€",
  "currency.SEK": "kr",
  "dateFormat.dayOfWeekDayMonthAndTime": "{weekday} <b>{date}</b> at <b>{time}</b>",
  "decimalSeparator": ".",
  "details.dayMonthAndTime.pattern": "d/m \\\\a\\\\t H:i",
  "details.dayOfWeek.pattern": "l",
  "entertainment.title": "Entertainment onboard",
  "entertainment.sitting": "Seat",
  "error.chromeframe.label": "Or you can install to current browser Google's",
  "entertainment.sittingGroup.premium.name\r\n": "Premium seating",
  "entertainment.sittingGroup.premium.description": "Premium seating includes meals and have the best seats to the show!",
  "entertainment.sittingGroup.basic.name\r\n": "Limited seating",
  "entertainment.sittingGroup.basic.description": "Basic seating has a limited view to the stage.",
  "entertainment.sittingGroup.basic.addOn.name\r\n": "Seat with limited view on stage",
  "error.chromeframe.link": "Chrome Frame extension",
  "error.ie": "You're using Internet Explorer outdated version, which may have problems using Tallink Silja Line's online booking engine. We suggest updating current browser to any of following:",
  "error.notPossibleToChangeBookingOnline": "Unfortunately it's not possible to make online changes to your booking.<br><br>In case you need any changes, please write to our <a href=\"mailto:international.sales@tallinksilja.com\">customer service</a> or call +49(0)40 547 541 222",
  "form.email": "Email",
  "form.phone": "Phone",
  "format.LocalDayMonth": "{{date, d/M}}",
  "format.LocalShortWeekdayAndDayMonth": "D d/m",
  "format.LocalLongWeekdayAndDayMonth": "l d/m",
  "format.LocalShortWeekdayAndShortMonth": "MMM D",
  "format.LocalDayMonthYear": "d/m/Y",
  "header.bookingNumber": "Booking No",
  "header.logout": "Log out",
  "header.myBooking": "My booking",
  "header.pin": "Security code",
  "hotel.checkInTime": "Check-in at",
  "hotel.checkOutTime": "Check-out at",
  "nights": "nights",
  "night": "night",
  "hotelsItinerary.returnTripIsNotAvailable": "Return trip is not available. Please, change last room date.",
  "label.remove": "Remove",
  "landServices.title": "Onshore activities",
  "landService.ageCategory.base": "Basic ticket",
  "landService.ageCategory.child": "Children {ageCategory} yrs",
  "landService.dateTime.pattern": "d/m/Y",
  "meals.packages.choosePackage": "Choose meal package",
  "meals.packages.title": "Save & buy a meal package",
  "meals.packages.commonInfo": "Meal package includes meals for the whole trip.",
  "meals.packages.description": "Children receive a discount, and kids aged 0–5 eat for free when accompanied by a paying adult.<br>If dinings are sold out, vouchers (same value) will be added to the booking. Dining vouchers can be also used as payment in all ship’s restaurants.",
  "meals.button.freeMealPackages": "Included",
  "meals.selectionMealBlockedByTime": "Selection meal is blocked if time is less than 4 hours before departure, but meals could still be purchased onboard",
  "onboardServices.title": "Onboard services",
  "adults": "adults",
  "adult": "adult",
  "child": "child",
  "junior": "Junior",
  "youth": "Youth",
  "children": "children",
  "guests.edit.accessibility.label": "Edit passenger details",
  "pier.DTER.address": "Lootsi 13, 10151 Tallinn",
  "pier.DTER.title": "D-Terminal",
  "pier.FHAM.address": "Frihamnen, Magasin 2, 10253 Stockholm",
  "pier.FHAM.title": "Frihamnen",
  "pier.HND.title": "Härnösand",
  "pier.HND.address": "Skeppsbron 31, 871 80 Härnösand",
  "pier.LNAS.address": "Lumparland, Långnäs",
  "pier.LNAS.title": "Långnäs",
  "pier.LSA2.address": "West harbour, Helsinki",
  "pier.LSA2.title": "West terminal 2",
  "pier.LSA6.address": "Tyynenmerenkatu 8 00220 Helsinki",
  "pier.LSA6.title": "West terminal",
  "pier.LSAT.address": "Tyynenmerenkatu 8 00220 Helsinki",
  "pier.LSAT.title": "West terminal",
  "pier.MHAM.address": "Västra hamnen, Mariehamn",
  "pier.MHAM.title": "Mariehamn",
  "pier.MUUG.address": "Muuga sadam, Maardu Tee 65, Maardu",
  "pier.MUUG.title": "Muuga Harbour",
  "pier.OLYM.address": "Olympiaranta 1, 00140 Helsinki",
  "pier.OLYM.title": "Olympia terminal",
  "pier.PALD.address": "Rae põik 10, EE-76806 Paldiski",
  "pier.PALD.title": "Paldiski",
  "pier.KAPE.address": "Hamnterminalen, 760 15 Gräddö",
  "pier.KAPE.title": "Kapellskär",
  "pier.RIGA.address": "Eksporta 3a, Riga, LV-1010",
  "pier.RIGA.title": "Riga terminal",
  "pier.TSAT.address": "Linnankatu 91, 20100 Turku",
  "pier.TSAT.title": "Turku harbour",
  "pier.VHAM.address": "Hamnpirsvägen 10, 11574 Stockholm",
  "pier.VHAM.title": "Värtahamnen",
  "pier.VISH.title": "Visby",
  "pier.VISH.address": "Färjeleden 2, 621 81 Visby",
  "pier.VSAA.address": "Vuosaari, Seilorinkatu 5, Helsinki",
  "pier.VSAA.title": "Vuosaari Harbour",
  "pier.MFAC.address": "Bereg Nevskoy gubi 1., V.O., St. Petersburg",
  "pier.MFAC.title": "St. Petersburg",
  "pier.SAS.title": "Sassnitz",
  "pier.SMA1.title": "Saaremaa",
  "pier.SMA1.address": "Ninase village, Mustjala, 93631, Saaremaa",
  "pier.KLJ1.title": "Klaipeda",
  "pier.KLJ1.address": "J.Zauerveino str. 18, LT-92122 Klaipeda, Lithuania",
  "port.KAP": "Kapellskär",
  "port.PAL": "Paldiski",
  "port.KLJ": "Klaipeda",
  "port.YST": "Ystad",
  "port.PARTY": "Baltic Sea",
  "refresh": "Refresh",
  "reservation.travelPermitForYouth": "As a 15-17 year old you can travel without being accompanied by an adult. Remember to bring your <a href=\"https://ee.tallink.com/documents/10192/65371006/Permission_to_travel_alone_15_17_EN.pdf/7a0c8141-c394-42b5-a6db-29469450ddc6\" target=\"_blank\">travel permit</a> with you. Safe travels!",
  "send.email.failed": "E-mail sending failed. Please try again.",
  "send.sms.failed": "SMS sending failed. Please try again.",
  "summary.confirm": "Confirm",
  "summary.dateTime.pattern": "d/m/Y <\\\\sp\\\\a\\\\n>\\\\a\\\\t</\\\\sp\\\\a\\\\n> H:i",
  "summary.extraServices": "Cost of extra services are added to the price. Please refer to the pdf that was sent you in the e-mail for more details.",
  "summary.freeMealPackages.title": "Free additionals",
  "summary.refund.notification": "Please contact the customer support for the refund. Tel. {phoneLocal}",
  "summary.refund.notification.with.phoneInternational": "Please contact the customer support for the refund. Tel. {phoneLocal} / {phoneInternational}",
  "summary.refund.notification.phoneInternational.EE": " +372 640 9808",
  "summary.refund.notification.phoneInternational.SE": " +46 8 22 21 40",
  "summary.refund.notification.phoneLocal": " +49 (0)40 547 541 222",
  "summary.refund.notification.phoneLocal.FI": "(09) 887 53121",
  "summary.refund.notification.phoneLocal.EE": " 17 808",
  "summary.refund.notification.phoneLocal.SE": "08 22 21 40",
  "summary.refund.notification.phoneLocal.LV": " +371 670 997 00",
  "summary.refund.notification.phoneLocal.RU": " + 372 611 8801",
  "summary.clearChanges.title": "Changed your mind?",
  "summary.clearChanges.link": "Clear changes",
  "summary.overnightPackage": "Overnight package",
  "template.dateTime": "{date} <span>at</span> {time}",
  "time.preposition.at": "at",
  "validate.firstName": "First name should only contain latin characters.",
  "validate.lastName": "Last name should only contain latin characters",
  "location.hotelCityCode.HAA": "Haapsalu",
  "location.hotelCityCode.HEL": "Helsinki",
  "location.hotelCityCode.JUR": "Jurmala",
  "location.hotelCityCode.KOM": "Kolmården",
  "location.hotelCityCode.KUR": "Kuressaare",
  "location.hotelCityCode.LAL": "Laulasmaa",
  "location.hotelCityCode.MHQ": "Mariehamn",
  "location.hotelCityCode.NAR": "Narva",
  "location.hotelCityCode.NRK": "Norrkoping",
  "location.hotelCityCode.OTE": "Otepää",
  "location.hotelCityCode.PAR": "Parnu",
  "location.hotelCityCode.RAK": "Rakvere",
  "location.hotelCityCode.RIX": "Riga",
  "location.hotelCityCode.SOE": "Sodertalje",
  "location.hotelCityCode.STO": "Stockholm",
  "location.hotelCityCode.TAR": "Tartu",
  "location.hotelCityCode.TKU": "Turku",
  "location.hotelCityCode.TLL": "Tallinn",
  "location.hotelCityCode.TMP": "Tampere",
  "location.hotelCityCode.UPP": "Uppsala",
  "location.hotelCityCode.VAN": "Vantaa",
  "location.hotelCityCode.VIH": "Vihula",
  "vehicle.type.bicycle.title": "Bicycle, electric scooter",
  "vehicle.type.car.title": "Passenger car",
  "vehicle.type.car-xl.title": "Passenger car",
  "vehicle.type.long-and-high.title": "Car with trailer",
  "vehicle.type.long-and-low.title": "Car with trailer",
  "vehicle.type.long-and-medium.title": "Car with trailer",
  "vehicle.type.motorcycle.title": "Motorcycle",
  "vehicle.type.motorcycle-with-sidecar.title": "Motorcycle with sidecar",
  "vehicle.type.motorcycle-with-sidecar.measures": "Up to 1,9 m high and up to 4 m long",
  "vehicle.type.van-high.title": "High van",
  "vehicle.type.parked-car.title": "Parked car",
  "vehicle.type.van.title": "Van",
  "vehicle.type.parked-van.title": "Parked van",
  "vehicle.type.shopper-car.title": "Shopper car",
  "vehicle.type.shopper-van.title": "Shopper van",
  "vehicle.type.shopper-car.notices": "- Easy access to your car during trip<br>\n- Parked next to shops",
  "vehicle.type.shopper-van.notices": "- Easy access to your car during trip<br>\n- Parked next to shops",
  "vehicle.type.parked-car.notices": "- No access to your car during trip<br>\r\n- At the destination car can't be driven outside",
  "vehicle.type.parked-van.notices": "- No access to your car during trip<br>\r\n- At the destination car can't be driven outside",
  "vehicle.type.shopper-car.noDisembark": "No car disembarkation",
  "vehicle.type.shopper-van.noDisembark": "No van disembarkation",
  "vehicle.type.parked-car.noDisembark": "No disembarkation",
  "vehicle.type.under.measures": "<span class=\"height\"></span> {height} m <span class=\"width\"></span> {length} m",
  "wifi.title": "WiFi",
  "common.language.FI": "Finnish",
  "common.language.ET": "Estonian",
  "common.language.EN": "English",
  "common.language.RU": "Russian",
  "common.language.SV": "Swedish",
  "common.language.DE": "German",
  "common.language.LV": "Latvian",
  "common.language.LT": "Lithuanian",
  "label.or": "or",
  "routePanel.from": "From",
  "routePanel.to": "To",
  "port.ALA": "Åland",
  "port.HEL": "Helsinki",
  "port.MUG": "Muuga",
  "port.RIG": "Riga",
  "port.STO": "Stockholm",
  "port.TAL": "Tallinn",
  "port.TUR": "Turku",
  "port.VIS": "Visby",
  "port.VSS": "Vuosaari",
  "port.SPE": "St. Petersburg",
  "port.SAS": "Sassnitz",
  "port.SMA": "Saaremaa",
  "port.VNT": "Ventspils",
  "port.HND": "Härnösand",
  "button.edit": "Edit",
  "guests": "passengers",
  "vehicles": "Vehicles",
  "date": "Date",
  "travelClass.title": "Travel class",
  "giftCard": "Gift Card",
  "SIGN_IN": "Sign In",
  "button.book.a.trip": "Book a trip",
  "price.total": "Total",
  "clubOne.points.price": "and {{count}} points",
  "error.title": "Error",
  "button.close": "Close",
  "calendar.choose.date": "Choose the date",
  "itinerary.miniCruise": "5h cruise",
  "TAL-HEL.CRUISE": "9h cruise",
  "timetable.oneWay": "One way",
  "timetable.roundtrip": "Roundtrip",
  "button.done": "Done",
  "pets": "pets",
  "label.see.details": "See details",
  "common.language.KO": "Korean",
  "common.language.ZH": "Chinese",
  "common.language.JA": "Japanese",
  "header.chooseYourLanguage": "Choose your language",
  "pageNotFound.title": "We tried to find it, we really did...",
  "pageNotFound.subtitle": "Unfortunately the page you are looking for is nowhere to be found.",
  "goBack": "Go back",
  "label.info": "Info",
  "itinerary.title": "Trip details",
  "itinerary.description": "Lorem ipsum dolor sit amet",
  "extraServices.button.soldOut": "Sold out",
  "button.cancel": "Cancel",
  "abbreviation.hour": "{{hour}}h",
  "cruise": "Cruise",
  "HEL-TAL.CRUISE": "22h cruise",
  "form.error.required": "Value is required",
  "form.error.min": "Minimum allowed value is {{min}}",
  "form.error.max": "Maximum allowed value is {{max}}",
  "form.error.minLength": "Minimum allowed length is {{minLength}}",
  "form.error.maxLength": "Maximum allowed length is {{maxLength}}",
  "sailLeg.sailTime": "{{date, eee', <b>'dd.MM' at <br>'HH:mm'</b>'}}",
  "timetable.tripTypeAndDeparture": "Trip type & departure",
  "timetable.calendar": "Calendar",
  "timetable.table.departureAndArrival": "Departure & arrival",
  "timetable.table.duration": "Duration",
  "timetable.table.vessel": "Vessel",
  "clubOne.slider.label": "Use available Club One points",
  "button.proceed": "Proceed",
  "label.loading": "Loading",
  "sailLeg.sailTime.short": "{{date, '<b>'dd.MM'</b> at <b>'HH:mm'</b>'}}",
  "clubOne.slider.description": "Maximum points you can use are calculated dynamically and based on items and services in your booking.",
  "specialCruise": "Special cruise",
  "cabin": "cabin",
  "lounges": "lounges",
  "cabins": "cabins",
  "specialCabins": "special cabins",
  "specialCabin.tag.handicap": "Accessible",
  "specialCabin.tag.allergy": "Allergy-friendly",
  "voucher": "Voucher",
  "serialTicket": "Serial ticket",
  "summary": "Summary",
  "contact": "Contact",
  "booking": "Booking",
  "payment": "Payment",
  "free": "Free",
  "guest": "passenger",
  "guest.count": "{count, plural, =0 {# passengers} =1 {# passenger} other {# passengers}}",
  "cabin.count": "{count, plural, =0 {# cabins} =1 {# cabin} other {# cabins}}",
  "form.firstName": "First name",
  "form.lastName": "Last name",
  "CO.number": "Club One number",
  "dateOfBirth": "Date of birth",
  "gender": "Gender",
  "guest.details": "Passenger details",
  "nationality": "Nationality",
  "specialAssistance": "Special assistance",
  "payButton": "Pay",
  "loading": "Please wait...",
  "male": "Male",
  "female": "Female",
  "citizenship.estonian": "Estonian",
  "notRequired": "Not required",
  "ELECTRIC WHEELCHAIR": "Electric wheelchair",
  "VISUALLY IMPAIRED": "Visual impairment",
  "HEARING IMPAIRED": "Hearing impairment",
  "OTHER REASON FOR ASSISTANCE": "Other",
  "GUIDEDOG": "With guide dog",
  "WHEELCHAIR": "With wheelchair",
  "button.ok": "OK",
  "errorPage.title": "An error occured!",
  "form.error.email": "Email is invalid",
  "form.error.positiveInteger": "Only numbers allowed",
  "form.error.date": "Date is invalid",
  "form.error.name": "Name should only contain latin characters",
  "form.error.clubOne": "Club One number is invalid",
  "clubOneApplied": "Club One applied",
  "form.signInToUseYourBonusPoints": "Club One account successfully added. <clickable>Sign in</clickable> to use your bonus points when paying.",
  "optional": "Optional",
  "form.error.positiveFloat": "Only numbers or decimal values allowed",
  "AD": "Andorra",
  "AE": "United Arab Emirates",
  "AF": "Afghanistan",
  "AG": "Antigua And Barbuda",
  "AI": "Anguilla",
  "AL": "Albania",
  "AM": "Armenia",
  "AN": "Netherland Antilles",
  "AO": "Angola",
  "AQ": "Antarctica",
  "AR": "Argentina",
  "AS": "American Samoa",
  "AT": "Austria",
  "AU": "Australia",
  "AW": "Aruba",
  "AZ": "Azerbaijan",
  "BA": "Bosnia Hercegovina",
  "BB": "Barbados",
  "BD": "Bangladesh",
  "BE": "Belgium",
  "BF": "Burkina Faso",
  "BG": "Bulgaria",
  "BH": "Bahrain",
  "BI": "Burundi",
  "BJ": "Benin",
  "BM": "Bermuda",
  "BN": "Brunei Darussalam",
  "BO": "Bolivia",
  "BR": "Brazil",
  "BS": "Bahamas",
  "BT": "Bhutan",
  "BW": "Botswana",
  "BY": "Belarus",
  "BZ": "Belize",
  "CA": "Canada",
  "CC": "Cocos (Keeling) Islands",
  "CD": "Congo, Democratic Republic Of",
  "CF": "Central African Republic",
  "CG": "Congo",
  "CH": "Switzerland",
  "CI": "Cote D'Ivoire",
  "CK": "Cook Islands",
  "CL": "Chile",
  "CM": "Cameroon",
  "CN": "China",
  "CO": "Colombia",
  "CR": "Costa Rica",
  "CS": "Serbia",
  "CU": "Cuba",
  "CV": "Cape Verde",
  "CX": "Christmas Islands",
  "CY": "Cyprus",
  "CZ": "Czech Republic",
  "DE": "Germany",
  "DJ": "Djibouti",
  "DK": "Denmark",
  "DM": "Dominica",
  "DO": "Dominican Republic",
  "DZ": "Algeria",
  "EC": "Ecuador",
  "EE": "Estonia",
  "EG": "Egypt",
  "EH": "Western Sahara",
  "ER": "Eritrea",
  "ES": "Spain",
  "ET": "Ethiopia",
  "FI": "Finland",
  "FJ": "Fiji",
  "FK": "Falkland Islands (Malvinas)",
  "FM": "Federal States Of Micronesia",
  "FO": "Faroe Islands",
  "FR": "France",
  "GA": "Gabon",
  "GB": "United Kingdom",
  "GD": "Grenada",
  "GE": "Georgia",
  "GF": "French Guiana",
  "GH": "Ghana",
  "GI": "Gibraltar",
  "GL": "Greenland",
  "GM": "Gambia",
  "GN": "Guinea",
  "GP": "Guadeloupe",
  "GQ": "Equatorial Guinea",
  "GR": "Greece",
  "GS": "South Georgia And South Sandwich Islands",
  "GT": "Guatemala",
  "GU": "Guam",
  "GW": "Guinea-Bissau",
  "GY": "Guyana",
  "GZ": "Gaza Strip",
  "HK": "Hong Kong",
  "HM": "Heard And Mcdonald Islands",
  "HN": "Honduras",
  "HR": "Croatia",
  "HT": "Haiti",
  "HU": "Hungary",
  "ID": "Indonesia",
  "IE": "Ireland",
  "IL": "Israel",
  "IN": "India",
  "IO": "Indian Ocean Territory",
  "IQ": "Iraq",
  "IR": "Iran, Islamic Republic Of",
  "IS": "Iceland",
  "IT": "Italy",
  "JM": "Jamaica",
  "JO": "Jordan",
  "JP": "Japan",
  "KE": "Kenya",
  "KG": "Kyrgyzstan",
  "KH": "Cambodia",
  "KI": "Kiribati",
  "KM": "Comoros",
  "KN": "Saint Kitts - Nevis",
  "KP": "Korea, Dem. People's Republic Of (North)",
  "KR": "Korea, Republic Of (South)",
  "KW": "Kuwait",
  "KY": "Cayman Islands",
  "KZ": "Kazakstan",
  "LA": "Lao People's Democratic Republic",
  "LB": "Lebanon",
  "LC": "Saint Lucia",
  "LI": "Liechtenstein",
  "LK": "Sri Lanka",
  "LR": "Liberia",
  "LS": "Lesotho",
  "LT": "Lithuania",
  "LU": "Luxembourg",
  "LV": "Latvia",
  "LY": "Libyan Arab Jamahiriya",
  "MA": "Morocco",
  "MC": "Monaco",
  "MD": "Moldova",
  "ME": "Montenegro",
  "MG": "Madagascar",
  "MH": "Marshall Islands",
  "MK": "Macedonia, F.Y.R.",
  "ML": "Mali",
  "MM": "Myanmar (Former Burma)",
  "MN": "Mongolia",
  "MO": "Macau",
  "MP": "Northern Marianas",
  "MQ": "Martinique",
  "MR": "Mauritania",
  "MS": "Montserrat",
  "MT": "Malta",
  "MU": "Mauritius",
  "MV": "Maldives",
  "MW": "Malawi",
  "MX": "Mexico",
  "MY": "Malaysia",
  "MZ": "Mozambique",
  "NC": "New Caledonia",
  "NE": "Niger",
  "NF": "Norfolk Island",
  "NG": "Nigeria",
  "NI": "Nicaragua",
  "NL": "Netherlands",
  "NO": "Norway",
  "NP": "Nepal",
  "NR": "Nauru",
  "NU": "Niue",
  "NZ": "New Zealand",
  "OM": "Oman",
  "OT": "Other",
  "PA": "Panama",
  "PE": "Peru",
  "PF": "French Polynesia",
  "PG": "Papua New Guinea",
  "PH": "Philippines",
  "PK": "Pakistan",
  "PL": "Poland",
  "PM": "St. Pierre And Miquelon",
  "PN": "Pitcairn Island",
  "PR": "Puerto Rico",
  "PS": "Palestina",
  "PT": "Portugal",
  "PW": "Palau",
  "PY": "Paraguay",
  "QA": "Qatar",
  "RE": "Reunion",
  "RO": "Romania",
  "RS": "Serbia",
  "RU": "Russian Federation",
  "RW": "Rwanda",
  "SA": "Saudi Arabia",
  "SB": "Solomon Islands",
  "SC": "Seychelles",
  "SD": "Sudan",
  "SE": "Sweden",
  "SG": "Singapore",
  "SH": "St. Helena",
  "SI": "Slovenia",
  "SJ": "Svalbard And Jan Mayen",
  "SK": "Slovakia",
  "SL": "Sierra Leone",
  "SM": "San Marino",
  "SN": "Senegal",
  "SO": "Somalia",
  "SR": "Suriname",
  "ST": "Sao Tome And Principe",
  "SV": "El Salvador",
  "SY": "Syrian Arab Republic",
  "SZ": "Swaziland",
  "TA": "Tahiti",
  "TC": "Turks And Caicos Islands",
  "TD": "Chad",
  "TF": "French Southern & Antarctic Lands",
  "TG": "Togo",
  "TH": "Thailand",
  "TJ": "Tajikistan",
  "TK": "Tokelau",
  "TL": "East Timor",
  "TM": "Turkmenistan",
  "TN": "Tunisia",
  "TO": "Tonga",
  "TR": "Turkey",
  "TT": "Trinidad And Tobago",
  "TV": "Tuvalu",
  "TW": "Taiwan",
  "TZ": "Tanzania, United Republic Of",
  "UA": "Ukraine",
  "UG": "Uganda",
  "UM": "United States Minor Outlying Islands",
  "US": "United States",
  "UY": "Uruguay",
  "UZ": "Uzbekistan",
  "VA": "Vatican City State (Holy See)",
  "VC": "Saint Vincent And The Grenadines",
  "VE": "Venezuela",
  "VG": "British Virgin Islands",
  "VI": "United States Virgin Islands",
  "VN": "Vietnam",
  "VU": "Vanuatu",
  "WE": "West Bank",
  "WF": "Wallis And Futuna Islands",
  "WS": "Samoa",
  "XK": "Kosovo",
  "XZ": "Undefinded",
  "YE": "Yemen",
  "YT": "Mayotte",
  "YU": "Yugoslavia, Federal Republic Of",
  "ZA": "South Africa",
  "ZM": "Zambia",
  "ZR": "Zaire = Congo Dem.",
  "ZW": "Zimbabwe",
  "ZZ": "undefinded",
  "reservationFee": "Reservation fee",
  "reserveTable": "Reserve table",
  "reserved": "Reserved",
  "footer.copyright": "© AS Tallink Grupp {{year}}",
  "button.changeBooking": "Change booking",
  "payment.unsuccessful.callCenter": "Call support <b><a href=\"tel:+372 640 9804\">+372 640 9804</a></b> is open Mon- Fri 09:00 - 18:00",
  "payment.klarnaAndSwish.title": "Klarna & Swish",
  "payment.klarna.description": "Invoice, part payment",
  "payment.onlineBank.title": "Online bank",
  "payment.onlineBankAndCards.title": "Online bank & Debit/credit card",
  "payment.cards.title": "Debit/credit card",
  "payment.onlineBanks.title": "Bank",
  "payment.BANK.description": "Banks",
  "payment.MOBILE_PAY.description": "MobilePay",
  "payment.GOOGLE_PAY.description": "Google Pay",
  "payment.APPLE_PAY.description": "Apple Pay",
  "payment.onlineBanks.description": "All local banks",
  "errorPage.description": "There was an error. Please reload your page. Please note! After reloading the page all selected data will be lost. If problem still appears, please contact Tallink Silja customer service by email <a href=\"mailto:international.sales@tallinksilja.com\">international.sales@tallinksilja.com</a> or contact us here",
  "payment.CARD.description": "Cards",
  "SERIAL COMFORT": "Comfort Lounge traveller tickets",
  "SERIAL PASSENGER": "Star Class traveller tickets",
  "SERIAL BUSINESS": "Business Lounge traveller tickets",
  "SERIAL CAR/CAR XL": "Car tickets",
  "SERIAL VAN": "Van tickets",
  "available.codes": "Available codes",
  "used.codes": "Used codes",
  "ticket.expiry.notice": "Following tickets expire on",
  "vehicle.type.extra-long-and-high.title": "Car with trailer",
  "accessibility": "Accessibility",
  "cancelCover": "Cancel Cover",
  "clubOneDiscount": "Club One discount",
  "button.payNow": "Pay now",
  "button.joinClubOne": "Join Club One",
  "price.toBePaid": "To be paid",
  "price.subtotal": "Subtotal",
  "price.alreadyPaid": "Already paid",
  "copy.coupon.to.clipboard.accessibility.label": "Copy coupon code to clipboard",
  "price.chargeFee": "Booking change fee",
  "expired.codes": "Expired codes",
  "button.buy.cta": "Buy serial tickets",
  "no.codes.available": "You have no codes available to use",
  "accessibility.icon.aria-label": "Read our accessibility statement",
  "pet.count": "{count, plural, =0 {# pets} =1 {# pet} other {# pets}}",
  "accessibility.url": "https://www.tallink.com/en/accessibility",
  "aLaCarteVoucher.withValue": "{{value}} À la carte voucher",
  "timeOfDay": "{{date, HH:mm}}",
  "dayWithTimeOfDay": "{{date, eee' at 'HH:mm }}",
  "aLaCarteVoucher": "À la carte voucher",
  "ticket.expired": "Tickets expired on",
  "tooltip.accessibility.label": "Open tooltip",
  "couponPage.login.cta": "To see purchased serial tickets, please <login>log in</login>.",
  "button.downloadFile": "Download file ({{extension}})"
} },
et: { translation: {
  "common.buyTickets": "Osta piletid",
  "common.cancel": "Tühista",
  "common.done": "Valmis",
  "common.ok": "Logi välja",
  "clubOne.level": "Club One {{level}}",
  "clubOne.points.points": "p.",
  "clubOne.points.hint": "Club One punkte saate kasutada boonusreisi eest tasumiseks",
  "clubOne.switchToCompanyCustomer.warning": "Sind logitakse välja",
  "clubOne.switchToCompanyCustomer.title": "Osta pilet ärikliendina",
  "clubOne.loginLink": "Logi sisse Club One'i numbriga",
  "clubOne.title": "Club One' klient",
  "companyCustomer.agentId": "Kliendikood",
  "companyCustomer.agentId.error": "Kliendikoodi ei leitud",
  "companyCustomer.agentId.pattern": "",
  "companyCustomer.error": "Sisestatud kliendikood ei ole õige",
  "companyCustomer.id": "Kliendikood",
  "companyCustomer.login": "Logi sisse",
  "companyCustomer.title": "Äriklient",
  "deliveryDetails.clubOneAnonymous.text": "Piletid saadetakse allolevale e-posti aadressile.",
  "deliveryDetails.clubOneLogged.text": "Piletid saadetakse allolevale e-posti aadressile.",
  "deliveryDetails.companyCustomerAnonymous.text": "Piletid saadetakse allolevale e-posti aadressile. ",
  "deliveryDetails.companyCustomerLogged.text": "Piletid saadetakse allolevale e-posti aadressile. ",
  "deliveryDetails.form.email.label": "E-posti aadress",
  "deliveryDetails.form.error.emailPattern": "E-posti aadress ei ole korrektne.",
  "deliveryDetails.form.error.namePattern": "Nime kirjutamiseks saad kasutada tähti, ' ja - märke.",
  "deliveryDetails.form.error.required": "Selle välja täitmine on kohustuslik.",
  "deliveryDetails.form.firstName.label": "Eesnimi",
  "deliveryDetails.form.lastName.label": "Perekonnanimi",
  "deliveryDetails.title": "Tellimuse info",
  "description.passenger": "Üks reisija seeriapilet kehtib ühe reisija ühesuunareisile.",
  "description.vehicle": "Üks sõiduki seeriapilet kehtib ühe sõiduki ühesuunareisile ega sisalda reisijapiletit.",
  "hero.mainTitle": "Seeriapiletid",
  "hero.subtitle": "Üks seeriapilet võimaldab ühele reisijale/sõidukile ühesuunareisi valitud suunal.",
  "hint.clubOne.error": "Sisselogimine ebaõnnestus, palun proovi uuesti või jätka sisselogimata. Vabandame ebamugavuste pärast.",
  "hint.clubOne.text": "Club One'i liikmena kehtivad Sulle alati parimad pakkumised ja kogud boonuspunkte, mida saad kasutada uute reiside ostmiseks. <a href=\"https://www.tallink.ee/et/club-one\" target=\"_blank\">Loe lisaks ja liitu Club One'i programmiga.</a>",
  "mainPage.title": "Seeriapiletid",
  "mobile.back": "← Tagasi",
  "mobile.done": "Jätka",
  "price.description": "Piletid",
  "price.amount": "Kogus",
  "price.discount": "Soodushind",
  "price.price": "Hind",
  "price.regular": "Tavahind",
  "price.giftCard": "Kinkekaart",
  "serialTicketName.passenger.business": "reisijapilet Business Lounge’is",
  "serialTicketName.passenger.comfort": "reisijapilet Comfort Lounge'is",
  "serialTicketName.passenger.star": "reisijapilet Star Classi'is",
  "serialTicketName.vehicle.CAR": "pilet sõiduautole \n(kuni ↔5 m ↕1,9 m)",
  "serialTicketName.vehicle.CAR XL": "pilet sõiduautole \n(kuni ↔5,5 m ↕2,4 m)",
  "serialTicketName.vehicle.VAN": "pilet sõiduautole \n(kuni ↔7 m ↕2,4 m)",
  "signIn.button": "Logi sisse",
  "signOut.link": "Logi välja →",
  "signInWithCompanyId.link": "Logi sisse ärikliendina →",
  "srt.termsAndConditions.title": "Tallinki seeriapiletite tingimused",
  "termsAndConditions.text": "<li>Seeriapiletid kehtivad, kas 8’le, 14’le või 24’le Tallinn-Helsingi või Helsingi-Tallinn ühesuunareisile.</li>\n<li>Seeriapiletid kehtivad kõikidele Tallinn-Helsingi või Helsingi-Tallinn suundadele.</li>\n<li>Seeriapiletid ei ole isikustatud, mis tähendab, et neid võib jagada nii sõprade, pere kui ka kolleegidega.</li>\n<li>Üks reisija seeriapilet kehtib ühe reisija ühesuunareisile.</li>\n<li>Üks sõiduki seeriapilet kehtib ühe sõiduki ühesuunareisile ega sisalda reisijapiletit.</li>\n<li>Seeriapiletid kehtivad üks aasta.</li>\n<li>Seeriapiletid on müügil Tallinki müügiesindustes, kõnekeskuses ja veebis.</li>\n<li>Seeriapiletiga saad reisi osta Tallinki müügiesindustes, kõnekeskuses ja veebis.</li>\n<li>Veebis saad ühes broneeringus kasutada kuni kuut seeriapiletit.</li>\n<li>Veebilehel broneerides kehtib seeriapilet alati esimesele suunale, reisijale ja autole.</li>\n<li>Seeriapiletiga tasutud pileti muutmisel ei kohaldata leppetrahvi ja piletit võid muuta kuni reisile registreerimise (<i>check-in’i</i>) lõpuni.</li>\n",
  "type.passenger": "Reisijapiletid",
  "type.vehicle": "Sõidukipiletid",
  "voucherPanel.header": "Kinkekaardid",
  "voucherPanel.link.addAnotherVoucher": "+ Lisa uus kood",
  "voucherPanel.link.addVoucher": "Mul on sooduskood või kinkekaart",
  "voucherPanel.voucher.button.add": "Lisa",
  "voucherPanel.voucher.hint": "Kinkekaarti on võimalik kasutada mitmel ostul kuni kaardil olevate vahendite lõppemiseni.<br>\nKinkekaardil on <b>{{amountLeft}} €</b>.<br>\nKinkekaart on kehtiv kuni <b>{{expirationDate}}</b>.",
  "voucherPanel.voucher.label": "Kinkekaardikood",
  "voucherPanel.voucher.validate.callToCallCenter": "Kinkekaarti saab kasutada helistades numbril +372 640 9804",
  "voucherPanel.voucher.validate.error": "Kontrolli sisestatud koodi",
  "payment.unsuccessful.description": "Makseprotsessis läks midagi valesti. Veendu, et tellimuse vormistamiseks on piisavalt vahendeid, ja proovi uuesti.",
  "payment.unsuccessful.title": "Makse ebaõnnestus",
  "payment.cancelled.title": "Tellimuse eest ei ole makstud",
  "payment.title": "Maksevahendid",
  "payment.paymentServiceMethods.title": "Kaardid",
  "payment.paymentServiceMethods.combined.title": "Pangad / Kaardid",
  "payment.disclaimer": "Kui vajutad maksmise nuppu, nõustud  <a href=\"https://www.tallink.ee/et/reisitingimused-uksikreisijatele\" target=\"_blank\">Tallinki makse- ja annulleerimistingimuste</a>, <a href=\"https://ee.tallink.com/privaatsuspoliitika\" target=\"_blank\">privaatsuspoliitika</a> ning <a href=\"https://ee.tallink.com/et/turvalisus\" target=\"_blank\">turvaeeskirjadega</a>.Oled noorem kui 18? <a href=\"https://www.tallink.ee/et/vanusepiirangud\" target=\"_blank\">Tutvu meie laevade vanusepiirangutega</a>.",
  "payment.disclaimer.Extra.TallinkGrupp": "Kui vajutad maksmise nuppu, nõustud  <a href=\"https://www.tallink.ee/et/reisitingimused-uksikreisijatele\" target=\"_blank\">Tallinki makse- ja annulleerimistingimuste</a>, <a href=\"https://ee.tallink.com/privaatsuspoliitika\" target=\"_blank\">privaatsuspoliitika</a> ning <a href=\"https://ee.tallink.com/et/turvalisus\" target=\"_blank\">turvaeeskirjadega</a>. Oled noorem kui 18? <a href=\"https://www.tallink.ee/et/vanusepiirangud\" target=\"_blank\">Tutvu meie laevade vanusepiirangutega</a>.<br>\nSulle pakutavate reisiteenuste kogum on pakettreis direktiivi (EL) 2015/2302 tähenduses.<br>\nSeetõttu on Sul kõik õigused, mis reisijal on ELi õiguse järgi pakettreisi korral. Ettevõtja AS Tallink Grupp vastutab täielikult pakettreisi kui terviku teenuste nõuetekohase osutamise eest.<br>\nLisaks sellele on seaduse alusel nõutav, et ettevõtjal AS Tallink Grupp on tagatis, et maksta, kui ta ei suuda maksevõime tõttu oma kohustusi täita, tagasi Sinu tehtud maksed ja kui pakettreis sisaldab reisijavedu, tagada Sinu tagasisõit lähtekohta või muusse kokkulepitud kohta.<br>\n<a href=\"https://www.tallink.ee/et/pakettreisi-teabeleht-tallink-grupp\" target=\"_blank\">Vaata pakettreisi tingimusi</a>.",
  "payment.disclaimer.Extra.TallinkSiljaOY": "Kui vajutad maksmise nuppu, nõustud  <a href=\"https://www.tallink.ee/et/reisitingimused-uksikreisijatele\" target=\"_blank\">Tallinki makse- ja annulleerimistingimuste</a>, <a href=\"https://ee.tallink.com/privaatsuspoliitika\" target=\"_blank\">privaatsuspoliitika</a> ning <a href=\"https://ee.tallink.com/et/turvalisus\" target=\"_blank\">turvaeeskirjadega</a>. Oled noorem kui 18? <a href=\"https://www.tallink.ee/et/vanusepiirangud\" target=\"_blank\">Tutvu meie laevade vanusepiirangutega</a>.<br>\nSulle pakutavate reisiteenuste kogum on pakettreis direktiivi (EL) 2015/2302 tähenduses.<br>\nSeetõttu on Sul kõik õigused, mis reisijal on ELi õiguse järgi pakettreisi korral. Ettevõtja Tallink Silja Oy vastutab täielikult pakettreisi kui terviku teenuste nõuetekohase osutamise eest.<br>\nLisaks sellele on seaduse alusel nõutav, et ettevõtjal Tallink Silja Oy on tagatis, et maksta, kui ta ei suuda maksevõime tõttu oma kohustusi täita, tagasi Sinu tehtud maksed ja kui pakettreis sisaldab reisijavedu, tagada Sinu tagasisõit lähtekohta või muusse kokkulepitud kohta.<br>\n<a href=\"https://ee.tallink.com/et/pakettreisi-teabeleht-tallink-silja\" target=\"_blank\">Vaata pakettreisi tingimusi</a>.",
  "passengerDistribution.errors.WITHOUT_ADULT": "Kajutis peab olema vähemalt üks täiskasvanud reisija",
  "passengerDistribution.errors.WITHOUT_CABIN": "Lisa veel {nrOfPassengersWithoutCabin} {nrOfPassengersWithoutCabin, plural, =0{reisijat} one{reisija} other{reisijat}} kajutitesse.",
  "passengerDistribution.notification.childWithoutOwnBed": "Laps ilma oma voodikohata.",
  "payment.klarna.title": "Klarna",
  "payment.onlineBanks.list.aktia": "Aktia",
  "payment.onlineBanks.list.alandsbanken": "Ålandsbanken",
  "payment.onlineBanks.list.coop": "COOP Pank",
  "payment.onlineBanks.list.danskebankEE": "Danske Bank",
  "payment.onlineBanks.list.danskebankFI": "Danske Bank",
  "payment.onlineBanks.list.handelsbanken": "Handelsbanken",
  "payment.onlineBanks.list.kultaraha": "Osuuspankki",
  "payment.onlineBanks.list.lahitapiola": "LähiTapiola",
  "payment.onlineBanks.list.lhv": "LHV",
  "payment.onlineBanks.list.luminor": "Luminor",
  "payment.onlineBanks.list.nordea": "Nordea",
  "payment.onlineBanks.list.saastopankki": "Säästöpankki",
  "payment.onlineBanks.list.seb": "SEB",
  "payment.onlineBanks.list.spankki": "S-Pankki",
  "payment.onlineBanks.list.swedbank": "Swedbank",
  "payment.invoice.title": "Maksevõimalused",
  "payment.type.invoice": "Maksan arvega",
  "payment.reference.title": "Viitenumber",
  "payment.reference.disclaimer": "Kui vajutad maksmise nuppu, nõustud  <a href=\"https://www.tallink.ee/et/reisitingimused-uksikreisijatele\" target=\"_blank\">Tallinki makse- ja annulleerimistingimuste</a>, <a href=\"https://ee.tallink.com/privaatsuspoliitika\" target=\"_blank\">privaatsuspoliitika</a> ning <a href=\"https://ee.tallink.com/et/turvalisus\" target=\"_blank\">turvaeeskirjadega</a>.",
  "payment.type.card": "Maksan ülekandega",
  "payment.klarna.options.title": "Maksmisvõimalused olenevad Sinu broneeringust. Kõige levinumad võimlused on: ",
  "payment.klarna.options.list": "<li>Faktura</li><li>Delbetala</li>",
  "payment.klarna.policy": "Broneeringut kinnitades nõustud, et Sinu broneeringu andmed saadetakse Klarnasse. Lugege rohkem Klarnast <a href=\"https://cdn.klarna.com/1.0/shared/content/policy/data/en_fi/privacy_statement.pdf\" target=\"_blank\">siit</a>.",
  "payment.klarna.mobile.title": "Soorita Klarna makse kergelt ja turvaliselt otse mobiilist.",
  "paymentPage.total": "Kokku",
  "paymentPage.confirm.freeReservation": "Kinnita tellimus",
  "paymentPage.confirm.onlyPayment": "Maksa",
  "paymentPage.confirm.onlyPayment.withInvoice": "Kinnita",
  "confirmation.thankYouCallout.title": "Täname Sind ostu eest!",
  "confirmation.thankYouCallout.paidTotal": "Kokku makstud",
  "confirmation.thankYouCallout.message": "Makse õnnestus ja Sinu tellimus on kinnitatud. Kinnituskiri saadetud aadressile {{email}}.",
  "confirmation.orderConfirmation": "",
  "confirmation.summary.downloadPdf": "Laadi PDF alla",
  "confirmation.summary.bookTrip": "Broneeri reis",
  "confirmation.summary.disclaimer": "Oma ostu saad kohe kasutada. Broneeri reis!",
  "confirmation.summary.email": "E-mail aadress",
  "confirmation.summary.contactPerson": "Kontaktisik",
  "confirmation.summary.securityCode": "Turvakood",
  "confirmation.summary.orderNumber": "Tellimuse number",
  "otherPaymentMethod": "Muu makseviis",
  "paymentMethod": "Makseviis",
  "remove": "Eemalda",
  "answer.yes": "Jah",
  "answer.no": "Ei",
  "button.send": "Saada",
  "button.withoutPrice.notChosen": "Vali",
  "button.withoutPrice.chosen": "Valitud",
  "button.add": "Lisa",
  "clubOne.level.BRONZE": "Pronks",
  "clubOne.level.SILVER": "Hõbe",
  "clubOne.level.GOLD": "Kuld",
  "clubOne.level.title": "Club One",
  "currency.EUR": "€",
  "currency.LAT": "Ls",
  "currency.LVL": "Ls",
  "currency.RUB": "€",
  "currency.SEK": "kr",
  "dateFormat.dayOfWeekDayMonthAndTime": "{weekday} <b>{date}</b> kell <b>{time}</b>",
  "decimalSeparator": ",",
  "details.dayMonthAndTime.pattern": "d.m. k\\\\l H:i",
  "details.dayOfWeek.pattern": "l",
  "entertainment.title": "Meelelahutus laeval",
  "entertainment.sitting": "Istekoht",
  "error.chromeframe.label": "Või lisage olemasolevale internetilehitsejale Google'i",
  "entertainment.sittingGroup.premium.name\r\n": "Premium-istekohad",
  "entertainment.sittingGroup.premium.description": "Premium-istekohad sisaldavad toite ja on parimad etenduse vaatamiseks!",
  "entertainment.sittingGroup.basic.name\r\n": "Piiratud istekohad",
  "entertainment.sittingGroup.basic.description": "Tavaistekohtadelt on lavale piiratud vaade.",
  "entertainment.sittingGroup.basic.addOn.name\r\n": "Lavale piiratud vaatega istekoht",
  "error.chromeframe.link": "Chrome Frame'i täiendus",
  "error.ie": "Kasutad Internet Exploreri vana versiooni. Tallink Silja Line'i veebi broneerimissüsteem ei toeta antud internetilehitsejat. Soovitame vahetada see uuema ja kiirema vastu. Valik tasuta lehitsejaid:",
  "error.notPossibleToChangeBookingOnline": "Kahjuks ei saa antud broneeringut veebikeskkonnas muuta.<br><br>Vajadusel palun võta ühendust meie klienditeenindusega telefonil +372 640 9804. Välismaalt helistades +372 640 9808.",
  "form.email": "E-post",
  "form.phone": "Telefon",
  "format.LocalDayMonth": "{{date, d.M}}",
  "format.LocalShortWeekdayAndDayMonth": "D d.m.",
  "format.LocalLongWeekdayAndDayMonth": "l d.m.",
  "format.LocalShortWeekdayAndShortMonth": "D. MMM",
  "format.LocalDayMonthYear": "d.m.Y",
  "header.bookingNumber": "Broneeringu number",
  "header.logout": "Logi välja",
  "header.myBooking": "Minu broneering",
  "header.pin": "Turvakood",
  "hotel.checkInTime": "Sisseregistreerimine",
  "hotel.checkOutTime": "Väljaregistreerimine",
  "nights": "ööd",
  "night": "öö",
  "hotelsItinerary.returnTripIsNotAvailable": "Tagasisuund on välja müüdud. Palun muuda hotellibroneeringut",
  "label.remove": "Eemalda",
  "landServices.title": "Tegevused maal",
  "landService.ageCategory.base": "Tavapilet",
  "landService.ageCategory.child": "Lapsed {ageCategory} a",
  "landService.dateTime.pattern": "d.m.Y",
  "meals.packages.choosePackage": "Vali toidupakett",
  "meals.packages.title": "Osta toidupakett ja säästa raha",
  "meals.packages.commonInfo": "Toidupakett sisaldab toite kogu reisi ajaks.",
  "meals.packages.description": "Lapsed saavad soodustust ja alla 6-aastased lapsed söövad tasuta, kui lapsevanem on ostnud toidupaketi.<br>Kui kõik kohad restoranis on välja müüdud lisatakse broneeringule sama väärtusega kupong, millega võib tasuda toidu eest ka kõikides teistes laeva restoranides.",
  "meals.button.freeMealPackages": "Sisaldub hinnas",
  "meals.selectionMealBlockedByTime": "Toitude eelmüük on lõppenud. Vabade kohtade olemasolul saad toidud osta laevast.",
  "onboardServices.title": "Lisateenused laeval",
  "adults": "täiskasvanud",
  "adult": "täiskasvanu",
  "child": "laps",
  "junior": "Juunior",
  "youth": "Noored",
  "children": "lapsed",
  "guests.edit.accessibility.label": "Reisijate andmed",
  "pier.DTER.address": "Lootsi 13, 10151 Tallinn",
  "pier.DTER.title": "D-Terminal",
  "pier.FHAM.address": "Frihamnen, Magasin 2, 10253 Stockholm",
  "pier.FHAM.title": "Frihamnen",
  "pier.HND.title": "Härnösand",
  "pier.HND.address": "Skeppsbron 31, 871 80 Härnösand",
  "pier.LNAS.address": "Långnäsi terminal, Lumparland",
  "pier.LNAS.title": "Långnäs",
  "pier.LSA2.address": "Läänesadam, Helsingi",
  "pier.LSA2.title": "Läänesadam 2",
  "pier.LSA6.address": "Tyynenmerenkatu 8, 00220 Helsingi",
  "pier.LSA6.title": "Läänesadam 1",
  "pier.LSAT.address": "Tyynenmerenkatu 8, 00220 Helsingi",
  "pier.LSAT.title": "Läänesadam 1",
  "pier.MHAM.address": "Västra hamnen, Mariehamn",
  "pier.MHAM.title": "Mariehamn",
  "pier.MUUG.address": "Muuga sadam, Maardu Tee 65, Maardu",
  "pier.MUUG.title": "Muuga sadam",
  "pier.OLYM.address": "Olympiaranta 1, 00140 Helsingi",
  "pier.OLYM.title": "Olympia terminal",
  "pier.PALD.address": "Rae põik 10, EE-76806 Paldiski",
  "pier.PALD.title": "Paldiski",
  "pier.KAPE.address": "Hamnterminalen, 760 15 Gräddö",
  "pier.KAPE.title": "Kapellskär",
  "pier.RIGA.address": "3a Eksporta Str. Riga, LV-1010",
  "pier.RIGA.title": "Riia terminal",
  "pier.TSAT.address": "Linnankatu 91, FIN-20100 Turu",
  "pier.TSAT.title": "Turu sadam",
  "pier.VHAM.address": "Hamnpirsvägen 10, 11574 Stockholm",
  "pier.VHAM.title": "Värtahamnen",
  "pier.VISH.title": "Visby",
  "pier.VISH.address": "Färjeleden 2, 621 81 Visby",
  "pier.VSAA.address": "Vuosaari, Seilorinkatu 5, Helsingi",
  "pier.VSAA.title": "Vuosaari sadam",
  "pier.MFAC.address": "Bereg Nevskoy gubi 1., V.O., St. Petersburg",
  "pier.MFAC.title": "Peterburi",
  "pier.SAS.title": "Sassnitz",
  "pier.SMA1.title": "Saaremaa",
  "pier.SMA1.address": "Ninase küla, Mustjala vald, 93631, Saaremaa",
  "pier.KLJ1.title": "Klaipeda",
  "pier.KLJ1.address": "J.Zauerveino str. 18, LT-92122 Klaipeda, Leedu",
  "port.KAP": "Kapellskär",
  "port.PAL": "Paldiski",
  "port.KLJ": "Klaipeda",
  "port.YST": "Ystad",
  "port.PARTY": "Läänemeri",
  "refresh": "Värskenda lehte",
  "reservation.travelPermitForYouth": "15–17-aastasena võid reisida üksi päevasel ühesuunareisil või päevareisil. Kindlasti võta kaasa <a target=\"_blank\" href=https://ee.tallink.com/documents/10192/65371006/Permission_to_travel_alone_15_17_EN.pdf/7a0c8141-c394-42b5-a6db-29469450ddc6>reisiluba</a>. Turvalist reisi.",
  "send.email.failed": "E-posti saatmine ebaõnnestus. Palun proovi uuesti.",
  "send.sms.failed": "SMS-i saatmine ebaõnnestus. Palun proovi uuesti.",
  "summary.confirm": "Kinnita",
  "summary.dateTime.pattern": "d.m.Y <\\\\sp\\\\a\\\\n>k\\\\l</\\\\sp\\\\a\\\\n> H:i",
  "summary.extraServices": "Lisateenused on arvestatud broneeringu lõpphinna sisse. Kõiki broneeringus olevaid lisateenuseid näed e-postiga saadetud broneeringu kinnituselt (pdf).",
  "summary.freeMealPackages.title": "Tasuta lisateenused",
  "summary.refund.notification": "Makse tagastamiseks palun võta ühendust meie klienditeenindusega tel. {phoneLocal} (hind 85 senti/kõne + operaatoritasu). ",
  "summary.refund.notification.with.phoneInternational": "Makse tagastamiseks palun võta ühendust meie klienditeenindusega tel. {phoneLocal} (hind 85 senti/kõne + operaatoritasu). Välismaalt helistades {phoneInternational}.",
  "summary.refund.notification.phoneInternational.EE": " +372 640 9808",
  "summary.refund.notification.phoneInternational.SE": " +46 8 22 21 40",
  "summary.refund.notification.phoneLocal": " +49 (0)40 547 541 222",
  "summary.refund.notification.phoneLocal.FI": "(09) 887 53121",
  "summary.refund.notification.phoneLocal.EE": " 17 808",
  "summary.refund.notification.phoneLocal.SE": "08 22 21 40",
  "summary.refund.notification.phoneLocal.LV": " +371 670 997 00",
  "summary.refund.notification.phoneLocal.RU": " + 372 611 8801",
  "summary.clearChanges.title": "Muutsid meelt?",
  "summary.clearChanges.link": "Tühista muudatused",
  "summary.overnightPackage": "Ööbimine laeval",
  "template.dateTime": "{date} <span>kell</span> {time}",
  "time.preposition.at": "kell",
  "validate.firstName": "Eesnimi peab sisaldama ainult ladina tähti",
  "validate.lastName": "Perekonnanimi peab sisaldama ainult ladina tähti",
  "location.hotelCityCode.HAA": "Haapsalu",
  "location.hotelCityCode.HEL": "Helsingi",
  "location.hotelCityCode.JUR": "Jurmala",
  "location.hotelCityCode.KOM": "Kolmården",
  "location.hotelCityCode.KUR": "Kuressaare",
  "location.hotelCityCode.LAL": "Laulasmaa",
  "location.hotelCityCode.MHQ": "Mariehamn",
  "location.hotelCityCode.NAR": "Narva",
  "location.hotelCityCode.NRK": "Norrkoping",
  "location.hotelCityCode.OTE": "Otepää",
  "location.hotelCityCode.PAR": "Pärnu",
  "location.hotelCityCode.RAK": "Rakvere",
  "location.hotelCityCode.RIX": "Riia",
  "location.hotelCityCode.SOE": "Södertälje",
  "location.hotelCityCode.STO": "Stockholm",
  "location.hotelCityCode.TAR": "Tartu",
  "location.hotelCityCode.TKU": "Turu",
  "location.hotelCityCode.TLL": "Tallinn",
  "location.hotelCityCode.TMP": "Tampere",
  "location.hotelCityCode.UPP": "Uppsala",
  "location.hotelCityCode.VAN": "Vantaa",
  "location.hotelCityCode.VIH": "Vihula",
  "vehicle.type.bicycle.title": "Jalgratas, elektritõukeratas",
  "vehicle.type.car.title": "Sõiduauto",
  "vehicle.type.car-xl.title": "Sõiduauto",
  "vehicle.type.long-and-high.title": "Sõiduk koos järelkäruga",
  "vehicle.type.long-and-low.title": "Sõiduk koos järelkäruga",
  "vehicle.type.long-and-medium.title": "Sõiduk koos järelkäruga",
  "vehicle.type.motorcycle.title": "Mootorratas",
  "vehicle.type.motorcycle-with-sidecar.title": "Külgkorviga mootorratas",
  "vehicle.type.motorcycle-with-sidecar.measures": "Kuni 1,9 m kõrge ja kuni 4,0 m pikk",
  "vehicle.type.van-high.title": "Sõiduk",
  "vehicle.type.parked-car.title": "Pargitud auto",
  "vehicle.type.van.title": "Väikebuss",
  "vehicle.type.parked-van.title": "Pargitud väikebuss",
  "vehicle.type.shopper-car.title": "Sõiduauto garaažikohaga",
  "vehicle.type.shopper-van.title": "Sõiduauto või väikebuss garaažikohaga",
  "vehicle.type.shopper-car.notices": "- Sõiduki juurde pääseb kogu reisi vältel<br>\n- Sõiduk on pargitud poe kõrvale",
  "vehicle.type.shopper-van.notices": "- Sõiduki juurde pääseb kogu reisi vältel<br>\n- Sõiduk on pargitud poe kõrvale",
  "vehicle.type.parked-car.notices": "- Reisi ajal sõiduki juurde ei pääse<br>- Sihtpunktis ei saa sõidukiga välja sõita",
  "vehicle.type.parked-van.notices": "- Reisi ajal sõiduki juurde ei pääse<br>\n- Sihtpunktis ei saa sõidukiga välja sõita",
  "vehicle.type.shopper-car.noDisembark": "Sihtpunktis ei saa sõidukiga välja sõita",
  "vehicle.type.shopper-van.noDisembark": "Sihtpunktis ei saa sõidukiga välja sõita",
  "vehicle.type.parked-car.noDisembark": "Maaleminekut ei toimu",
  "vehicle.type.under.measures": "<span class=\"height\"></span> {height} m <span class=\"width\"></span> {length} m",
  "wifi.title": "Wifi",
  "common.language.FI": "Soome keel",
  "common.language.ET": "Eesti keel",
  "common.language.EN": "Inglise keel",
  "common.language.RU": "Vene keel",
  "common.language.SV": "Rootsi keel",
  "common.language.DE": "Saksa keel",
  "common.language.LV": "Läti keel",
  "common.language.LT": "Leedu keel",
  "label.or": "või",
  "routePanel.from": "Väljumine",
  "routePanel.to": "Sihtkoht",
  "port.ALA": "Ahvenamaa",
  "port.HEL": "Helsingi",
  "port.MUG": "Muuga",
  "port.RIG": "Riia",
  "port.STO": "Stockholm",
  "port.TAL": "Tallinn",
  "port.TUR": "Turu",
  "port.VIS": "Visby",
  "port.VSS": "Vuosaari",
  "port.SPE": "Peterburi",
  "port.SAS": "Sassnitz",
  "port.SMA": "Saaremaa",
  "port.VNT": "Ventspils",
  "port.HND": "Härnösand",
  "button.edit": "Muuda",
  "guests": "reisijad",
  "vehicles": "Sõidukid",
  "date": "Kuupäev",
  "travelClass.title": "Reisiklass",
  "giftCard": "Kinkekaart",
  "SIGN_IN": "Logi sisse",
  "button.book.a.trip": "Osta reis",
  "price.total": "Kokku",
  "clubOne.points.price": "ja {{count}} punkti",
  "error.title": "Viga",
  "button.close": "Sulge",
  "calendar.choose.date": "Vali kuupäev",
  "itinerary.miniCruise": "5h kruiis",
  "TAL-HEL.CRUISE": "9h kruiis",
  "timetable.oneWay": "Üks suund",
  "timetable.roundtrip": "Edasi-tagasi",
  "button.done": "Valmis",
  "pets": "lemmikloomad",
  "label.see.details": "Vaata detaile",
  "common.language.KO": "Korea keel ",
  "common.language.ZH": "Hiina keel ",
  "common.language.JA": "Jaapani keel",
  "header.chooseYourLanguage": "Vali keel ",
  "pageNotFound.title": "Andsime endast parima, et otsitut leida...",
  "pageNotFound.subtitle": "Kahjuks otsitavat lehte ei leitud.",
  "goBack": "Tagasi",
  "label.info": "Info",
  "itinerary.title": "Reisiinfo",
  "itinerary.description": "",
  "extraServices.button.soldOut": "Välja müüdud",
  "button.cancel": "Tühista",
  "abbreviation.hour": "{{hour}} h",
  "cruise": "Kruiis",
  "HEL-TAL.CRUISE": "22h kruiis",
  "form.error.required": "Väärtus on nõutav",
  "form.error.min": "Minimaalne lubatud väärtus on {{min}}",
  "form.error.max": "Maksimaalne lubatud väärtus on {{max}}",
  "form.error.minLength": "Minimaalne lubatud pikkus on {{minLength}}",
  "form.error.maxLength": "Maksimaalne lubatud pikkus on {{maxLength}}",
  "sailLeg.sailTime": "{{date, eeeee', <b>'dd.MM' kell <br>'HH:mm'</b>'}}",
  "timetable.tripTypeAndDeparture": "Reisitüüp ja väljumine",
  "timetable.calendar": "Kalender",
  "timetable.table.departureAndArrival": "Väljumine ja saabumine",
  "timetable.table.duration": "Kestus",
  "timetable.table.vessel": "Laev",
  "clubOne.slider.label": "Kasuta Club One'i punkte",
  "button.proceed": "Jätka",
  "label.loading": "Laadin andmeid",
  "sailLeg.sailTime.short": "{{date, '<b>'dd.MM'</b> kell <b>'HH:mm'</b>'}}",
  "clubOne.slider.description": "Maksimaalne kasutatavate punktide arv kalkuleeritakse dünaamiliselt broneeringus olevate toodete ja teenuste alusel.",
  "specialCruise": "Erikruiis",
  "cabin": "kajut",
  "lounges": "puhketoad",
  "cabins": "kajutid",
  "specialCabins": "spetsiaalsed kajutid",
  "specialCabin.tag.handicap": "Ligipääsetav",
  "specialCabin.tag.allergy": "Allergikule",
  "voucher": "Sooduskood",
  "serialTicket": "Seeriapilet",
  "summary": "Kokkuvõte",
  "contact": "Kontakt",
  "booking": "Broneering",
  "payment": "Makse",
  "free": "Tasuta",
  "guest": "reisija",
  "guest.count": "{count, plural, =0 {# reisijat} =1 {# reisija} other {# reisijat}}",
  "cabin.count": "{count, plural, =0 {# kajutit} =1 {# kajut} other {# kajutit}}",
  "form.firstName": "Eesnimi",
  "form.lastName": "Perekonnanimi",
  "CO.number": "Club One'i number",
  "dateOfBirth": "Sünnikuupäev",
  "gender": "Sugu",
  "guest.details": "Reisija andmed",
  "nationality": "Rahvus",
  "specialAssistance": "Eriabi",
  "payButton": "Maksa",
  "loading": "Palun oota...",
  "male": "Mees",
  "female": "Naine",
  "citizenship.estonian": "Eestlane",
  "notRequired": "Ei ole vaja",
  "ELECTRIC WHEELCHAIR": "Elektriline ratastool",
  "VISUALLY IMPAIRED": "Nägemispuue",
  "HEARING IMPAIRED": "Kuulmispuue",
  "OTHER REASON FOR ASSISTANCE": "Muu",
  "GUIDEDOG": "Juhtkoeraga",
  "WHEELCHAIR": "Ratastooliga",
  "button.ok": "OK",
  "errorPage.title": "Ilmnes viga!",
  "form.error.email": "E-posti aadress on vale",
  "form.error.positiveInteger": "Lubatud on ainult numbrid",
  "form.error.date": "Kuupäev on vale",
  "form.error.name": "Nimi peab sisaldama ainult ladina tähti",
  "form.error.clubOne": "Club One'i number on vale",
  "clubOneApplied": "Club One lisatud",
  "form.signInToUseYourBonusPoints": "Club One'i konto lisatud. Boonuspunktide kasutamiseks <clickable>logi sisse</clickable>.",
  "optional": "Valikuline",
  "form.error.positiveFloat": "Lubatud on ainult numbrid või kümnendväärtused",
  "AD": "Andorra",
  "AE": "Araabia Ühendemiraadid",
  "AF": "Afganistan",
  "AG": "Antigua ja Barbuda",
  "AI": "Anguilla",
  "AL": "Albaania",
  "AM": "Armeenia",
  "AN": "Hollandi Antillid",
  "AO": "Angoola",
  "AQ": "Antarktika",
  "AR": "Argentiina",
  "AS": "Ameerika Samoa",
  "AT": "Austria",
  "AU": "Austraalia",
  "AW": "Aruuba",
  "AZ": "Aserbaidžaan",
  "BA": "Bosnia Hertsegoviina",
  "BB": "Barbados",
  "BD": "Bangladesh",
  "BE": "Belgia",
  "BF": "Burkina Faso",
  "BG": "Bulgaaria",
  "BH": "Bahrain",
  "BI": "Burundi",
  "BJ": "Benin",
  "BM": "Bermuuda",
  "BN": "Brunei Darussalam",
  "BO": "Boliivia",
  "BR": "Brasiilia",
  "BS": "Bahama",
  "BT": "Bhutan",
  "BW": "Botswaana",
  "BY": "Valgevene",
  "BZ": "Belize",
  "CA": "Kanada",
  "CC": "Kookossaared",
  "CD": "Kongo Demokraatlik Vabariik",
  "CF": "Kesk-Aafrika Vabariik",
  "CG": "Kongo",
  "CH": "Šveits",
  "CI": "Elevandiluurannik",
  "CK": "Cooki saared",
  "CL": "Tšiili",
  "CM": "Kamerun",
  "CN": "Hiina",
  "CO": "Kolumbia",
  "CR": "Costa Rica",
  "CS": "Serbia",
  "CU": "Kuuba",
  "CV": "Roheneemesaared",
  "CX": "Jõulusaar",
  "CY": "Küpros",
  "CZ": "Tšehhi Vabariik",
  "DE": "Saksamaa",
  "DJ": "Djibouti",
  "DK": "Taani",
  "DM": "Dominica",
  "DO": "Dominica Vabariik",
  "DZ": "Alžeeria",
  "EC": "Ecuador",
  "EE": "Eesti",
  "EG": "Egiptus",
  "EH": "Lääne-Sahaara",
  "ER": "Eritrea",
  "ES": "Hispaania",
  "ET": "Etioopia",
  "FI": "Soome",
  "FJ": "Fidži",
  "FK": "Falklandi saared",
  "FM": "Mikroneesia",
  "FO": "Fääri saared",
  "FR": "Prantsusmaa",
  "GA": "Gabon",
  "GB": "Suurbritannia",
  "GD": "Grenada",
  "GE": "Gruusia",
  "GF": "Prantsuse Guajaana",
  "GH": "Ghana",
  "GI": "Gibraltar",
  "GL": "Gröönimaa",
  "GM": "Gambia",
  "GN": "Guinea",
  "GP": "Guadeloupe",
  "GQ": "Ekvatoriaalne Guinea",
  "GR": "Kreeka",
  "GS": "Lõuna-Georgia ja Lõuna-Sandwichi saared",
  "GT": "Guatemala",
  "GU": "Guam",
  "GW": "Guinea-Bissau",
  "GY": "Guyana",
  "GZ": "Gaza sektor",
  "HK": "Hong Kong",
  "HM": "Heardi ja Mcdonaldi saared",
  "HN": "Honduras",
  "HR": "Horvaatia",
  "HT": "Haiti",
  "HU": "Ungari",
  "ID": "Indoneesia",
  "IE": "Iirimaa",
  "IL": "Iisrael",
  "IN": "India",
  "IO": "India ookeani territoorium",
  "IQ": "Iraak",
  "IR": "Iraan",
  "IS": "Island",
  "IT": "Itaalia",
  "JM": "Jamaika",
  "JO": "Jordaania",
  "JP": "Jaapan",
  "KE": "Keenia",
  "KG": "Kõrgõzstan",
  "KH": "Kambodža",
  "KI": "Kiribati",
  "KM": "Comoros",
  "KN": "Saint Kitts - Nevis",
  "KP": "Korea Demokraatlik Rahvavabariik (Põhja-)",
  "KR": "Korea Vabariik (Lõuna-)",
  "KW": "Kuveit",
  "KY": "Caymani saared",
  "KZ": "Kasahstan",
  "LA": "Lao Demokraatlik Rahvavabariik",
  "LB": "Liibanon",
  "LC": "Saint Lucia",
  "LI": "Liechtenstein",
  "LK": "Sri Lanka",
  "LR": "Libeeria",
  "LS": "Lesotho",
  "LT": "Leedu",
  "LU": "Luksemburg",
  "LV": "Läti",
  "LY": "Liibüa",
  "MA": "Maroko",
  "MC": "Monaco",
  "MD": "Moldova",
  "ME": "Montenegro",
  "MG": "Madagaskar",
  "MH": "Marshalli saared",
  "MK": "Makedoonia",
  "ML": "Mali",
  "MM": "Myanmar (Former Burma)",
  "MN": "Mongoolia",
  "MO": "Macau",
  "MP": "Põhja-Mariaanid",
  "MQ": "Martinique",
  "MR": "Mauritaania",
  "MS": "Montserrat",
  "MT": "Malta",
  "MU": "Mauritius",
  "MV": "Maldiivid",
  "MW": "Malawi",
  "MX": "Mehhiko",
  "MY": "Malaisia",
  "MZ": "Mosambiik",
  "NC": "Uus-Kaledoonia",
  "NE": "Niger",
  "NF": "Norfolki saared",
  "NG": "Nigeeria",
  "NI": "Nikaraagua",
  "NL": "Holland",
  "NO": "Norra",
  "NP": "Nepaal",
  "NR": "Nauru",
  "NU": "Niue",
  "NZ": "Uus-Meremaa",
  "OM": "Omaan",
  "OT": "Muu",
  "PA": "Panama",
  "PE": "Peruu",
  "PF": "Prantsuse Polüneesia",
  "PG": "Paapua Uus-Guinea",
  "PH": "Filipiinid",
  "PK": "Pakistan",
  "PL": "Poola",
  "PM": "St. Pierre ja Miquelon",
  "PN": "Pitcairni saar",
  "PR": "Puerto Rico",
  "PS": "Palestina",
  "PT": "Portugal",
  "PW": "Palau",
  "PY": "Paraguay",
  "QA": "Qatar",
  "RE": "Reunion",
  "RO": "Rumeenia",
  "RS": "",
  "RU": "Vene Föderatsioon",
  "RW": "Rwanda",
  "SA": "Saudi Araabia",
  "SB": "Saalomoni saared",
  "SC": "Seišellid",
  "SD": "Sudaan",
  "SE": "Rootsi",
  "SG": "Singapur",
  "SH": "St. Helena",
  "SI": "Sloveenia",
  "SJ": "Svalbard ja Jan Mayen",
  "SK": "Slovakkia",
  "SL": "Sierra Leone",
  "SM": "San Marino",
  "SN": "Senegal",
  "SO": "Somaalia",
  "SR": "Suriname",
  "ST": "Sao Tome ja Principe",
  "SV": "El Salvador",
  "SY": "Süüria Araabia Vabariik",
  "SZ": "Svaasimaa",
  "TA": "Tahiiti",
  "TC": "Turks ja Caicos",
  "TD": "Tšaad",
  "TF": "Prantsuse alad lõunas ja Antarktikas",
  "TG": "Togo",
  "TH": "Tai",
  "TJ": "Tadžikistan",
  "TK": "Tokelau",
  "TL": "Ida-Timor",
  "TM": "Türkmenistan",
  "TN": "Tuneesia",
  "TO": "Tonga",
  "TR": "Türgi",
  "TT": "Trinidad ja Tobago",
  "TV": "Tuvalu",
  "TW": "Taiwan",
  "TZ": "Tansaania Ühendatud Vabariik",
  "UA": "Ukraina",
  "UG": "Uganda",
  "UM": "Ameerika Ühendriikide hajasaared",
  "US": "Ameerika Ühendriigid",
  "UY": "Uruguay",
  "UZ": "Usbekistan",
  "VA": "Vatikani Linnriik",
  "VC": "Saint Vincent ja Grenadiinid",
  "VE": "Venetsueela",
  "VG": "Briti Neitsisaared",
  "VI": "Ühendriikide Neitsisaared",
  "VN": "Vietnam",
  "VU": "Vanuatu",
  "WE": "Jordani Läänekallas",
  "WF": "Wallise ja Futuna saared",
  "WS": "Samoa",
  "XK": "Kosovo",
  "XZ": "Rahvusvaheline tsoon",
  "YE": "Jeemen",
  "YT": "Mayotte",
  "YU": "",
  "ZA": "Lõuna-Aafrika",
  "ZM": "Sambia",
  "ZR": "Sair",
  "ZW": "Zimbabwe",
  "ZZ": "Määratlemata",
  "reservationFee": "Broneerimistasu",
  "reserveTable": "Broneeri laud",
  "reserved": "Reserveeritud",
  "footer.copyright": "© AS Tallink Grupp {{year}}",
  "button.changeBooking": "Broneeringu muutmine",
  "payment.unsuccessful.callCenter": "Infotelefon <b><a href=\"tel:+372 640 9804\">+372 640 9804</a></b> (hind 85 senti/kõne + operaatoritasu) töötab E–R 09.00–18.00",
  "payment.klarnaAndSwish.title": "Klarna & Swish",
  "payment.klarna.description": "Arve, osaline makse",
  "payment.onlineBank.title": "Internetipank",
  "payment.onlineBankAndCards.title": "Internetipank & deebet/krediitkaart",
  "payment.cards.title": "Deebet/krediitkaart",
  "payment.onlineBanks.title": "Pank",
  "payment.BANK.description": "Pangad",
  "payment.MOBILE_PAY.description": "MobilePay",
  "payment.GOOGLE_PAY.description": "Google Pay",
  "payment.APPLE_PAY.description": "Apple Pay",
  "payment.onlineBanks.description": "Kohalikud pangad",
  "errorPage.description": "Lehekülje laadimine ebaõnnestus. Palun proovige uuesti. Pärast lehe laadimist kõik eelnevalt tehtud valikud kaovad. Kui sellest ei ole abi, palun helistage meie klienditeenindusse numbril  +372 640 9808. <br> Vabandame võimalike ebamugavuste pärast.",
  "payment.CARD.description": "Kaardid",
  "SERIAL COMFORT": "Comfort Lounge'i piletid",
  "SERIAL PASSENGER": "Star Class'i piletid",
  "SERIAL BUSINESS": "Business Lounge'i piletid",
  "SERIAL CAR/CAR XL": "Sõiduauto piletid",
  "SERIAL VAN": "Väikebussi piletid",
  "available.codes": "Kasutatavad koodid",
  "used.codes": "Kasutatud koodid",
  "ticket.expiry.notice": "Järgmised piletid aeguvad",
  "vehicle.type.extra-long-and-high.title": "Auto haagisega",
  "accessibility": "Ligipääsetavus",
  "cancelCover": "Tühistamise kindlustus",
  "clubOneDiscount": "Club One'i allahindlus",
  "button.payNow": "Maksa kohe",
  "button.joinClubOne": "Liitu Club One'iga",
  "price.toBePaid": "Maksmisele kuuluv",
  "price.subtotal": "Vahesumma",
  "price.alreadyPaid": "Juba makstud",
  "copy.coupon.to.clipboard.accessibility.label": "Kopeeri kood ",
  "price.chargeFee": "Broneeringu muutmise tasu",
  "expired.codes": "Aegunud koodid",
  "button.buy.cta": "Osta seeriapileteid",
  "no.codes.available": "Sul ei ole kasutatavaid koode",
  "accessibility.icon.aria-label": "Loe meie ligipääsetavuse avaldust",
  "pet.count": "{count, plural, =0 {# lemmiklooma} =1 {# lemmikloom} other {# lemmiklooma}}",
  "accessibility.url": " https://www.tallink.com/et/ligipaasetavus",
  "aLaCarteVoucher.withValue": "{{value}} À la carte vautšer",
  "timeOfDay": "{{date, HH:mm}}",
  "dayWithTimeOfDay": "{{date, eeeee' kell 'HH:mm }}",
  "aLaCarteVoucher": "À la carte vautšer",
  "ticket.expired": "Piletid aegusid",
  "tooltip.accessibility.label": "Ava kohtspikri",
  "couponPage.login.cta": "Ostetud seeriapiletite nägemiseks <login>logi sisse</login>.",
  "button.downloadFile": "Laadi fail alla ({{extension}})"
} },
fi: { translation: {
  "common.buyTickets": "Osta liput",
  "common.cancel": "Peruuta",
  "common.done": "valmis",
  "common.ok": "Ok",
  "clubOne.level": "Club One {{level}}",
  "clubOne.points.points": "p",
  "clubOne.points.hint": "Voit käyttää Club One -pisteitäsi bonusmatkojen varaamiseen.",
  "clubOne.switchToCompanyCustomer.warning": "Sinut kirjataan ulos",
  "clubOne.switchToCompanyCustomer.title": "Varaa yritysasiakkaana",
  "clubOne.loginLink": "Kirjaudu sisään",
  "clubOne.title": "Club One -asiakas",
  "companyCustomer.agentId": "Agenttinumero",
  "companyCustomer.agentId.error": "Syöttämääsi agenttinumeroa ei löydy",
  "companyCustomer.agentId.pattern": "Voit käyttää vain numeroita",
  "companyCustomer.error": "Syöttämääsi yritysnumeroa ei löydy",
  "companyCustomer.id": "Yritysnumero",
  "companyCustomer.login": "Kirjaudu",
  "companyCustomer.title": "Yritysasiakas",
  "deliveryDetails.clubOneAnonymous.text": "Liput lähetetään alla olevaan sähköpostiosoitteeseen.",
  "deliveryDetails.clubOneLogged.text": "Liput lähetetään alla olevaan sähköpostiosoitteeseen.",
  "deliveryDetails.companyCustomerAnonymous.text": "Liput lähetetään alla olevaan sähköpostiosoitteeseen.",
  "deliveryDetails.companyCustomerLogged.text": "Liput lähetetään alla olevaan sähköpostiosoitteeseen.",
  "deliveryDetails.form.email.label": "Sähköpostiosoite",
  "deliveryDetails.form.error.emailPattern": "Sähköpostiosoite on virheellinen",
  "deliveryDetails.form.error.namePattern": "Kentässä voit käyttää kirjaimia, ' ja -.",
  "deliveryDetails.form.error.required": "Pakollinen kenttä",
  "deliveryDetails.form.firstName.label": "Etunimi",
  "deliveryDetails.form.lastName.label": "Sukunimi",
  "deliveryDetails.title": "Toimitustiedot",
  "description.passenger": "Yksi henkilösarjalippu on voimassa yhdelle matkustajalle, yhdensuuntaiselle matkalle.",
  "description.vehicle": "Yksi ajoneuvon sarjalippu on voimassa yhdensuuntaiselle matkalle, yhdelle ajoneuvolle. Sarjalippu ei sisällä matkustajalippua.",
  "hero.mainTitle": "Sarjaliput",
  "hero.subtitle": "Sarjalipulla yksi matkustaja tai ajoneuvo voi matkustaa yhteen suuntaan valitulla reitillä.",
  "hint.clubOne.error": "Tämän osion lataamisessa tapahtui virhe. Päivitä sivu uudelleen tai jatka kirjautumatta sisään. Pahoittelemme tapahtunutta.",
  "hint.clubOne.text": "Club One -jäsenenä saat alennuksia ja keräät bonuspisteitä, joita voit käyttää bonusmatkoihin tai ostoksiin verkkokaupassamme. <a href=\"https://www.tallinksilja.fi/mika-on-club-one\"  target=\"_blank\">Lue lisää ja liity jäseneksi !</a>",
  "mainPage.title": "Sarjaliput",
  "mobile.back": "← Takaisin",
  "mobile.done": "Jatka",
  "price.description": "Liput",
  "price.amount": "Määrä",
  "price.discount": "Alennus",
  "price.price": "Hinta",
  "price.regular": "Normaali hinta",
  "price.giftCard": "Lahjakortti",
  "serialTicketName.passenger.business": "Lippu Business Loungessa",
  "serialTicketName.passenger.comfort": "Lippu Comfort Loungessa",
  "serialTicketName.passenger.star": "Lippu Star-luokassa",
  "serialTicketName.vehicle.CAR": "Lippu henkilöautolle\n(max ↔5 m ↕1,9 m)",
  "serialTicketName.vehicle.CAR XL": "Lippu henkilöautolle\n(max ↔5,5 m ↕2,4 m)",
  "serialTicketName.vehicle.VAN": "Lippu pakettiautolle\n(max ↔5,5 m ↕2,4 m)",
  "signIn.button": "Kirjaudu sisään",
  "signOut.link": "Kirjaudu ulos →",
  "signInWithCompanyId.link": "Kirjaudu sisään yritysnumerolla →",
  "srt.termsAndConditions.title": "Tallink-sarjalippujen käyttöehdot",
  "termsAndConditions.text": "<li>Sarjaliput ovat voimassa 8:lle, 14:lle tai 24:lle yhdensuuntaiselle matkalle Tallinna–Helsinki- ja Helsinki–Tallinna-reitillä.</li>\n<li>Sarjaliput ovat voimassa kaikilla Tallinna–Helsinki- ja Helsinki–Tallinna-reitillä.</li>\n<li>Sarjaliput myönnetään yhdelle määrätylle henkilölle tai yritykselle, mutta niitä voi käyttää useampi henkilö.</li>\n<li>Yksi henkilösarjalippu on voimassa yhdelle henkilölle, yhdensuuntaiselle matkalle.</li>\n<li>Yksi ajoneuvon sarjalippu on voimassa yhdelle ajoneuvolle, yhdensuuntaiselle matkalle ja ei sisällä lippua matkustajalle.</li>\n<li>Sarjaliput ovat voimassa yhden vuoden.</li>\n<li>Sarjalippuja voi ostaa matkamyymälöistämme, myyntipalvelustamme ja verkkosivujemme kautta.</li>\n<li>Sarjalipulla voit ostaa matkan matkamyymälöissämme, myyntipalvelustamme tai verkkosivujemme kautta.</li>\n<li>Voit käyttää maksimissaan kuusi sarjalippua yhdellä varauksella.</li>\n<li>Verkossa tehdyllä varauksella sarjalippu on voimassa matkan ensimmäisestä suunnasta.</li>\n<li>Sarjalipulla maksetun matkan muuttamisesta ei seuraa lisämaksua ja lipun voi muuttaa lähtöselvityksen päättymiseen asti.</li>",
  "type.passenger": "Henkilösarjalippu",
  "type.vehicle": "Sarjalippu ajoneuvoille",
  "voucherPanel.header": "Alennuskoodit ja lahjakortit",
  "voucherPanel.link.addAnotherVoucher": "+ Lisää uusi koodi",
  "voucherPanel.link.addVoucher": "Minulla on alennuskoodi tai lahjakortti",
  "voucherPanel.voucher.button.add": "Lisää",
  "voucherPanel.voucher.hint": "Lahjakortin voi käyttää useampaan ostoon, kunnes lahjakortin summa on käytetty kokonaan.<br>\nLahjakortilla on jäljellä <b>{{amountLeft}} €</b>.<br>\nVoimassa <b>{{expirationDate}}</b> asti.",
  "voucherPanel.voucher.label": "Alennuskoodi",
  "voucherPanel.voucher.validate.callToCallCenter": "Käyttääksesi lahjakortin, soita myyntipalveluumme p. 010 804 133 (0,0835 €/puhelu + 0,167 €/min).",
  "voucherPanel.voucher.validate.error": "Tarkista koodi",
  "payment.unsuccessful.description": "Maksuprosessi epäonnistui. Yritä uudelleen.",
  "payment.unsuccessful.title": "Maksu epäonnistui",
  "payment.cancelled.title": "Tilausta ei ole vielä maksettu",
  "payment.title": "Maksu",
  "payment.paymentServiceMethods.title": "Kortti",
  "payment.paymentServiceMethods.combined.title": "Verkkopankki / Kortti",
  "payment.disclaimer": "Maksamalla / vahvistamalla varauksen hyväksyt <a href=\"https://www.tallinksilja.fi/tietosuojaperiaatteet/\" target=\"_blank\">tietosuojaperiaatteet</a> ja matkaa koskevat <a href=\"https://www.tallinksilja.fi/matkaa-koskevat-ehdot/\" target=\"_blank\">ehdot.</a> Alle 18-v. matkustaja, muista tarkistaa <a href=\"https://www.tallinksilja.fi/ikasaanto/\" target=\"_blank\">ikäsäännöt ja tarvittavat matkustusluvat</a>.\n",
  "payment.disclaimer.Extra.TallinkGrupp": "Maksamalla / vahvistamalla varauksen hyväksyt <a href=\"https://www.tallinksilja.fi/tietosuojaperiaatteet/\" target=\"_blank\">tietosuojaperiaatteet</a> ja matkaa koskevat <a href=\"https://www.tallinksilja.fi/matkaa-koskevat-ehdot/\" target=\"_blank\">ehdot.</a> Alle 18-v. matkustaja, muista tarkistaa <a href=\"https://www.tallinksilja.fi/ikasaanto/\" target=\"_blank\">ikäsäännöt ja tarvittavat matkustusluvat</a>.<br>\nSinulle tarjottu matkapalvelujen yhdistelmä on direktiivissä (EU) 2015/2302 tarkoitettu matkapaketti.<br>\nNäin ollen sinuun sovelletaan kaikkia matkapaketteja koskevia EU-oikeuksia. AS Tallink Grupp on täysin vastuussa koko matkapaketin asianmukaisesta toteuttamisesta.<br>\nLisäksi yritys AS Tallink Grupp on hankkinut suojan palauttaakseen suorittamasi maksut ja, jos kuljetus sisältyy matkapakettiin, turvatakseen paluukuljetuksesi siltä varalta, että yrityksestä tulee maksukyvytön.<br>\n<a href=\"https://www.tallinksilja.fi/matkapakettien-oikeudet-tietolomake-tallink-grupp\" target=\"_blank\">Lisätietoja direktiivin (EU) 2015/2301 mukaisista tärkeimmistä oikeuksista</a>.",
  "payment.disclaimer.Extra.TallinkSiljaOY": "Maksamalla / vahvistamalla varauksen hyväksyt <a href=\"https://www.tallinksilja.fi/tietosuojaperiaatteet/\" target=\"_blank\">tietosuojaperiaatteet</a> ja matkaa koskevat <a href=\"https://www.tallinksilja.fi/matkaa-koskevat-ehdot/\" target=\"_blank\">ehdot.</a> Alle 18-v. matkustaja, muista tarkistaa <a href=\"https://www.tallinksilja.fi/ikasaanto/\" target=\"_blank\">ikäsäännöt ja tarvittavat matkustusluvat</a>.<br>\nSinulle tarjottu matkapalvelujen yhdistelmä on direktiivissä (EU) 2015/2302 tarkoitettu matkapaketti.<br>\nNäin ollen sinuun sovelletaan kaikkia matkapaketteja koskevia EU-oikeuksia. AS Tallink Grupp on täysin vastuussa koko matkapaketin asianmukaisesta toteuttamisesta.<br>\nLisäksi yritys AS Tallink Grupp on hankkinut suojan palauttaakseen suorittamasi maksut ja, jos kuljetus sisältyy matkapakettiin, turvatakseen paluukuljetuksesi siltä varalta, että yrityksestä tulee maksukyvytön.<br>\n<a href=\"https://fi.tallink.com/matkapakettien-oikeudet-tietolomake-tallink-silja\" target=\"_blank\">Lisätietoja direktiivin (EU) 2015/2301 mukaisista tärkeimmistä oikeuksista</a>.",
  "passengerDistribution.errors.WITHOUT_ADULT": "Lisää vähintään yksi aikuinen jokaiseen hyttiin.",
  "passengerDistribution.errors.WITHOUT_CABIN": "Lisää vielä puuttuvat {nrOfPassengersWithoutCabin} {nrOfPassengersWithoutCabin, plural, =0{matkustajaa} one{matkustaja} other{matkustajaa}} hytteihin.",
  "passengerDistribution.notification.childWithoutOwnBed": "Lapsi ilman omaa vuodepaikkaa",
  "payment.klarna.title": "Maksa\nmyöhemmin",
  "payment.onlineBanks.list.aktia": "Aktia",
  "payment.onlineBanks.list.alandsbanken": "Ålandsbanken",
  "payment.onlineBanks.list.coop": "COOP Pank",
  "payment.onlineBanks.list.danskebankEE": "Danske Bank",
  "payment.onlineBanks.list.danskebankFI": "Danske Bank",
  "payment.onlineBanks.list.handelsbanken": "Handelsbanken",
  "payment.onlineBanks.list.kultaraha": "Osuuspankki",
  "payment.onlineBanks.list.lahitapiola": "LähiTapiola",
  "payment.onlineBanks.list.lhv": "LHV",
  "payment.onlineBanks.list.luminor": "Luminor",
  "payment.onlineBanks.list.nordea": "Nordea",
  "payment.onlineBanks.list.saastopankki": "Säästöpankki",
  "payment.onlineBanks.list.seb": "SEB",
  "payment.onlineBanks.list.spankki": "S-Pankki",
  "payment.onlineBanks.list.swedbank": "Swedbank",
  "payment.invoice.title": "Maksutapa",
  "payment.type.invoice": "Maksu laskulla",
  "payment.reference.title": "Viitenumero",
  "payment.reference.disclaimer": "Klikkamalla maksu-painiketta hyväksyt <a href=\"https://www.tallinksilja.fi/tietosuojaperiaatteet/\" target=\"_blank\">tietosuojaperiaatteet</a> ja matkaa koskevat <a href=\"https://www.tallinksilja.fi/matkaa-koskevat-ehdot/\" target=\"_blank\">ehdot.</a>",
  "payment.type.card": "Maksu kortilla",
  "payment.klarna.options.title": "Saatavilla olevat maksutavat riippuvat varauksestasi, yleisimmät maksutavat ovat:",
  "payment.klarna.options.list": "<li>lasku</li><li>osamaksu</li>",
  "payment.klarna.policy": "Vahvistamalla varauksen hyväksyt varaustietojen luovutuksen Klarnalle maksutapojen mahdollistamista varten. Lue lisää <a href=\"https://cdn.klarna.com/1.0/shared/content/policy/data/fi_fi/privacy_statement.pdf\" target=\"_blank\">Klarnan tietosuojaperiaatteista.</a>",
  "payment.klarna.mobile.title": "Maksa helposti mobiilissa",
  "paymentPage.total": "Yhteensä",
  "paymentPage.confirm.freeReservation": "Vahvista tilaus",
  "paymentPage.confirm.onlyPayment": "Maksa",
  "paymentPage.confirm.onlyPayment.withInvoice": "Vahvista",
  "confirmation.thankYouCallout.title": "Kiitos ostostasi!",
  "confirmation.thankYouCallout.paidTotal": "Maksettu yhteensä",
  "confirmation.thankYouCallout.message": "Maksu onnistui ja tilauksesi on vahvistettu. Katso tarkat tiedot tilausvahvistuksestasi (lähetetty <b>{{email}}</b>).",
  "confirmation.orderConfirmation": "Tilausvahvistus",
  "confirmation.summary.downloadPdf": "Lataa PDF-tiedosto",
  "confirmation.summary.bookTrip": "Varaa matka",
  "confirmation.summary.disclaimer": "Voit hyödyntää ostostasi heti varaamalla matkan.",
  "confirmation.summary.email": "Sähköpostiosoite",
  "confirmation.summary.contactPerson": "Yhteyshenkilö",
  "confirmation.summary.securityCode": "Turvanumero",
  "confirmation.summary.orderNumber": "Varausnumero",
  "otherPaymentMethod": "Muu maksutapa",
  "paymentMethod": "Maksutapa",
  "remove": "Poista",
  "answer.yes": "Kyllä",
  "answer.no": "Ei",
  "button.send": "Lähetä",
  "button.withoutPrice.notChosen": "Valitse",
  "button.withoutPrice.chosen": "Valittu",
  "button.add": "Lisää",
  "clubOne.level.BRONZE": "Bronze",
  "clubOne.level.SILVER": "Silver",
  "clubOne.level.GOLD": "Gold",
  "clubOne.level.title": "Club One",
  "currency.EUR": "€",
  "currency.LAT": "Ls",
  "currency.LVL": "Ls",
  "currency.RUB": "€",
  "currency.SEK": "kr",
  "dateFormat.dayOfWeekDayMonthAndTime": "{weekday} <b>{date}</b> klo <b>{time}</b>",
  "decimalSeparator": ",",
  "details.dayMonthAndTime.pattern": "j.n. k\\\\lo H:i",
  "details.dayOfWeek.pattern": "l",
  "entertainment.title": "Viihde laivalla",
  "entertainment.sitting": "Istumapaikka",
  "error.chromeframe.label": "tai voit asentaa käyttämääsi selaimeen Googlen ",
  "entertainment.sittingGroup.premium.name\r\n": "Premium-paikat",
  "entertainment.sittingGroup.premium.description": "Paikoilta on esteetön näkyvyys lavalle ja niihin kuuluu aina tarjoilupaketti",
  "entertainment.sittingGroup.basic.name\r\n": "Rajoitettu näkymä",
  "entertainment.sittingGroup.basic.description": "Paikoilta voi olla hyvin rajoitettu näkyvyys lavalle tai esitystä voi seurata näyttötaulun kautta",
  "entertainment.sittingGroup.basic.addOn.name\r\n": "Istumapaikka",
  "error.chromeframe.link": "Chrome Frame -laajennuksen.",
  "error.ie": "Käytössäsi on Internet Explorer -selaimen vanha versio, jota Tallink Siljan Internet-varauspalvelu ei enää tue. Suosittelemme päivittämään turvallisempaan ja nopeampaan selaimeen. Voit ladata esimerkiksi jonkun alla olevista ilmaisista selaimista ",
  "error.notPossibleToChangeBookingOnline": "Valitettavasti kyseistä varausta ei pysty muuttamaan Online-palvelussa.<br><br>Tarvittaessa ole yhteydessä myyntipalveluumme 010 804 133 (0,0835 €/puhelu + 0,167 €/min).",
  "form.email": "Email",
  "form.phone": "Phone",
  "format.LocalDayMonth": "{{date, d.M.}}",
  "format.LocalShortWeekdayAndDayMonth": "D j.n.",
  "format.LocalLongWeekdayAndDayMonth": "l j.n.",
  "format.LocalShortWeekdayAndShortMonth": "D.M.",
  "format.LocalDayMonthYear": "j.n.Y",
  "header.bookingNumber": "Varausnumero",
  "header.logout": "Kirjaudu ulos",
  "header.myBooking": "Varaukseni",
  "header.pin": "Turvanumero",
  "hotel.checkInTime": "Check-in",
  "hotel.checkOutTime": "Check-out",
  "nights": "yötä",
  "night": "yö",
  "hotelsItinerary.returnTripIsNotAvailable": "Paluumatkalla ei saatavuutta, ole hyvä ja muuta varaustasi toiselle päivälle.",
  "label.remove": "Poista",
  "landServices.title": "Ennakkoon ostettavat retket/liput",
  "landService.ageCategory.base": "Peruslippu",
  "landService.ageCategory.child": "Lapsi {ageCategory} v.",
  "landService.dateTime.pattern": "j.n.Y",
  "meals.packages.choosePackage": "Valitse ateriapaketti",
  "meals.packages.title": "Osta ateriapaketti ja säästä!",
  "meals.packages.commonInfo": "Ateriapaketti sisältää ruokailut koko matkalle.",
  "meals.packages.description": "Lapset saavat paketista alennusta ja 0-5 v. syövät maksutta aikuisen seurassa. <br> Mikäli et saa varattua laivan Buffet-kattausta (täynnä), saat automaattisesti varaukselle samanarvoiset illalliskupongit. Voit myös käyttää kupongit maksuna laivan muissa ravintoloissa.",
  "meals.button.freeMealPackages": "Sis. hintaan",
  "meals.selectionMealBlockedByTime": "Ruokailujen ennakkomyynti on päättynyt. Voit tiedustella vapaita paikkoja vielä paikan päällä noustuasi laivaan.",
  "onboardServices.title": "Laivan muut palvelut",
  "adults": "aikuiset",
  "adult": "aikuinen",
  "child": "lapsi",
  "junior": "Juniori",
  "youth": "Nuoriso",
  "children": "lapset",
  "guests.edit.accessibility.label": "Matkustajatiedot",
  "pier.DTER.address": "Lootsi 13, 10151 Tallinn",
  "pier.DTER.title": "D-terminaali",
  "pier.FHAM.address": "Frihamnen, Magasin 2, 10253 Stockholm",
  "pier.FHAM.title": "Frihamnen",
  "pier.HND.title": "Härnösand",
  "pier.HND.address": "Skeppsbron 31, 871 80 Härnösand",
  "pier.LNAS.address": "Långnäsin terminaali, 22630 Lumparland",
  "pier.LNAS.title": "Långnäs",
  "pier.LSA2.address": "Länsisatama, Helsinki",
  "pier.LSA2.title": "Länsiterminaali 2",
  "pier.LSA6.address": "Tyynenmerenkatu 8 00220 Helsinki",
  "pier.LSA6.title": "Länsiterminaali 1",
  "pier.LSAT.address": "Tyynenmerenkatu 8 00220 Helsinki",
  "pier.LSAT.title": "Länsiterminaali 1",
  "pier.MHAM.address": "Västra hamnen, 22100 Maarianhamina",
  "pier.MHAM.title": "Maarianhamina",
  "pier.MUUG.address": "Muuga sadam, Maardu Tee 65, Maardu",
  "pier.MUUG.title": "Muuga satama",
  "pier.OLYM.address": "Olympiaranta 1, 00140 Helsinki",
  "pier.OLYM.title": "Olympiaterminaali",
  "pier.PALD.address": "Rae põik 10, EE-76806 Paldiski",
  "pier.PALD.title": "Paldiski",
  "pier.KAPE.address": "Hamnterminalen, 760 15 Gräddö",
  "pier.KAPE.title": "Kapellskär",
  "pier.RIGA.address": "3a Eksporta Str. Riga, LV-1010",
  "pier.RIGA.title": "Riian terminaali",
  "pier.TSAT.address": "Linnankatu 91, 20100 Turku",
  "pier.TSAT.title": "Turun satama",
  "pier.VHAM.address": "Hamnpirsvägen 10, 11574 Stockholm",
  "pier.VHAM.title": "Värtahamnen",
  "pier.VISH.title": "Visby",
  "pier.VISH.address": "Färjeleden 2, 621 81 Visby",
  "pier.VSAA.address": "Vuosaari, Seilorinkatu 5, Helsinki",
  "pier.VSAA.title": "Vuosaaren satama",
  "pier.MFAC.address": "Bereg Nevskoy gubi 1., V.O., St. Petersburg",
  "pier.MFAC.title": "Pietari",
  "pier.SAS.title": "Sassnitz",
  "pier.SMA1.title": "Saarenmaa",
  "pier.SMA1.address": "Klaipeda",
  "pier.KLJ1.title": "Klaipeda",
  "pier.KLJ1.address": "J.Zauerveino str. 18, LT-92122 Klaipeda, Lithuania",
  "port.KAP": "Kapellskär",
  "port.PAL": "Paldiski",
  "port.KLJ": "Klaipeda",
  "port.YST": "Ystad",
  "port.PARTY": "Itämeri",
  "refresh": "Päivitä",
  "reservation.travelPermitForYouth": "15–17-vuotias voi matkustaa ilman aikuista. Muista ottaa <a href=\"https://ee.tallink.com/documents/10192/65371006/Permission_to_travel_alone_15_17_EN.pdf/7a0c8141-c394-42b5-a6db-29469450ddc6\" target=\"_blank\">matkustuslupa</a> mukaasi. Turvallista matkaa!",
  "send.email.failed": "Sähköpostin lähetys epäonnistui. Ole hyvä ja yritä uudelleen.",
  "send.sms.failed": "Tekstiviestin lähetys epäonnistui. Ole hyvä ja yritä uudelleen.",
  "summary.confirm": "Vahvista",
  "summary.dateTime.pattern": "j.n.Y <\\\\sp\\\\a\\\\n>k\\\\lo</\\\\sp\\\\a\\\\n> H:i",
  "summary.extraServices": "Lisäpalvelut on laskettu mukaan varauksen kokonaishintaan. Näet kaikki varauksellasi olevat lisäpalvelut sähköpostiisi lähetetystä varausvahvistuksesta (pdf).",
  "summary.freeMealPackages.title": "Maksuttomat lisäpalvelut",
  "summary.refund.notification": "Ylimääräisen maksun palautukseen liittyen ole yhteydessä asiakaspalveluumme {phoneLocal} (paikallisverkkomaksu/matkapuhelinmaksu)",
  "summary.refund.notification.with.phoneInternational": "Ylimääräisen maksun palautukseen liittyen ole yhteydessä asiakaspalveluumme {phoneLocal} (paikallisverkkomaksu/matkapuhelinmaksu)",
  "summary.refund.notification.phoneInternational.EE": " +372 640 9808",
  "summary.refund.notification.phoneInternational.SE": " +46 8 22 21 40",
  "summary.refund.notification.phoneLocal": " +49 (0)40 547 541 222",
  "summary.refund.notification.phoneLocal.FI": "(09) 887 53121",
  "summary.refund.notification.phoneLocal.EE": " 17 808",
  "summary.refund.notification.phoneLocal.SE": "08 22 21 40",
  "summary.refund.notification.phoneLocal.LV": " +371 670 997 00",
  "summary.refund.notification.phoneLocal.RU": " + 372 611 8801",
  "summary.clearChanges.title": "Muutitko mielesi?",
  "summary.clearChanges.link": "Peruuta muutokset",
  "summary.overnightPackage": "Yöpyminen laivalla",
  "template.dateTime": "{date} <span>klo</span> {time}",
  "time.preposition.at": "klo",
  "validate.firstName": "Nimi ei saa sisältää erikoismerkkejä",
  "validate.lastName": "Nimi ei saa sisältää erikoismerkkejä",
  "location.hotelCityCode.HAA": "Haapsalu",
  "location.hotelCityCode.HEL": "Helsinki",
  "location.hotelCityCode.JUR": "Jurmala",
  "location.hotelCityCode.KOM": "Kolmården",
  "location.hotelCityCode.KUR": "Kuressaare",
  "location.hotelCityCode.LAL": "Laulasmaa",
  "location.hotelCityCode.MHQ": "Maarianhamina",
  "location.hotelCityCode.NAR": "Narva",
  "location.hotelCityCode.NRK": "Norrköping",
  "location.hotelCityCode.OTE": "Otepää",
  "location.hotelCityCode.PAR": "Pärnu",
  "location.hotelCityCode.RAK": "Rakvere",
  "location.hotelCityCode.RIX": "Riika",
  "location.hotelCityCode.SOE": "Södertälje",
  "location.hotelCityCode.STO": "Tukholma",
  "location.hotelCityCode.TAR": "Tartto",
  "location.hotelCityCode.TKU": "Turku",
  "location.hotelCityCode.TLL": "Tallinna",
  "location.hotelCityCode.TMP": "Tampere",
  "location.hotelCityCode.UPP": "Uppsala",
  "location.hotelCityCode.VAN": "Vantaa",
  "location.hotelCityCode.VIH": "Vihula",
  "vehicle.type.bicycle.title": "Polkupyörä, sähköpotkulauta",
  "vehicle.type.car.title": "Henkilöauto",
  "vehicle.type.car-xl.title": "Korkea henkilöauto",
  "vehicle.type.long-and-high.title": "Korkea ajoneuvo ja perävaunu",
  "vehicle.type.long-and-low.title": "Henkilöauto ja perävaunu",
  "vehicle.type.long-and-medium.title": "Pakettiauto ja perävaunu",
  "vehicle.type.motorcycle.title": "Moottoripyörä / mopo",
  "vehicle.type.motorcycle-with-sidecar.title": "Moottoripyörä sivuvaunulla",
  "vehicle.type.motorcycle-with-sidecar.measures": "Maks. 1,9 m korkea ja maks. 4,0 m pitkä",
  "vehicle.type.van-high.title": "Korkea pakettiauto / matkailuauto",
  "vehicle.type.parked-car.title": "Henkilöauto parkkiin laivalle",
  "vehicle.type.van.title": "Pakettiauto",
  "vehicle.type.parked-van.title": "Pakettiauto parkkiin laivalle",
  "vehicle.type.shopper-car.title": "Henkilöauto parkkiin autotalliin",
  "vehicle.type.shopper-van.title": "Pakettiauto parkkiin autotalliin",
  "vehicle.type.shopper-car.notices": "- helppo pääsy autosi luokse matkan aikana<br>- Vieraile autolla matkan aikana",
  "vehicle.type.shopper-van.notices": "- helppo pääsy autosi luokse matkan aikana<br>- Vieraile autolla matkan aikana",
  "vehicle.type.parked-car.notices": "- Ajoneuvon luona ei voi vierailla matkan aikana.<br>\r\n- Ajoneuvoa ei voi ajaa ulos matkakohteessa.",
  "vehicle.type.parked-van.notices": "- Ajoneuvon luona ei voi vierailla matkan aikana.<br>\r\n- Ajoneuvoa ei voi ajaa ulos matkakohteessa.",
  "vehicle.type.shopper-car.noDisembark": "Ajoneuvoa ei voi ajaa maihin",
  "vehicle.type.shopper-van.noDisembark": "Ajoneuvoa ei voi ajaa maihin",
  "vehicle.type.parked-car.noDisembark": "Ei maihinnousua",
  "vehicle.type.under.measures": "<span class=\"height\"></span> {height} m <span class=\"width\"></span> {length} m",
  "wifi.title": "WiFi",
  "common.language.FI": "Suomen kieli",
  "common.language.ET": "Eestin kieli",
  "common.language.EN": "Englannin kieli",
  "common.language.RU": "Venäjän kieli",
  "common.language.SV": "Ruotsin kieli",
  "common.language.DE": "Saksan kieli",
  "common.language.LV": "Latvian kieli",
  "common.language.LT": "Liettuan kieli",
  "label.or": "tai",
  "routePanel.from": "Mistä",
  "routePanel.to": "Mihin",
  "port.ALA": "Ahvenanmaa",
  "port.HEL": "Helsinki",
  "port.MUG": "Muuga",
  "port.RIG": "Riika",
  "port.STO": "Tukholma",
  "port.TAL": "Tallinna",
  "port.TUR": "Turku",
  "port.VIS": "Visby",
  "port.VSS": "Vuosaari",
  "port.SPE": "Pietari",
  "port.SAS": "Sassnitz",
  "port.SMA": "Saarenmaa",
  "port.VNT": "Ventspils",
  "port.HND": "Härnösand",
  "button.edit": "Muokkaa",
  "guests": "matkustajat",
  "vehicles": "Ajoneuvoja",
  "date": "Lähtöpäivä",
  "travelClass.title": "Matkustusluokka",
  "giftCard": "Lahjakortti",
  "SIGN_IN": "Kirjaudu sisään",
  "button.book.a.trip": "Varaa matka",
  "price.total": "Yhteensä",
  "clubOne.points.price": "ja {{count}} bonuspistettä",
  "error.title": "Virhe",
  "button.close": "Sulje",
  "calendar.choose.date": "Valitse päivämäärä",
  "itinerary.miniCruise": "5 h -risteily",
  "TAL-HEL.CRUISE": "9 h -risteily",
  "timetable.oneWay": "Yksi suunta",
  "timetable.roundtrip": "Meno-paluu",
  "button.done": "Valmis",
  "pets": "lemmikit",
  "label.see.details": "Katso lisätiedot",
  "common.language.KO": "Korean kieli",
  "common.language.ZH": "Kiinan kieli",
  "common.language.JA": "Japanin kieli",
  "header.chooseYourLanguage": "Valitse kieli",
  "pageNotFound.title": "Yritimme löytää sitä mitä etsit...",
  "pageNotFound.subtitle": "Valitettavasti etsimääsi sivua ei löytynyt.",
  "goBack": "Takaisin",
  "label.info": "Info",
  "itinerary.title": "Matkan tiedot",
  "itinerary.description": "",
  "extraServices.button.soldOut": "Ei saatavilla",
  "button.cancel": "Peruuta",
  "abbreviation.hour": "{{hour}} h",
  "cruise": "Risteily",
  "HEL-TAL.CRUISE": "22 h -risteily",
  "form.error.required": "Pakollinen kenttä",
  "form.error.min": "Vähimmäismäärä on {{min}}",
  "form.error.max": "Enimmäismäärä on {{max}}",
  "form.error.minLength": "Vähimmäispituus on {{minLength}}",
  "form.error.maxLength": "Enimmäispituus on {{maxLength}}",
  "sailLeg.sailTime": "{{date, eee', <b>'dd.MM' klo <br>'HH:mm'</b>'}}",
  "timetable.tripTypeAndDeparture": "Valitse matka & lähtöpäivä",
  "timetable.calendar": "Kalenteri",
  "timetable.table.departureAndArrival": "Lähtö & saapuminen",
  "timetable.table.duration": "Kesto",
  "timetable.table.vessel": "Laiva",
  "clubOne.slider.label": "Käytä Club One -bonuspisteitä",
  "button.proceed": "Jatka",
  "label.loading": "Tieto latautuu",
  "sailLeg.sailTime.short": "{{date, '<b>'dd.MM'</b> klo <b>'HH:mm'</b>'}}",
  "clubOne.slider.description": "Käytettävien bonuspisteiden enimmäismäärä määräytyy varauksen tuotteiden ja palvelujen sekä dynaamisen hinnoittelun mukaan.",
  "specialCruise": "Erikoisristeily",
  "cabin": "mökki",
  "lounges": "oleskelutilat",
  "cabins": "mökit",
  "specialCabins": "erikoishytit",
  "specialCabin.tag.handicap": "Esteetön",
  "specialCabin.tag.allergy": "Allergiavapaa hytti",
  "voucher": "Alennuskoodi",
  "serialTicket": "Sarjalippu",
  "summary": "Yhteenveto",
  "contact": "Matkustajatiedot",
  "booking": "Varaus",
  "payment": "Maksu",
  "free": "Ilmainen",
  "guest": "matkustaja",
  "guest.count": "{count, plural, =0 {# matkustajaa} =1 {# matkustaja} other {# matkustajaa}}",
  "cabin.count": "{count, plural, =0 {# hyttiä} =1 {# hytti} other {# hyttiä}}",
  "form.firstName": "",
  "form.lastName": "",
  "CO.number": "Club One -jäsennumero",
  "dateOfBirth": "Syntymäpäivä",
  "gender": "Sukupuoli",
  "guest.details": "Matkustajatiedot",
  "nationality": "Kansallisuus",
  "specialAssistance": "Erityistarpeet ja avustuspalvelut",
  "payButton": "Maksa",
  "loading": "Ole hyvä ja odota...",
  "male": "Mies",
  "female": "Nainen",
  "citizenship.estonian": "virolainen",
  "notRequired": "Ei tarvita",
  "ELECTRIC WHEELCHAIR": "Sähköpyörätuoli",
  "VISUALLY IMPAIRED": "Heikentynyt näkö",
  "HEARING IMPAIRED": "Heikentynyt kuulo",
  "OTHER REASON FOR ASSISTANCE": "Muu syy avustukseen",
  "GUIDEDOG": "Opaskoiran kanssa",
  "WHEELCHAIR": "Pyörätuolin kanssa",
  "button.ok": "OK",
  "errorPage.title": "Virhe",
  "form.error.email": "Sähköpostiosoite on virheellinen",
  "form.error.positiveInteger": "Vain numerot sallittuja",
  "form.error.date": "Päivämäärä on virheellinen",
  "form.error.name": "Nimessä saa olla vain latinalaisia kirjaimia",
  "form.error.clubOne": "Club One -numero on virheellinen",
  "clubOneApplied": "Club One -jäsenyys huomioitu",
  "form.signInToUseYourBonusPoints": "Club One -jäsenyys lisätty onnistuneesti. <clickable>Kirjaudu sisään</clickable> käyttääksesi bonuspisteitä osamaksuna.",
  "optional": "Valinnainen",
  "form.error.positiveFloat": "Vain numerot tai desimaaliluvut sallittuja",
  "AD": "Andorra",
  "AE": "Yhdistyneet Arabiemiirikunnat",
  "AF": "Afganistan",
  "AG": "Antigua ja Barbuda",
  "AI": "Anguilla",
  "AL": "Albania",
  "AM": "Armenia",
  "AN": "Alankomaiden Antillit",
  "AO": "Angola",
  "AQ": "Antarktika",
  "AR": "Argentiina",
  "AS": "American Samoa",
  "AT": "Itävalta",
  "AU": "Australia",
  "AW": "Aruba",
  "AZ": "Azerbaidžan",
  "BA": "Bosnia ja Hertsegovina",
  "BB": "Barbados",
  "BD": "Bangladesh",
  "BE": "Belgia",
  "BF": "Burkina Faso",
  "BG": "Bulgaria",
  "BH": "Bahrain",
  "BI": "Burundi",
  "BJ": "Benin",
  "BM": "Bermuda",
  "BN": "Brunei",
  "BO": "Bolivia",
  "BR": "Brasilia",
  "BS": "Bahamas",
  "BT": "Bhutan",
  "BW": "Botswana",
  "BY": "Valko-Venäjä",
  "BZ": "Belize",
  "CA": "Kanada",
  "CC": "Kookossaaret (Keeling-saaret)",
  "CD": "Kongon demokraattinen tasavalta",
  "CF": "Keski-Afrikan tasavalta",
  "CG": "Kongo",
  "CH": "Sveitsi",
  "CI": "Norsunluurannikko",
  "CK": "Cookinsaaret",
  "CL": "Chile",
  "CM": "Kamerun",
  "CN": "Kiina",
  "CO": "Kolumbia",
  "CR": "Costa Rica",
  "CS": "Serbia",
  "CU": "Kuuba",
  "CV": "Kap Verde",
  "CX": "Joulusaaret",
  "CY": "Kypros",
  "CZ": "Tšekki",
  "DE": "Saksa",
  "DJ": "Djibouti",
  "DK": "Tanska",
  "DM": "Dominica",
  "DO": "Dominikaaninen tasavalta",
  "DZ": "Algeria",
  "EC": "Ecuador",
  "EE": "Viro",
  "EG": "Egypti",
  "EH": "Länsi-Sahara",
  "ER": "Eritrea",
  "ES": "Espanja",
  "ET": "Etiopia",
  "FI": "Suomi",
  "FJ": "Fidžisaaret",
  "FK": "Falklandinsaaret (Malvinas)",
  "FM": "Mikronesia",
  "FO": "Färsaaret",
  "FR": "Ranska",
  "GA": "Gabon",
  "GB": "Iso-Britannia",
  "GD": "Grenada",
  "GE": "Georgia",
  "GF": "Ranskan Guyana",
  "GH": "Ghana",
  "GI": "Gibraltar",
  "GL": "Grönlanti",
  "GM": "Gambia",
  "GN": "Guinea",
  "GP": "Guadaloupe",
  "GQ": "Päiväntasaajan Guinea",
  "GR": "Kreikka",
  "GS": "Etelä-Georgia ja Eteläiset Sandwichsaaret",
  "GT": "Guatemala",
  "GU": "Guam",
  "GW": "Guinea-Bissau",
  "GY": "Guyana",
  "GZ": "Gazan kaista",
  "HK": "Hongkong",
  "HM": "Heard ja McDonaldinsaaret",
  "HN": "Honduras",
  "HR": "Kroatia",
  "HT": "Haiti",
  "HU": "Unkari",
  "ID": "Indonesia",
  "IE": "Irlanti",
  "IL": "Israel",
  "IN": "Intia",
  "IO": "Brittiläinen Intian valtameren alue",
  "IQ": "Iraq",
  "IR": "Iran",
  "IS": "Islanti",
  "IT": "Italia",
  "JM": "Jamaika",
  "JO": "Jordania",
  "JP": "Japani",
  "KE": "Kenia",
  "KG": "Kirgistan",
  "KH": "Kambodža",
  "KI": "Kiribatin tasavalta",
  "KM": "Komorien liitto",
  "KN": "Saint Kitts ja Nevis",
  "KP": "Korean demokraattinen kansantasavalta",
  "KR": "Korean tasavalta",
  "KW": "Kuwait",
  "KY": "Caymansaaret",
  "KZ": "Kazakstan",
  "LA": "Laos",
  "LB": "Libanon",
  "LC": "Saint Lucia",
  "LI": "Liechtenstein",
  "LK": "Sri Lanka",
  "LR": "Liberia",
  "LS": "Lesotho",
  "LT": "Liettua",
  "LU": "Luxembourg",
  "LV": "Latvia",
  "LY": "Libya",
  "MA": "Marokko",
  "MC": "Monaco",
  "MD": "Moldova",
  "ME": "Montenegro",
  "MG": "Madagascar",
  "MH": "Marshallinsaaret",
  "MK": "Makedonia",
  "ML": "Mali",
  "MM": "Myanmar (ent. Burma)",
  "MN": "Mongolia",
  "MO": "Macao",
  "MP": "Pohjois-Mariaanien liittovaltio",
  "MQ": "Martinique",
  "MR": "Mauritania",
  "MS": "Montserrat",
  "MT": "Malta",
  "MU": "Mauritius",
  "MV": "Malediivit",
  "MW": "Malawi",
  "MX": "Mexiko",
  "MY": "Malesia",
  "MZ": "Mosambik",
  "NC": "Uusi-Kaledonia",
  "NE": "Niger",
  "NF": "Norfolk",
  "NG": "Nigeria",
  "NI": "Nicaragua",
  "NL": "Alankomaat",
  "NO": "Norja",
  "NP": "Nepal",
  "NR": "Nauru",
  "NU": "Niue",
  "NZ": "Uusi-Seelanti",
  "OM": "Oman",
  "OT": "Ei käytössä",
  "PA": "Panama",
  "PE": "Peru",
  "PF": "Ranskan Polynesia",
  "PG": "Papua-Uusi-Guinea",
  "PH": "Filippiinit",
  "PK": "Pakistan",
  "PL": "Puola",
  "PM": "St. Pierre ja Miquelon",
  "PN": "Pitcairn-saari",
  "PR": "Puerto Rico",
  "PS": "Palestiina",
  "PT": "Portugali",
  "PW": "Palau",
  "PY": "Paraguay",
  "QA": "Qatar",
  "RE": "Réunion",
  "RO": "Romania",
  "RS": "Serbia",
  "RU": "Venäjä",
  "RW": "Ruanda",
  "SA": "Saudi-Arabia",
  "SB": "Salomonsaaret",
  "SC": "Seychellit",
  "SD": "Sudan",
  "SE": "Ruotsi",
  "SG": "Singapore",
  "SH": "St. Helena",
  "SI": "Slovenia",
  "SJ": "Huippuvuoret ja Jan Mayen",
  "SK": "Slovakia",
  "SL": "Sierra Leone",
  "SM": "San Marino",
  "SN": "Senegal",
  "SO": "Somalia",
  "SR": "Suriname",
  "ST": "São Tomé ja Príncipe",
  "SV": "El Salvador",
  "SY": "Syyria",
  "SZ": "Swazimaa",
  "TA": "Tahiti",
  "TC": "Turks- ja Caicossaaret",
  "TD": "Tšad",
  "TF": "Ranskan eteläiset ja antarktiset alueet",
  "TG": "Togo",
  "TH": "Thaimaa",
  "TJ": "Tadžikistan",
  "TK": "Tokelau",
  "TL": "Itä-Timor",
  "TM": "Turkmenistan",
  "TN": "Tunisia",
  "TO": "Tonga",
  "TR": "Turkki",
  "TT": "Trinidad ja Tobago",
  "TV": "Tuvalu",
  "TW": "Taiwan",
  "TZ": "Tansania",
  "UA": "Ukraina",
  "UG": "Uganda",
  "UM": "Yhdysvaltain pienet erillissaaret",
  "US": "Yhdysvallat",
  "UY": "Uruguay",
  "UZ": "Uzbekistan",
  "VA": "Vatikaanivaltio",
  "VC": "Saint Vincent ja Grenadiinit",
  "VE": "Venezuela",
  "VG": "Brittiläiset Neitsytsaaret",
  "VI": "Yhdysvaltain Neitsytsaaret",
  "VN": "Vietnam",
  "VU": "Vanuatu",
  "WE": "Länsiranta",
  "WF": "Wallis ja Futuna",
  "WS": "Samoa",
  "XK": "Kosovo",
  "XZ": "Kansainvälinen alue",
  "YE": "Jemen",
  "YT": "Mayotte",
  "YU": "Jugoslavia",
  "ZA": "Etelä-Afrikka",
  "ZM": "Sambia",
  "ZR": "Zaire",
  "ZW": "Zimbabwe",
  "ZZ": "Määrittelemätön",
  "reservationFee": "Varausmaksu",
  "reserveTable": "Varaa pöytä",
  "reserved": "Varattu",
  "footer.copyright": "© AS Tallink Grupp {{year}}",
  "button.changeBooking": "Muuta varausta",
  "payment.unsuccessful.callCenter": "Soita myyntipalveluumme <b><a href=\"tel:010804133\">010 804 133</a></b> (0,0835 €/puhelu + 0,167 €/min), avoinna ma–pe klo 9–18.",
  "payment.klarnaAndSwish.title": "Klarna & Swish",
  "payment.klarna.description": "Laskutus, osamaksu",
  "payment.onlineBank.title": "Verkkopankki",
  "payment.onlineBankAndCards.title": "Verkkopankki & pankki-/luottokortti",
  "payment.cards.title": "Pankki-/luottokortti",
  "payment.onlineBanks.title": "Verkkopankit",
  "payment.BANK.description": "Pankit",
  "payment.MOBILE_PAY.description": "MobilePay",
  "payment.GOOGLE_PAY.description": "Google Pay",
  "payment.APPLE_PAY.description": "Apple Pay",
  "payment.onlineBanks.description": "Yleisimmät verkkopankit",
  "errorPage.description": "Valitettavasti tapahtui virhe. Ole hyvä ja lataa sivu uudelleen. Huom.! Uudelleen lataamisen jälkeen kaikki valitut tiedot katoavat. Jos ongelma vielä jatkuu, ota yhteyttä <a href=\"https://www.tallinksilja.fi/palvelunumerot\" target=\"_blank\">Tallink Siljan myyntipalveluun</a>.",
  "payment.CARD.description": "Kortit",
  "SERIAL COMFORT": "Comfort Loungen henkilösarjaliput",
  "SERIAL PASSENGER": "Star-luokan henkilösarjaliput",
  "SERIAL BUSINESS": "Business Loungen henkilösarjaliput",
  "SERIAL CAR/CAR XL": "Henkilöautosarjaliput",
  "SERIAL VAN": "Pakettiautosarjaliput",
  "available.codes": "Käyttämättömät koodit",
  "used.codes": "Käytetyt koodit",
  "ticket.expiry.notice": "Seuraavien sarjalippujen voimassaoloaika umpeutuu",
  "vehicle.type.extra-long-and-high.title": "Auto perävaunulla",
  "accessibility": "Saavutettavuus",
  "cancelCover": "Peruuta kansi",
  "clubOneDiscount": "Club One -alennus",
  "button.payNow": "Maksa nyt",
  "button.joinClubOne": "Liity Club Oneen",
  "price.toBePaid": "Maksettava",
  "price.subtotal": "Välisumma",
  "price.alreadyPaid": "Jo maksettu",
  "copy.coupon.to.clipboard.accessibility.label": "Kopioi sarjalippukoodi leikepöydälle",
  "price.chargeFee": "Varauksen muutosmaksu",
  "expired.codes": "Umpeutuneet koodit",
  "button.buy.cta": "Osta sarjalippuja",
  "no.codes.available": "Sinulla ei ole jäljellä sarjalippukoodeja",
  "accessibility.icon.aria-label": "Lue saavutettavuuslauselmamme",
  "pet.count": "{count, plural, =0 {# lemmikkiä} =1 {# lemmikki} other {# lemmikkiä}}",
  "accessibility.url": "https://www.tallink.com/fi/saavutettavuus",
  "aLaCarteVoucher.withValue": "{{value}} ateriakuponki",
  "timeOfDay": "{{date, HH:mm}}",
  "dayWithTimeOfDay": "{{date, eee 'klo' HH:mm }}",
  "aLaCarteVoucher": "À la carte -kuponki",
  "ticket.expired": "Lippujen voimassaolo päättyi",
  "tooltip.accessibility.label": "Avaa työkaluvihje",
  "couponPage.login.cta": "Nähdäksesi ostetut sarjaliput, <login>kirjaudu sisään</login>.",
  "button.downloadFile": "Lataa tiedosto ({{extension}})"
} },
ru: { translation: {
  "common.buyTickets": "Купить ",
  "common.cancel": "Отменить",
  "common.done": "Готово",
  "common.ok": "Ок",
  "clubOne.level": "Club One {{level}}",
  "clubOne.points.points": "б.п.",
  "clubOne.points.hint": "Вы можете использовать бонусные пункты Club One для частичной оплаты путешествия.",
  "clubOne.switchToCompanyCustomer.warning": "Выйти из учетной записи",
  "clubOne.switchToCompanyCustomer.title": "Переключиться на учетную запись бизнес-клиента",
  "clubOne.loginLink": "Введите Ваш номер Club One ",
  "clubOne.title": "Клиент Club One",
  "companyCustomer.agentId": "ID агента",
  "companyCustomer.agentId.error": "ID агента не найдено",
  "companyCustomer.agentId.pattern": "",
  "companyCustomer.error": "Неверный номер клиента",
  "companyCustomer.id": "Номер клиента",
  "companyCustomer.login": "Войти",
  "companyCustomer.title": "Бизнес-клиент",
  "deliveryDetails.clubOneAnonymous.text": "Билеты отправлены на электронную почту указанную ниже. ",
  "deliveryDetails.clubOneLogged.text": "Билеты отправлены на электронную почту указанную ниже.",
  "deliveryDetails.companyCustomerAnonymous.text": "Билеты отправлены на электронную почту указанную ниже.",
  "deliveryDetails.companyCustomerLogged.text": "Билеты отправлены на электронную почту указанную ниже.",
  "deliveryDetails.form.email.label": "e-mail",
  "deliveryDetails.form.error.emailPattern": "Адрес электронной почты недействителен. ",
  "deliveryDetails.form.error.namePattern": "Для имени Вы можете использовать буквы, символы  ' и -.",
  "deliveryDetails.form.error.required": "Это поле обязательно к заполнению.",
  "deliveryDetails.form.firstName.label": "имя",
  "deliveryDetails.form.lastName.label": "фамилия",
  "deliveryDetails.title": "Детали доставки",
  "description.passenger": "Один из пассажирских серийных билетов действителен для одного пассажира в одном направлении.",
  "description.vehicle": "Серийный билет для транспортного средства действителен в одном направлении для одного автомобиля, пассажирский билет в стоимость не входит. ",
  "hero.mainTitle": "Серийные билеты ",
  "hero.subtitle": "Один из серийных билетов позволяет пассажиру/транспортному средству совершить рейс в одну сторону по выбранному маршруту.",
  "hint.clubOne.error": "При входе в систему произошла ошибка. Пожалуйста, перезагрузите страницу или продолжите без входа в систему. Приносим свои извинения за неудобство.",
  "hint.clubOne.text": "Участникам Club One предоставляются скидки и возможность накапливать бонусные пункты, которые можно использовать при покупке новых билетов на паром. <a href=\"https://www.tallinksilja.ru/general-information\" target=\"_blank\">Подробнее о Club One</a>",
  "mainPage.title": "Серийные билеты",
  "mobile.back": "← Назад",
  "mobile.done": "Подтверждаю",
  "price.description": "Билеты",
  "price.amount": "Количество",
  "price.discount": "Скидка",
  "price.price": "Стоимость",
  "price.regular": "Обычная стоимость",
  "price.giftCard": "Подарочная карта",
  "serialTicketName.passenger.business": "Билет в Business Lounge",
  "serialTicketName.passenger.comfort": "Билет в Comfort Lounge",
  "serialTicketName.passenger.star": "Билет в Star Class",
  "serialTicketName.vehicle.CAR": "билет для пассажиров с транспортным средством \n(до ↔5 м ↕1,9 м)",
  "serialTicketName.vehicle.CAR XL": "билет для пассажиров с транспортным средством \n(до ↔5,5 м ↕2,4 м)",
  "serialTicketName.vehicle.VAN": "билет для микроавтобуса \n(до ↔7 м ↕2,4 м)",
  "signIn.button": "Войти",
  "signOut.link": "Выйти →",
  "signInWithCompanyId.link": "Войти c ID клиента →",
  "srt.termsAndConditions.title": "Условия серийных билетов",
  "termsAndConditions.text": "<li>Серийный билет действителен на 8, 14 или 24 рейса(-ов) в одну сторону на отправления по маршрутам: Хельсинки-Таллинн и Таллинн-Хельсинки.</li>\n<li>Серийные билеты не персонализированы и их можно передавать близким и коллегам.</li>\n<li>Один из серийных билетов для пассажира покрывает один рейс в одну сторону для одного человека.</li>\n<li>Один из серийных билетов для транспортных средств действует на одно транспортное средство и не включает в себя билет для пассажира.</li>\n<li>Серийный билет действителен в течение одного года. </li>\n<li>Серийный билет возможно приобрести в официальных представительствах, в службе клиентской поддержки и в онлайн-системе на сайте компании Tallink.</li>\n<li>Поездки по серийному билету возможно оформить в официальных представительствах, через службу клиентской поддержки и в онлайн-системе на сайтах компании Tallink.</li>\n<li>В одном бронировании возможно использовать до 6 серийных билетов.</li>\n<li>Для онлайн-бронирований срок действия серийного билета начинается с первой поездки.</li>\n<li>При изменениях отправлений приобретенных по серийному билету не применяется сбор неустойки и билет возможно изменить до окончания регистрации (check-in).</li>",
  "type.passenger": "билеты для пассажиров",
  "type.vehicle": "билеты для транспортных средств",
  "voucherPanel.header": "Скидки и промокоды",
  "voucherPanel.link.addAnotherVoucher": "+ Добавить еще один промокод",
  "voucherPanel.link.addVoucher": "У меня есть промокод или подарочная карта",
  "voucherPanel.voucher.button.add": "Добавить",
  "voucherPanel.voucher.hint": "Подарочную карту можно использовать для нескольких покупок, пока средства не будут израсходованы.<br>\nНа счете подарочной карты <b>{{amountLeft}} €</b>.<br>\nПодарочная карта действительна до <b>{{expirationDate}}</b>.",
  "voucherPanel.voucher.label": "Промокод",
  "voucherPanel.voucher.validate.callToCallCenter": "Чтобы воспользоваться подарочной картой, пожалуйста, свяжитесь с поддержкой по телефону +372 640 9804",
  "voucherPanel.voucher.validate.error": "Пожалуйста, проверьте правильность промокода",
  "payment.unsuccessful.description": "В процессе оплаты что-то пошло не так. Пожалуйста, удостоверьтесь, что на балансе Вашей карты достаточно средств и повторите попытку.",
  "payment.unsuccessful.title": "Платеж не прошел",
  "payment.cancelled.title": "Заказ не оплачен",
  "payment.title": "Оплата",
  "payment.paymentServiceMethods.title": "Кредитные карты ",
  "payment.paymentServiceMethods.combined.title": "Банк / Карта",
  "payment.disclaimer": "Если вам меньше 18 лет, пожалуйста, ознакомьтесь с <a href=\"https://www.tallink.ee/ru/vanusepiirangud\" target=\"_blank\"> возрастными ограничениями</a>. Нажав на кнопку оплаты, вы соглашаетесь с <a href=\"https://www.tallink.ee/ru/reisitingimused-uksikreisijatele#maksetingimused1\" target=\"_blank\">условиями оплаты и аннулирования</a>.",
  "payment.disclaimer.Extra.TallinkGrupp": "Если вам меньше 18 лет, пожалуйста, ознакомьтесь с <a href=\"https://www.tallink.ee/ru/vanusepiirangud\" target=\"_blank\"> возрастными ограничениями</a>. Нажав на кнопку оплаты, вы соглашаетесь с условиями <a href=\"https://www.tallink.ee/ru/reisitingimused-uksikreisijatele#maksetingimused1\" target=\"_blank\">оплаты и аннулирования</a>.<br>\nПредлагаемый вам пакет туристических услуг - это пакетный тур в значении Директивы (EU) 2015/2302. Таким образом, у вас есть все права, которые есть у пассажира в соответствии с законодательством ЕС в случае пакетного тура. Предприниматель AS Tallink Grupp несёт полную ответственность за пакетный тур как надлежащее представление услуг в целом.<br>\nКроме того, по закону требуется, чтобы у предпринимателя AS Tallink Grupp была гарантия, если он не в состоянии выполнить свои обязательства в связи с платёжеспособностью, возместить произведённые вами платежи и, если пакетный тур включает в себя перевозку пассажиров, обеспечить ваше возвращение в пункт отправления или другое согласованное место.<br>\n<a href=\"https://www.tallink.ee/ru/pakettreisi-teabeleht-tallink-grupp\" target=\"_blank\">Ознакомиться с условиями пакетных туров</a>.",
  "payment.disclaimer.Extra.TallinkSiljaOY": "Если вам меньше 18 лет, пожалуйста, ознакомьтесь с <a href=\"https://www.tallink.ee/ru/vanusepiirangud\" target=\"_blank\"> возрастными ограничениями</a>. Нажав на кнопку оплаты, вы соглашаетесь с условиями <a href=\"https://www.tallink.ee/ru/reisitingimused-uksikreisijatele#maksetingimused1\" target=\"_blank\">оплаты и аннулирования</a>.<br>\nПредлагаемый вам пакет туристических услуг - это пакетный тур в значении Директивы (EU) 2015/2302. Таким образом, у вас есть все права, которые есть у пассажира в соответствии с законодательством ЕС в случае пакетного тура. Предприниматель Tallink Silja Oy несёт полную ответственность за пакетный тур как надлежащее представление услуг в целом.<br>\nКроме того, по закону требуется, чтобы у предпринимателя Tallink Silja Oy была гарантия, если он не в состоянии выполнить свои обязательства в связи с платёжеспособностью, возместить произведённые вами платежи и, если пакетный тур включает в себя перевозку пассажиров, обеспечить ваше возвращение в пункт отправления или другое согласованное место.<br>\n<a href=\"https://ee.tallink.com/ru/pakettreisi-teabeleht-tallink-silja\" target=\"_blank\">Ознакомиться с условиями пакетных туров</a>.",
  "passengerDistribution.errors.WITHOUT_ADULT": "В каюте должен быть как минимум один взрослый",
  "passengerDistribution.errors.WITHOUT_CABIN": "Пожалуйста, расселите в каюты {nrOfPassengersWithoutCabin, plural, one{оставшегося # пассажира} other{оставшихся # пассажиров}}.",
  "passengerDistribution.notification.childWithoutOwnBed": "Ребенок без отдельного спального места.",
  "payment.klarna.title": "Klarna",
  "payment.onlineBanks.list.aktia": "Aktia",
  "payment.onlineBanks.list.alandsbanken": "Ålandsbanken",
  "payment.onlineBanks.list.coop": "COOP Pank",
  "payment.onlineBanks.list.danskebankEE": "Danske Bank",
  "payment.onlineBanks.list.danskebankFI": "Danske Bank",
  "payment.onlineBanks.list.handelsbanken": "Handelsbanken",
  "payment.onlineBanks.list.kultaraha": "Osuuspankki",
  "payment.onlineBanks.list.lahitapiola": "LähiTapiola",
  "payment.onlineBanks.list.lhv": "LHV",
  "payment.onlineBanks.list.luminor": "Luminor",
  "payment.onlineBanks.list.nordea": "Nordea",
  "payment.onlineBanks.list.saastopankki": "Säästöpankki",
  "payment.onlineBanks.list.seb": "SEB",
  "payment.onlineBanks.list.spankki": "S-Pankki",
  "payment.onlineBanks.list.swedbank": "Swedbank",
  "payment.invoice.title": "Способ оплаты",
  "payment.type.invoice": "Выставить счет для оплаты",
  "payment.reference.title": "Ваш номер ссылки",
  "payment.reference.disclaimer": "Нажимая на кнопку оплаты, Вы подтверждаете согласие с <a href=\"https://www.tallinksilja.ru/usefulinfo#17631321\" target=\"_blank\">правилами и условиями</a>.",
  "payment.type.card": "Провести оплату по карте",
  "payment.klarna.options.title": "Способ оплаты зависит от Вашего бронирования. Наиболее популярные способы:",
  "payment.klarna.options.list": "<li>Faktura</li><li>Delbetala</li>",
  "payment.klarna.policy": "Подтверждая бронирование, Вы соглашаетесь с тем, что информация о Вашем бронировании будет передана в сервис Klarna. Подробная информация <a href=\"https://cdn.klarna.com/1.0/shared/content/policy/data/en_fi/privacy_statement.pdf\" target=\"_blank\">на сайте </a>.",
  "payment.klarna.mobile.title": "Оплачивайте легко и безопасно с мобильного телефона с сервисом Klarna . ",
  "paymentPage.total": "Всего",
  "paymentPage.confirm.freeReservation": "Подтвердить заказ",
  "paymentPage.confirm.onlyPayment": "Оплатить",
  "paymentPage.confirm.onlyPayment.withInvoice": "Подтвердить",
  "confirmation.thankYouCallout.title": "Благодарим Вас за покупку!",
  "confirmation.thankYouCallout.paidTotal": "Оплачено итого",
  "confirmation.thankYouCallout.message": "Оплата прошла и Ваш заказ подтвержден. Ваше подтверждение бронирования с деталями заказа отправлено на адрес <b>{{email}}</b>.",
  "confirmation.orderConfirmation": "Подтверждение заказа",
  "confirmation.summary.downloadPdf": "Скачать PDF",
  "confirmation.summary.bookTrip": "Забронировать рейс",
  "confirmation.summary.disclaimer": "Вы можете сразу воспользоваться покупкой. Забронируйте Ваш рейс сейчас.",
  "confirmation.summary.email": "Эл. почта",
  "confirmation.summary.contactPerson": "Контактное лицо",
  "confirmation.summary.securityCode": "Защитный код",
  "confirmation.summary.orderNumber": "Номер заказа",
  "otherPaymentMethod": "Другой способ оплаты",
  "paymentMethod": "Способ оплаты",
  "remove": "Удалить",
  "answer.yes": "Да",
  "answer.no": "Нет",
  "button.send": "Отправить",
  "button.withoutPrice.notChosen": "Выбрать",
  "button.withoutPrice.chosen": "Удалить",
  "button.add": "Добавить",
  "clubOne.level.BRONZE": "Бронзовый уровень",
  "clubOne.level.SILVER": "Серебряный уровень",
  "clubOne.level.GOLD": "Золотой уровень",
  "clubOne.level.title": "Club one",
  "currency.EUR": "€",
  "currency.LAT": "Лс",
  "currency.LVL": "Ls",
  "currency.RUB": "€",
  "currency.SEK": "кр",
  "dateFormat.dayOfWeekDayMonthAndTime": "{weekday} <b>{date}</b> в <b>{time}</b>",
  "decimalSeparator": ",",
  "details.dayMonthAndTime.pattern": "d.m k\\\\l H:i",
  "details.dayOfWeek.pattern": "l",
  "entertainment.title": "Развлекательная программа на борту",
  "entertainment.sitting": "Место",
  "error.chromeframe.label": "Или замените имеющийся интернет-браузером Google",
  "entertainment.sittingGroup.premium.name\r\n": "Премиум места",
  "entertainment.sittingGroup.premium.description": "Премиум места включают питание и лучший обзор!",
  "entertainment.sittingGroup.basic.name\r\n": "Количество мест ограничено",
  "entertainment.sittingGroup.basic.description": "Стандартные места не гарантируют хороший обзор ",
  "entertainment.sittingGroup.basic.addOn.name\r\n": "Места с ограниченным обзором сцены",
  "error.chromeframe.link": "Дополнение Chrome Frame",
  "error.ie": "Вы используете старую версию Internet Explorer. Tallink Online не поддерживает этот браузер. Советуем сменить браузер на более новый и быстрый. Здесь найдёте список бесплатных браузеров:",
  "error.notPossibleToChangeBookingOnline": "К сожалению, данное бронирование невозможно поменять в онлайн системе бронирования. <br><br> При необходимости просим связаться с центром обслуживания клиентов по номеру + 372 611 8801.",
  "form.email": "Email",
  "form.phone": "Телефон",
  "format.LocalDayMonth": "{{date, d.M}}",
  "format.LocalShortWeekdayAndDayMonth": "D d.m",
  "format.LocalLongWeekdayAndDayMonth": "l d.m",
  "format.LocalShortWeekdayAndShortMonth": "DD.MM",
  "format.LocalDayMonthYear": "d.m.Y",
  "header.bookingNumber": "Номер бронирования",
  "header.logout": "Выход из системы",
  "header.myBooking": "Моё бронирование",
  "header.pin": "Защитный код ",
  "hotel.checkInTime": "Заезд",
  "hotel.checkOutTime": "Отъезд",
  "nights": "ночи",
  "night": "ночь",
  "hotelsItinerary.returnTripIsNotAvailable": "Билеты на обратное направление распроданы. Просим изменить срок пребывания в отеле",
  "label.remove": "Удалить",
  "landServices.title": "Развлечения на берегу",
  "landService.ageCategory.base": "Обычный билет",
  "landService.ageCategory.child": "Дети {ageCategory} лет",
  "landService.dateTime.pattern": "d.m.Y",
  "meals.packages.choosePackage": "Выбрать комплект питания",
  "meals.packages.title": "Экономьте и приобретайте комплекты питания\r\n",
  "meals.packages.commonInfo": "В комплекте питания еда включена на весь круиз.",
  "meals.packages.description": "Детям 6-17 лет предоставляются скидки, дети 0-5 лет - бесплатно, если родители приобрели комплект питания. <br>Если смены ужинов распроданы и их не выбрать, то в комплект питания будут добавлены купоны на ужин (тем же номиналом). Купоны на ужин возможно использовать для оплаты входа в буфет, а также для оплаты счета во всех ресторанах на борту. ",
  "meals.button.freeMealPackages": "Включено",
  "meals.selectionMealBlockedByTime": "Предварительная продажа питания окончена. При наличии свободных мест питание можно  будет приобрести  на борту судна.",
  "onboardServices.title": "Услуги на борту",
  "adults": "взрослые",
  "adult": "взрослый",
  "child": "ребенок",
  "junior": "Младший",
  "youth": "Молодость",
  "children": "дети",
  "guests.edit.accessibility.label": "Данные пассажиров",
  "pier.DTER.address": "Lootsi 13, 10151 Таллинн",
  "pier.DTER.title": "D-терминал",
  "pier.FHAM.address": "Фрихамн, Magasin 2, 10 253 Стокгольм",
  "pier.FHAM.title": "Фрихамн (Frihamnen)",
  "pier.HND.title": "Хернёсанд",
  "pier.HND.address": "Skeppsbron 31, 871 80 Härnösand",
  "pier.LNAS.address": "Лонгнес/Терминал Лумпарланд ",
  "pier.LNAS.title": "Лонгнес",
  "pier.LSA2.address": "Западный порт, Хельсинки",
  "pier.LSA2.title": "Западный терминал 2",
  "pier.LSA6.address": "Tyynenmerenkatu 8, 00220 Хельсинки",
  "pier.LSA6.title": "Западный терминал 1",
  "pier.LSAT.address": "Tyynenmerenkatu 8, 00220 Хельсинки",
  "pier.LSAT.title": "Западный терминал 1",
  "pier.MHAM.address": "Мариехамн/Терминал «Вястра хамн»",
  "pier.MHAM.title": "Мариехамн",
  "pier.MUUG.address": "Мууга",
  "pier.MUUG.title": "Мууга",
  "pier.OLYM.address": "Olympiaranta 1, 00140 Хельсинки",
  "pier.OLYM.title": "Южный порт (Olympia терминал)",
  "pier.PALD.address": "Rae põik 10, EE-76806 Paldiski",
  "pier.PALD.title": "Paldiski",
  "pier.KAPE.address": "Hamnterminalen, 760 15 Gräddö",
  "pier.KAPE.title": "Kapellskär",
  "pier.RIGA.address": "Eksporta iela 3A, Рига, LV-1010",
  "pier.RIGA.title": "Рижский пассажирский порт",
  "pier.TSAT.address": "Linnankatu 91, 20100 Турку",
  "pier.TSAT.title": "Порт Турку",
  "pier.VHAM.address": "Hamnpirsvägen 10, 11574 Стокгольм",
  "pier.VHAM.title": "Вяртахамн (Värtahamnen)",
  "pier.VISH.title": "Висбю",
  "pier.VISH.address": "Färjeleden 2, 62181 Висбю",
  "pier.VSAA.address": "Вуосаари",
  "pier.VSAA.title": "Вуосаари",
  "pier.MFAC.address": "Берег Невской губы, 1, В.О., Санкт-Петербург",
  "pier.MFAC.title": "Морской вокзал",
  "pier.SAS.title": "Засниц",
  "pier.SMA1.title": "Сааремаа",
  "pier.SMA1.address": "Ninase küla, Mustjala, 93631, Сааремаа",
  "pier.KLJ1.title": "Клайпеда",
  "pier.KLJ1.address": "J.Zauerveino str. 18, LT-92122 Клайпеда, Литва",
  "port.KAP": "Капельшер",
  "port.PAL": "Палдиски",
  "port.KLJ": "Клайпеда",
  "port.YST": "Ystad",
  "port.PARTY": "Балтийское море",
  "refresh": "Обновить",
  "reservation.travelPermitForYouth": "As a 15-17 year old you can travel without being accompanied by an adult. Remember to bring your <a href=\"https://ee.tallink.com/documents/10192/65371006/Permission_to_travel_alone_15_17_EN.pdf/7a0c8141-c394-42b5-a6db-29469450ddc6\" target=\"_blank\">travel permit</a> with you. Safe travels!",
  "send.email.failed": "Письмо не отправлено. Пожалуйста, попробуйте снова.",
  "send.sms.failed": "Сообщение не отправлено. Пожалуйста, попробуйте снова.",
  "summary.confirm": "Подтвердить",
  "summary.dateTime.pattern": "d.m.Y <\\\\sp\\\\a\\\\n>\\в</\\\\sp\\\\a\\\\n> H:i",
  "summary.extraServices": "Стоимость дополнительных услуг включена в общую цену. Вся необходимая информация имеется в высланном Вам по электронной почте PDF файле.",
  "summary.freeMealPackages.title": "Бесплатные дополнительные услуги",
  "summary.refund.notification": "Для возврата денежных средств просим связаться с центром обслуживания клиентов по телефону {phoneLocal}.",
  "summary.refund.notification.with.phoneInternational": "Для возврата денежных средств просим связаться с центром обслуживания клиентов по телефонам {phoneLocal} / {phoneInternational}",
  "summary.refund.notification.phoneInternational.EE": " +372 640 9808",
  "summary.refund.notification.phoneInternational.SE": " +46 8 22 21 40",
  "summary.refund.notification.phoneLocal": " +49 (0)40 547 541 222",
  "summary.refund.notification.phoneLocal.FI": "(09) 887 53121",
  "summary.refund.notification.phoneLocal.EE": " 17 808",
  "summary.refund.notification.phoneLocal.SE": "08 22 21 40",
  "summary.refund.notification.phoneLocal.LV": " +371 670 997 00",
  "summary.refund.notification.phoneLocal.RU": " + 372 611 8801",
  "summary.clearChanges.title": "Вы передумали? ",
  "summary.clearChanges.link": "Отменить изменения ",
  "summary.overnightPackage": "С ночевкой на борту",
  "template.dateTime": "{date} <span>в</span> {time}",
  "time.preposition.at": "",
  "validate.firstName": "При вводе имени просим использовать только латинские буквы",
  "validate.lastName": "При вводе фамилии просим использовать только латинские буквы",
  "location.hotelCityCode.HAA": "Haapsalu",
  "location.hotelCityCode.HEL": "Хельсинки",
  "location.hotelCityCode.JUR": "Юрмала",
  "location.hotelCityCode.KOM": "Кольморден",
  "location.hotelCityCode.KUR": "Курессааре",
  "location.hotelCityCode.LAL": "Лауласмаа",
  "location.hotelCityCode.MHQ": "Мариенхамен",
  "location.hotelCityCode.NAR": "Нарва",
  "location.hotelCityCode.NRK": "Норрчёпинг",
  "location.hotelCityCode.OTE": "Отепя",
  "location.hotelCityCode.PAR": "Пярну",
  "location.hotelCityCode.RAK": "Раквере",
  "location.hotelCityCode.RIX": "Рига ",
  "location.hotelCityCode.SOE": "Сёдертелье",
  "location.hotelCityCode.STO": "Стокгольм",
  "location.hotelCityCode.TAR": "Тарту",
  "location.hotelCityCode.TKU": "Турку",
  "location.hotelCityCode.TLL": "Таллинн",
  "location.hotelCityCode.TMP": "Тампере",
  "location.hotelCityCode.UPP": "Упсала",
  "location.hotelCityCode.VAN": "Ванта",
  "location.hotelCityCode.VIH": "Вихула",
  "vehicle.type.bicycle.title": "Велосипед, электросамокат",
  "vehicle.type.car.title": "Легковой автомобиль",
  "vehicle.type.car-xl.title": "Легковой автомобиль",
  "vehicle.type.long-and-high.title": "ТС с прицепом",
  "vehicle.type.long-and-low.title": "ТС с прицепом",
  "vehicle.type.long-and-medium.title": "ТС с прицепом",
  "vehicle.type.motorcycle.title": "Мотоцикл",
  "vehicle.type.motorcycle-with-sidecar.title": "Мотоцикл с коляской",
  "vehicle.type.motorcycle-with-sidecar.measures": "До 1,9 м высотой, до 4 м длиной",
  "vehicle.type.van-high.title": "ТС",
  "vehicle.type.parked-car.title": "Припаркованный автомобиль ",
  "vehicle.type.van.title": "Автомобиль или микроавтобус",
  "vehicle.type.parked-van.title": "Припаркованный микроавтобус",
  "vehicle.type.shopper-car.title": "Автомобиль для шопинга",
  "vehicle.type.shopper-van.title": "Микроавтобус для шопинга ",
  "vehicle.type.shopper-car.notices": "- Доступ к т/с во время путешествия <br>- Парковка рядом с магазином",
  "vehicle.type.shopper-van.notices": "- Доступ к т/с во время путешествия <br>- Парковка рядом с магазином",
  "vehicle.type.parked-car.notices": "- Без доступа к т/с во время путешествия<br>\r\n- Без возможности съезда с судна в пункте назначения",
  "vehicle.type.parked-van.notices": "- Без доступа к т/с во время путешествия<br>\r\n- Без возможности съезда с судна в пункте назначения",
  "vehicle.type.shopper-car.noDisembark": "Съезд т/с в пункте назначения невозможен",
  "vehicle.type.shopper-van.noDisembark": "Съезд т/с в пункте назначения невозможен",
  "vehicle.type.parked-car.noDisembark": "",
  "vehicle.type.under.measures": "<span class=\"height\"></span> {height} m <span class=\"width\"></span> {length} m",
  "wifi.title": "WiFi",
  "common.language.FI": "Финский язык",
  "common.language.ET": "Эстонский язык",
  "common.language.EN": "Английский язык",
  "common.language.RU": "Русский язык",
  "common.language.SV": "Шведский язык",
  "common.language.DE": "Немецкий язык",
  "common.language.LV": "Латышский язык",
  "common.language.LT": "Литовский язык",
  "label.or": "или",
  "routePanel.from": "Из",
  "routePanel.to": "В",
  "port.ALA": "Аландские о-ва",
  "port.HEL": "Хельсинки",
  "port.MUG": "Мууга",
  "port.RIG": "Рига",
  "port.STO": "Стокгольм",
  "port.TAL": "Таллинн",
  "port.TUR": "Турку",
  "port.VIS": "Висбю",
  "port.VSS": "Вуосаари",
  "port.SPE": "Петербург",
  "port.SAS": "Засниц",
  "port.SMA": "Сааремаа",
  "port.VNT": "Вентспилс",
  "port.HND": "Хернёсанд",
  "button.edit": "Edit",
  "guests": "пассажиры",
  "vehicles": "Траспортные ср-ва",
  "date": "",
  "travelClass.title": "",
  "giftCard": "Сертификат",
  "SIGN_IN": "Войти",
  "button.book.a.trip": "Забронировать поездку",
  "price.total": "Итого",
  "clubOne.points.price": "",
  "error.title": "",
  "button.close": "",
  "calendar.choose.date": "",
  "itinerary.miniCruise": "Мини-круиз",
  "TAL-HEL.CRUISE": "9h круиз",
  "timetable.oneWay": "В одном направлении",
  "timetable.roundtrip": "Туда-обратно",
  "button.done": "Готово",
  "pets": "домашние животные",
  "label.see.details": "",
  "common.language.KO": "",
  "common.language.ZH": "",
  "common.language.JA": "",
  "header.chooseYourLanguage": "",
  "pageNotFound.title": "Мы тщательно осмотрели все уголочки сайта… ",
  "pageNotFound.subtitle": "К сожалению, мы не смогли найти страницу, которую Вы искали.",
  "goBack": "Назад",
  "label.info": "",
  "itinerary.title": "",
  "itinerary.description": "",
  "extraServices.button.soldOut": "Нет в наличии",
  "button.cancel": "Отменить",
  "abbreviation.hour": "",
  "cruise": "Круиз",
  "HEL-TAL.CRUISE": "22h круиз",
  "form.error.required": "",
  "form.error.min": "",
  "form.error.max": "",
  "form.error.minLength": "",
  "form.error.maxLength": "",
  "sailLeg.sailTime": "{{date, eee', <b>'dd.MM' в <br>'HH:mm'</b>'}}",
  "timetable.tripTypeAndDeparture": "",
  "timetable.calendar": "",
  "timetable.table.departureAndArrival": "",
  "timetable.table.duration": "",
  "timetable.table.vessel": "",
  "clubOne.slider.label": "",
  "button.proceed": "",
  "label.loading": "",
  "sailLeg.sailTime.short": "{{дата, '<b>'дд.ММ'</b> в <b>'ЧЧ:мм'</b>'}}",
  "clubOne.slider.description": "",
  "specialCruise": "",
  "cabin": "кабина",
  "lounges": "гостиные",
  "cabins": "каюты",
  "specialCabins": "специальные каюты",
  "specialCabin.tag.handicap": "Доступный",
  "specialCabin.tag.allergy": "Подходит для аллергиков",
  "voucher": "Ваучер",
  "serialTicket": "Серийный билет",
  "summary": "",
  "contact": "",
  "booking": "",
  "payment": "",
  "free": "",
  "guest": "пассажир",
  "guest.count": "",
  "cabin.count": "",
  "form.firstName": "",
  "form.lastName": "",
  "CO.number": "",
  "dateOfBirth": "",
  "gender": "",
  "guest.details": "",
  "nationality": "",
  "specialAssistance": "",
  "payButton": "",
  "loading": "Пожалуйста, подождите...",
  "male": "",
  "female": "",
  "citizenship.estonian": "",
  "notRequired": "",
  "ELECTRIC WHEELCHAIR": "",
  "VISUALLY IMPAIRED": "",
  "HEARING IMPAIRED": "",
  "OTHER REASON FOR ASSISTANCE": "",
  "GUIDEDOG": "",
  "WHEELCHAIR": "",
  "button.ok": "OK",
  "errorPage.title": "Произошла ошибка!",
  "form.error.email": "",
  "form.error.positiveInteger": "Разрешены только цифры",
  "form.error.date": "Дата недействительна",
  "form.error.name": "",
  "form.error.clubOne": "",
  "clubOneApplied": "",
  "form.signInToUseYourBonusPoints": "",
  "optional": "Необязательный",
  "form.error.positiveFloat": "Разрешены только числа или десятичные значения.",
  "AD": "Андорра",
  "AE": "Объединенные Арабские Эмираты",
  "AF": "Афганистан",
  "AG": "Антигуа и Барбуда",
  "AI": "Ангилья",
  "AL": "Албания",
  "AM": "Армения",
  "AN": "Нидерландские Антильские о-ва",
  "AO": "Ангола",
  "AQ": "Антарктида",
  "AR": "Аргентина",
  "AS": "Восточное Самоа",
  "AT": "Австрия",
  "AU": "Австралия",
  "AW": "Аруба",
  "AZ": "Азербайджан",
  "BA": "Босния и Герцеговина",
  "BB": "Барбадос",
  "BD": "Бангладеш",
  "BE": "Бельгия",
  "BF": "Буркина-Фасо",
  "BG": "Болгария",
  "BH": "Бахрейн",
  "BI": "Бурунди",
  "BJ": "Бенин",
  "BM": "Бермудские о-ва",
  "BN": "Бруней Даруссалам",
  "BO": "Боливия",
  "BR": "Бразилия",
  "BS": "Багамские о-ва",
  "BT": "Бутан",
  "BW": "Ботсвана",
  "BY": "Беларусь",
  "BZ": "Белиз",
  "CA": "Канада",
  "CC": "Кокосовые о-ва",
  "CD": "Конго (ДРК)",
  "CF": "Центральная Африканская Республика",
  "CG": "Конго",
  "CH": "Швейцария",
  "CI": "Кот-д'Ивуар",
  "CK": "О-ва Кука",
  "CL": "Чили",
  "CM": "Камерун",
  "CN": "Китай",
  "CO": "Колумбия",
  "CR": "Коста-Рика",
  "CS": "Сербия",
  "CU": "Куба",
  "CV": "Кабо-Верде",
  "CX": "О. Рождества",
  "CY": "Кипр",
  "CZ": "Чехия",
  "DE": "Германия",
  "DJ": "Джибути",
  "DK": "Дания",
  "DM": "Доминика",
  "DO": "Доминиканская Республика",
  "DZ": "Алжир",
  "EC": "Эквадор",
  "EE": "Эстония",
  "EG": "Египет",
  "EH": "Западная Сахара",
  "ER": "Эритрея",
  "ES": "Испания",
  "ET": "Эфиопия",
  "FI": "Финляндия",
  "FJ": "О-ва Фиджи",
  "FK": "Фолклендские острова",
  "FM": "Федеративные Штаты Микронезии",
  "FO": "Фарерские о-ва",
  "FR": "Франция",
  "GA": "Габон",
  "GB": "Соединённое Королевство Великобритании",
  "GD": "Гренада",
  "GE": "Грузия",
  "GF": "Гвиана",
  "GH": "Гана",
  "GI": "Гибралтар",
  "GL": "Гренландия",
  "GM": "Гамбия",
  "GN": "Гвинея",
  "GP": "Гваделупа",
  "GQ": "Экваториальная Гвинея",
  "GR": "Греция",
  "GS": "Южная Георгия и Южные Сандвичевы о-ва",
  "GT": "Гватемала",
  "GU": "О. Гуам",
  "GW": "Гвинея-Бисау",
  "GY": "Гайана",
  "GZ": "Сектор Газа",
  "HK": "Гонконг (ОАР)",
  "HM": "О-ва Херд и Макдональд",
  "HN": "Гондурас",
  "HR": "Хорватия",
  "HT": "Гаити",
  "HU": "Венгрия",
  "ID": "Индонезия",
  "IE": "Ирландия",
  "IL": "Израиль",
  "IN": "Индия",
  "IO": "Британские территории в Индийском океане",
  "IQ": "Ирак",
  "IR": "Исламская Республика Иран",
  "IS": "Исландия",
  "IT": "Италия",
  "JM": "Ямайка",
  "JO": "Иордания",
  "JP": "Япония",
  "KE": "Кения",
  "KG": "Республика Кыргызстан",
  "KH": "Камбоджа",
  "KI": "Кирибати",
  "KM": "Коморские о-ва",
  "KN": "Сент-Китс и Невис",
  "KP": "Северная Корея",
  "KR": "Республика Корея",
  "KW": "Кувейт",
  "KY": "Каймановы о-ва",
  "KZ": "Казахстан",
  "LA": "Лаосская Народно-Демократическая Республика",
  "LB": "Ливан",
  "LC": "Сент-Люсия",
  "LI": "Лихтенштейн",
  "LK": "Шри-Ланка",
  "LR": "Либерия",
  "LS": "Лесото",
  "LT": "Литва",
  "LU": "Люксембург",
  "LV": "Латвия",
  "LY": "Ливийская Арабская Джамахирия",
  "MA": "Марокко",
  "MC": "Монако",
  "MD": "Молдавия",
  "ME": "Монтенегро",
  "MG": "Мадагаскар",
  "MH": "Маршалловы о-ва",
  "MK": "Македония, ФРЮ",
  "ML": "Мали",
  "MM": "Мьянма (Бирма)",
  "MN": "Монголия",
  "MO": "Макао",
  "MP": "Северные Марианские о-ва",
  "MQ": "Мартиника",
  "MR": "Мавритания",
  "MS": "о. Монтсеррат",
  "MT": "Мальта",
  "MU": "Маврикий",
  "MV": "Мальдивы",
  "MW": "Малави",
  "MX": "Мексика",
  "MY": "Малайзия",
  "MZ": "Мозамбик",
  "NC": "о. Новая Каледония",
  "NE": "Нигер",
  "NF": "О. Норфолк",
  "NG": "Нигерия",
  "NI": "Никарагуа",
  "NL": "Нидерланды",
  "NO": "Норвегия",
  "NP": "Непал",
  "NR": "Науру",
  "NU": "о. Ниуэ",
  "NZ": "Новая Зеландия",
  "OM": "Оман",
  "OT": "Другое",
  "PA": "Панама",
  "PE": "Перу",
  "PF": "Французская Полинезия",
  "PG": "Папуа - Новая Гвинея",
  "PH": "Филиппины",
  "PK": "Пакистан",
  "PL": "Польша",
  "PM": "Сен-Пьер и Микелон",
  "PN": "о. Питкэрн",
  "PR": "Пуэрто-Рико",
  "PS": "",
  "PT": "Португалия",
  "PW": "о-ва Палау",
  "PY": "Парагвай",
  "QA": "Катар",
  "RE": "Реюньон",
  "RO": "Румыния",
  "RS": "",
  "RU": "Россия",
  "RW": "Руанда",
  "SA": "Саудовская Аравия",
  "SB": "Соломоновы о-ва",
  "SC": "Сейшельские о-ва",
  "SD": "Судан",
  "SE": "Швеция",
  "SG": "Сингапур",
  "SH": "О. Святой Елены",
  "SI": "Словения",
  "SJ": "Шпицберген и о-ва Ян Майен",
  "SK": "Словакия",
  "SL": "Сьерра-Леоне",
  "SM": "Сан-Марино",
  "SN": "Сенегал",
  "SO": "Сомали",
  "SR": "Суринам",
  "ST": "Демократическая Республика Сан-Томе и Принсипи",
  "SV": "Сальвадор",
  "SY": "Сирийская Арабская Республика",
  "SZ": "Свазиленд",
  "TA": "Таити",
  "TC": "О-ва Теркс и Кайкос",
  "TD": "Чад",
  "TF": "Французские Южные и Антарктические территории",
  "TG": "Того",
  "TH": "Таиланд",
  "TJ": "Таджикистан",
  "TK": "о-ва Токелау",
  "TL": "Восточный Тимор",
  "TM": "Туркменистан",
  "TN": "Тунис",
  "TO": "Тонга",
  "TR": "Турция",
  "TT": "Тринидад и Тобаго",
  "TV": "Тувалу",
  "TW": "Тайвань",
  "TZ": "Танзания",
  "UA": "Украина",
  "UG": "Уганда",
  "UM": "Малые Отдаленные о-ва США",
  "US": "Соединенные Штаты Америки",
  "UY": "Уругвай",
  "UZ": "Узбекистан",
  "VA": "Ватикан",
  "VC": "Сент-Винсент и Гренадины",
  "VE": "Венесуэла",
  "VG": "Британские Виргинские о-ва",
  "VI": "Виргинские Острова США",
  "VN": "Вьетнам",
  "VU": "Вануату",
  "WE": "Западный берег и сектор Газа",
  "WF": "Уоллис и Футуна",
  "WS": "Самоа",
  "XK": "Косово",
  "XZ": "Международная зона",
  "YE": "Йемен",
  "YT": "О. Майотта",
  "YU": "ЮГОСЛАВИЯ",
  "ZA": "Южно-Африканская Республика",
  "ZM": "Замбия",
  "ZR": "Конго",
  "ZW": "Зимбабве",
  "ZZ": "Неопределенное",
  "reservationFee": "Плата за бронирование",
  "reserveTable": "Зарезервировать стол",
  "reserved": "Сдержанный",
  "footer.copyright": "© AS Tallink Grupp {{year}}",
  "button.changeBooking": "Изменить бронирование",
  "payment.unsuccessful.callCenter": "Поддержка клиентов по телефону <b><a href=\"tel:+372 640 9804\">+372 640 9804</a></b>, часы работы с Понедельника по Пятницу с 09:00 до 18:00 (эстонское время)",
  "payment.klarnaAndSwish.title": "Klarna & Swish",
  "payment.klarna.description": "Invoice, part payment",
  "payment.onlineBank.title": "Online bank",
  "payment.onlineBankAndCards.title": "Online bank & Debit/credit card",
  "payment.cards.title": "Debit/credit card",
  "payment.onlineBanks.title": "Интернет-банк",
  "payment.BANK.description": "Banks",
  "payment.MOBILE_PAY.description": "MobilePay",
  "payment.GOOGLE_PAY.description": "Google Pay",
  "payment.APPLE_PAY.description": "Apple Pay",
  "payment.onlineBanks.description": "Все доступные банки ",
  "errorPage.description": "Произошла ошибка. Пожалуйста, перезагрузите страницу. Внимание! При обновлении страницы вся ранее указанная информация будет утеряна. При повторном возникновении ошибки, пожалуйста, свяжитесь с поддержкой по телефону +372 640 9808.<br> Приносим извинения за возможные неудобства.",
  "payment.CARD.description": "Cards",
  "SERIAL COMFORT": "Билеты для пассажиров Comfort Lounge",
  "SERIAL PASSENGER": "Билеты класса Star",
  "SERIAL BUSINESS": "Билеты для путешественников в бизнес-зал",
  "SERIAL CAR/CAR XL": "Штрафы за нарушение правил дорожного движения",
  "SERIAL VAN": "Билеты на микроавтобус",
  "available.codes": "Доступные коды",
  "used.codes": "Использованные коды",
  "ticket.expiry.notice": "Срок действия следующих билетов истекает",
  "vehicle.type.extra-long-and-high.title": "Автомобиль с прицепом",
  "accessibility": "Доступность",
  "cancelCover": "Отменить обложку",
  "clubOneDiscount": "Скидка Club One",
  "button.payNow": "Оплатить сейчас",
  "button.joinClubOne": "Присоединяйтесь к Club One",
  "price.toBePaid": "Подлежит оплате",
  "price.subtotal": "Промежуточный итог",
  "price.alreadyPaid": "Уже оплачено",
  "copy.coupon.to.clipboard.accessibility.label": "Скопировать код купона в буфер обмена",
  "price.chargeFee": "Плата за изменение бронирования",
  "expired.codes": "Коды с истекшим сроком действия",
  "button.buy.cta": "Купить серийные билеты",
  "no.codes.available": "У вас нет кодов, доступных для использования",
  "accessibility.icon.aria-label": "Прочитайте наше заявление о доступности",
  "pet.count": "",
  "accessibility.url": "https://www.tallink.com/ru/dostupnost",
  "aLaCarteVoucher.withValue": "{{value}} Ваучер на питание по меню",
  "timeOfDay": "{{date, HH:mm}}",
  "dayWithTimeOfDay": "{{date, еее' в 'HH:mm}}",
  "aLaCarteVoucher": "Ваучер на заказ блюд",
  "ticket.expired": "Билеты истекли",
  "tooltip.accessibility.label": "Открыть подсказку",
  "couponPage.login.cta": "Чтобы увидеть купленные серийные билеты, пожалуйста, <login>войдите в систему</login>.",
  "button.downloadFile": "Загрузить файл ({{extension}})"
} },
sv: { translation: {
  "common.buyTickets": "Köp biljetter",
  "common.cancel": "avbryt",
  "common.done": "klart",
  "common.ok": "ok",
  "clubOne.level": "Club One {{level}}",
  "clubOne.points.points": "p",
  "clubOne.points.hint": "Du kan använda Club One-poäng till bonusresor.",
  "clubOne.switchToCompanyCustomer.warning": "Du loggas ut.",
  "clubOne.switchToCompanyCustomer.title": "Byt till företagskund",
  "clubOne.loginLink": "Logga in på Club One",
  "clubOne.title": "Club One-medlem",
  "companyCustomer.agentId": "Kundnummer",
  "companyCustomer.agentId.error": "Kundnumret kan inte hittas",
  "companyCustomer.agentId.pattern": "",
  "companyCustomer.error": "Företagsnumret kan inte hittas",
  "companyCustomer.id": "Företagsnr",
  "companyCustomer.login": "Logga in",
  "companyCustomer.title": "Företagskund",
  "deliveryDetails.clubOneAnonymous.text": "Biljetterna skickas till e-postadressen som angetts nedan.",
  "deliveryDetails.clubOneLogged.text": "Biljetterna skickas till e-postadressen nedan.",
  "deliveryDetails.companyCustomerAnonymous.text": "Biljetterna skickas till e-postadressen nedan.",
  "deliveryDetails.companyCustomerLogged.text": "Biljetterna skickas till e-postadressen nedan.",
  "deliveryDetails.form.email.label": "e-postadress",
  "deliveryDetails.form.error.emailPattern": "Adressen verkar vara ofullständig.",
  "deliveryDetails.form.error.namePattern": "Bokstäver, ' och - kan användas för namn.",
  "deliveryDetails.form.error.required": "Detta fält måste fyllas i.",
  "deliveryDetails.form.firstName.label": "förnamn",
  "deliveryDetails.form.lastName.label": "efternamn",
  "deliveryDetails.title": "Leveransuppgifter",
  "description.passenger": "En seriebiljett för passagerare gäller för en passagerare som reser enkel väg.",
  "description.vehicle": "En seriebiljett för fordon gäller för enkel väg för ett fordon, passagerare ingår inte i biljetten.",
  "hero.mainTitle": "Seriebiljetter",
  "hero.subtitle": "En seriebiljett gäller för en passagerare/ett fordon som reser enkel väg i vald riktning.",
  "hint.clubOne.error": "Ett fel inträffade, försök att uppdatera sidan eller fortsätt utan att logga in. Vi ber om ursäkt för besväret.",
  "hint.clubOne.text": "Club One-medlemmar får rabatter och samlar bonuspoäng som kan användas till nya resor. <a href=\"https://www.tallinksilja.se/om-club-one\" target=\"_blank\">Läs mer och bli medlem.</a>",
  "mainPage.title": "Seriebiljetter",
  "mobile.back": "← Tillbaka",
  "mobile.done": "Bekräfta",
  "price.description": "Biljetter",
  "price.amount": "Summa",
  "price.discount": "Rabatt",
  "price.price": "Pris",
  "price.regular": "Ordinarie pris",
  "price.giftCard": "Presenkort",
  "serialTicketName.passenger.business": "Biljett i Business Lounge",
  "serialTicketName.passenger.comfort": "Biljett i Comfort Lounge",
  "serialTicketName.passenger.star": "Biljett i Star Class",
  "serialTicketName.vehicle.CAR": "biljett för bil\n(upp till ↔5 m ↕1,9 m)",
  "serialTicketName.vehicle.CAR XL": "biljett för bil\r\n(upp till ↔5,5 m ↕2,4 m)",
  "serialTicketName.vehicle.VAN": "biljett för skåpbil\r\n(upp till ↔7 m ↕2,4 m)",
  "signIn.button": "logga in",
  "signOut.link": "logga ut →",
  "signInWithCompanyId.link": "logga in med företagsnummer →",
  "srt.termsAndConditions.title": "Villkor för Tallink Shuttle-seriebiljetter",
  "termsAndConditions.text": "<li>Seriebiljetter gäller för 8, 14 eller 24 enkelresor på linjen Tallinn-Helsingfors eller Helsingfors-Tallinn.</li>\n<li>Seriebiljetter gäller på alla avgångar på linjen Tallinn-Helsingfors eller Helsingfors-Tallinn.</li>\n<li>Seriebiljetter är inte personliga och kan delas med vänner, familj och kollegor.</li>\n<li>En seriebiljett för passagerare gäller för en passagerare enkel väg. </li>\n<li>En seriebiljett för fordon gäller för ett fordon enkel väg och inkluderar inte en passagerarbiljett. </li>\n<li>Seriebiljetter är giltiga i ett år.</li>\n<li>Seriebiljetter kan köpas genom Tallinks försäljningsställen, kundservice och hemsida. </li>\n<li>Med seriebiljett kan du köpa en resa genom Tallinks försäljningsställen, kundtjänst och hemsida. </li>\n<li>Du kan använda upp till sex seriebiljetter på en bokning. </li>\n<li>Vid onlinebokning är seriebiljetten giltig från den första delen av resan</li>\n<li>Ingen straffavgift tillkommer vid ändring av biljett som är betald med seriebiljett, ändringar kan göras fram till slutet av incheckning.</li>",
  "type.passenger": "passagerarbiljetter",
  "type.vehicle": "bilbiljetter",
  "voucherPanel.header": "Presentkort",
  "voucherPanel.link.addAnotherVoucher": "+ Lägg till en annan kod",
  "voucherPanel.link.addVoucher": "Jag har bokningskod eller presentkort",
  "voucherPanel.voucher.button.add": "Lägg till",
  "voucherPanel.voucher.hint": "Presentkortet kan användas flera gånger tills saldot tar slut.<br>\r\nPresentkortet har <b>{{amountLeft}} €</b>.<br>\r\nGiltigt t o m <b>{{expirationDate}}</b>.",
  "voucherPanel.voucher.label": "Bokningskod",
  "voucherPanel.voucher.validate.callToCallCenter": "För att använda presentkortet ring +46 8 22 21 40",
  "voucherPanel.voucher.validate.error": "Kontrollera koden",
  "payment.unsuccessful.description": "Något gick fel under betalningsprocessen. Se till att kontot har tillräckligt med pengar och försök igen.",
  "payment.unsuccessful.title": "betalning misslyckades",
  "payment.cancelled.title": "Bokningen är obetald",
  "payment.title": "Betalning",
  "payment.paymentServiceMethods.title": "Kort",
  "payment.paymentServiceMethods.combined.title": "Bank / Kort",
  "payment.disclaimer": "Genom att slutföra bokningen intygar du att du har tagit del av och godkänt våra <a href=\"https://www.tallinksilja.se/bra-att-veta/resevillkor\" target=\"_blank\">villkor</a> och <a href=\"https://se.tallink.com/bra-att-veta/ordningsregler\" target=\"_blank\">ordningsregler</a>. Passagerare under 18 år, vänligen kom ihåg att läsa våra <a href=\"https://www.tallinksilja.se/bra-att-veta/aldersregler\" target=\"_blank\">åldersregler</a>.",
  "payment.disclaimer.Extra.TallinkGrupp": "Passagerare under 18 år, vänligen kom ihåg att läsa våra <a href=\"https://se.tallink.com/bra-att-veta/aldersregler\" target=\"_blank\">åldersregler</a>. Genom att slutföra bokningen intygar du att du har tagit del av och godkänt våra <a href=\"https://www.tallinksilja.se/bra-att-veta/resevillkor\" target=\"_blank\">villkor</a> och <a href=\"https://se.tallink.com/bra-att-veta/ordningsregler\" target=\"_blank\">ordningsregler</a>.<br>\nDe kombinerade resetjänster du erbjuds utgör en paketresa i den mening som avses i direktiv (EU) 2015/2302.<br>\nDärför omfattas du av alla EU-rättigheter som gäller för paketresor. Företag AS Tallink Grupp kommer att ansvara fullt ut för att paketresan som helhet fullgörs korrekt.<br>\nDessutom har företag AS Tallink Grupp, enligt lag, ett skydd för att återbetala dina betalningar och, när transport ingår i paketresan, säkerställa din hemtransport om det eller de hamnar på obestånd.<br>\n<a href=\"https://www.tallinksilja.se/informationsformular-paketresor-tallink-grupp\" target=\"_blank\">Se hela Informationsformuläret för paketresor - Tallink Grupp</a>\n",
  "payment.disclaimer.Extra.TallinkSiljaOY": "Passagerare under 18 år, vänligen kom ihåg att läsa våra <a href=\"https://se.tallink.com/bra-att-veta/aldersregler\" target=\"_blank\">åldersregler</a>. Genom att slutföra bokningen intygar du att du har tagit del av och godkänt våra <a href=\"https://www.tallinksilja.se/bra-att-veta/resevillkor\" target=\"_blank\">villkor</a> och <a href=\"https://se.tallink.com/bra-att-veta/ordningsregler\" target=\"_blank\">ordningsregler</a>.<br>\nDe kombinerade resetjänster du erbjuds utgör en paketresa i den mening som avses i direktiv (EU) 2015/2302.<br>\nDärför omfattas du av alla EU-rättigheter som gäller för paketresor. Företag Tallink Silja Oy kommer att ansvara fullt ut för att paketresan som helhet fullgörs korrekt.<br>\nDessutom har företag Tallink Silja Oy, enligt lag, ett skydd för att återbetala dina betalningar och, när transport ingår i paketresan, säkerställa din hemtransport om det eller de hamnar på obestånd.<br>\n<a href=\"https://se.tallink.com/informationsformular-paketresor-tallink-silja\" target=\"_blank\">Se hela Informationsformuläret för paketresor - Tallink Silja Oy</a>\n",
  "passengerDistribution.errors.WITHOUT_ADULT": "Minst en vuxen krävs per hytt",
  "passengerDistribution.errors.WITHOUT_CABIN": "Fördela resterande {nrOfPassengersWithoutCabin} {nrOfPassengersWithoutCabin, plural, =0{passagerare} one{passagerare} other{passagerare}} i hytter.",
  "passengerDistribution.notification.childWithoutOwnBed": "Barnet har inte en egen säng.",
  "payment.klarna.title": "Klarna",
  "payment.onlineBanks.list.aktia": "Aktia",
  "payment.onlineBanks.list.alandsbanken": "Ålandsbanken",
  "payment.onlineBanks.list.coop": "COOP Pank",
  "payment.onlineBanks.list.danskebankEE": "Danske Bank",
  "payment.onlineBanks.list.danskebankFI": "Danske Bank",
  "payment.onlineBanks.list.handelsbanken": "Handelsbanken",
  "payment.onlineBanks.list.kultaraha": "Osuuspankki",
  "payment.onlineBanks.list.lahitapiola": "LähiTapiola",
  "payment.onlineBanks.list.lhv": "LHV",
  "payment.onlineBanks.list.luminor": "Luminor",
  "payment.onlineBanks.list.nordea": "Nordea",
  "payment.onlineBanks.list.saastopankki": "Säästöpankki",
  "payment.onlineBanks.list.seb": "SEB",
  "payment.onlineBanks.list.spankki": "S-Pankki",
  "payment.onlineBanks.list.swedbank": "Swedbank",
  "payment.invoice.title": "Betalningsalternativ",
  "payment.type.invoice": "Jag vill betala med faktura",
  "payment.reference.title": "Referensnummer",
  "payment.reference.disclaimer": "Genom att slutföra bokningen godkänner du våra <a href=\"https://se.tallink.com/bra-att-veta/resevillkor\" target=\"_blank\">villkor</a> och <a href=\"https://se.tallink.com/bra-att-veta/ordningsregler\" target=\"_blank\">ordningsregler</a>.",
  "payment.type.card": "Jag vill betala med kort",
  "payment.klarna.options.title": "Klarna erbjuder följande betalningsalternativ:",
  "payment.klarna.options.list": "<li>Swish</li><li>Faktura</li><li>Delbetalning</li>",
  "payment.klarna.policy": "Genom att bekräfta denna bokning godkänner du att dina bokningsuppgifter kommer att överföras till Klarna för kontroll av tillgängliga betalningsalternativ. <a href=\"https://cdn.klarna.com/1.0/shared/content/policy/data/sv_se/privacy_statement.pdf\" target=\"_blank\">Läs mer om Klarnas användning av dina uppgifter</a>.",
  "payment.klarna.mobile.title": "Med Klarna betalar du enkelt och säkert via mobilen.",
  "paymentPage.total": "Totalt",
  "paymentPage.confirm.freeReservation": "Bekräfta bokning",
  "paymentPage.confirm.onlyPayment": "Betala",
  "paymentPage.confirm.onlyPayment.withInvoice": "Bekräfta",
  "confirmation.thankYouCallout.title": "Tack för din betalning!",
  "confirmation.thankYouCallout.paidTotal": "betald summa",
  "confirmation.thankYouCallout.message": "Betalningen gick igenom och bokningen är bekräftad. Läs bokningsbekräftelsen (PDF skickad till <b>{{email}}</b>) för att kontrollera alla uppgifter.",
  "confirmation.orderConfirmation": "Bokningsbekräftelse",
  "confirmation.summary.downloadPdf": "Ladda ner PDF",
  "confirmation.summary.bookTrip": "boka resa",
  "confirmation.summary.disclaimer": "Du kan använda ditt köp direkt. Boka din resa nu.",
  "confirmation.summary.email": "E-postadress",
  "confirmation.summary.contactPerson": "Kontaktperson",
  "confirmation.summary.securityCode": "Säkerhetskod",
  "confirmation.summary.orderNumber": "Bokningsnummer",
  "otherPaymentMethod": "Annat betalsätt",
  "paymentMethod": "Betalsätt",
  "remove": "Ta bort",
  "answer.yes": "Ja",
  "answer.no": "Nej",
  "button.send": "Skicka",
  "button.withoutPrice.notChosen": "Välj",
  "button.withoutPrice.chosen": "Vald",
  "button.add": "Lägg till",
  "clubOne.level.BRONZE": "Brons",
  "clubOne.level.SILVER": "Silver",
  "clubOne.level.GOLD": "Guld",
  "clubOne.level.title": "Club One",
  "currency.EUR": "€",
  "currency.LAT": "Ls",
  "currency.LVL": "Ls",
  "currency.RUB": "€",
  "currency.SEK": "kr",
  "dateFormat.dayOfWeekDayMonthAndTime": "{weekday} <b>{date}</b> kl <b>{time}</b>",
  "decimalSeparator": ",",
  "details.dayMonthAndTime.pattern": "d.m. \\\\k\\\\l H:i",
  "details.dayOfWeek.pattern": "l",
  "entertainment.title": "Underhållning ombord",
  "entertainment.sitting": "Plats",
  "error.chromeframe.label": "Eller du kan installera på nuvarande webbläsare Googles",
  "entertainment.sittingGroup.premium.name\r\n": "Premiumpaket",
  "entertainment.sittingGroup.premium.description": "Premiumplatserna har fri utsikt över scenen. Välj tilläggspaket enligt önskemål.",
  "entertainment.sittingGroup.basic.name\r\n": "Endast platsbokning",
  "entertainment.sittingGroup.basic.description": "Platser med begränsad sikt. För bästa placering, vänligen boka något av premiumpaketen ovan. ",
  "entertainment.sittingGroup.basic.addOn.name\r\n": "Plats med begränsad sikt",
  "error.chromeframe.link": "Chrome Frame-förlängning",
  "error.ie": "Du använder en gammal version av Internet Explorer som Tallink Silja Lines onlinebokning inte stöder. Vi rekommenderar att uppdatera till säkrare och snabbare webbläsare. Du kan till exempel ladda ner en av följande webbläsare",
  "error.notPossibleToChangeBookingOnline": "Tyvärr är det inte möjligt att göra ändringar i din bokning online.<br><br>Om du behöver göra några ändringar, skriv till vår <a href=\"mailto:info.sweden@tallinksilja.com\">kundtjänst</a> eller ring 08-22 21 40.<br>Om du befinner dig utomlands, ring +46(0)8-22 21 40.",
  "form.email": "E-post",
  "form.phone": "Telefon",
  "format.LocalDayMonth": "{{date, dd.MM}}",
  "format.LocalShortWeekdayAndDayMonth": "D d.m.",
  "format.LocalLongWeekdayAndDayMonth": "l d.m.",
  "format.LocalShortWeekdayAndShortMonth": "D MMMM",
  "format.LocalDayMonthYear": "d.m.Y",
  "header.bookingNumber": "Bokningsnummer",
  "header.logout": "Logga ut",
  "header.myBooking": "Min bokning",
  "header.pin": "Kontrollnummer",
  "hotel.checkInTime": "Checka in",
  "hotel.checkOutTime": "Checka ut",
  "nights": "nätter",
  "night": "natt",
  "hotelsItinerary.returnTripIsNotAvailable": "Hemresa är inte tillgänglig. Var vänlig ändra sista datumet för rummet.",
  "label.remove": "Ta bort",
  "landServices.title": "Tillval i land",
  "landService.ageCategory.base": "Ordinarie",
  "landService.ageCategory.child": "Barn {ageCategory} år",
  "landService.dateTime.pattern": "d.m.Y",
  "meals.packages.choosePackage": "Välj måltidspaket",
  "meals.packages.title": "Köp måltidspaket och spara pengar",
  "meals.packages.commonInfo": "I måltidspaketet ingår måltider för hela resan.",
  "meals.packages.description": "Barn 6–17 år äter till rabatterat pris och barn 0–5 år äter gratis i Grande Buffet med betalande vuxen. Är sittingen utsåld läggs kuponger (samma värde) till på bokningen. Måltidskuponger kan även användas som betalning på fartygets alla restauranger.",
  "meals.button.freeMealPackages": "Ingår",
  "meals.selectionMealBlockedByTime": "Måltid kan inte bokas om tiden är mindre än 4 timmar före avgång, men måltider kan fortfarande köpas ombord.",
  "onboardServices.title": "Tillval ombord",
  "adults": "vuxna",
  "adult": "vuxen",
  "child": "barn",
  "junior": "Junior",
  "youth": "Ungdom",
  "children": "barn",
  "guests.edit.accessibility.label": "Ändra passagerarinfo",
  "pier.DTER.address": "Lootsi 13 ,10151 Tallinn",
  "pier.DTER.title": "D-Terminalen",
  "pier.FHAM.address": "Frihamnen, Magasin 2, 10253 Stockholm",
  "pier.FHAM.title": "Frihamnen",
  "pier.HND.title": "Härnösand",
  "pier.HND.address": "Skeppsbron 31, 871 80 Härnösand",
  "pier.LNAS.address": "Långnäs terminal, Lumparland",
  "pier.LNAS.title": "Långnäs",
  "pier.LSA2.address": "Västra hamnen, Helsingfors",
  "pier.LSA2.title": "Västra terminalen 2",
  "pier.LSA6.address": "Stillahavsgatan 8, 00220 Helsingfors",
  "pier.LSA6.title": "Västra terminalen 1",
  "pier.LSAT.address": "Stillahavsgatan 8, 00220 Helsingfors",
  "pier.LSAT.title": "Västra terminalen 1",
  "pier.MHAM.address": "Västra hamnen, Mariehamn",
  "pier.MHAM.title": "Mariehamn",
  "pier.MUUG.address": "Muuga hamn, Maardu Tee 65, Maardu",
  "pier.MUUG.title": "Muuga hamn",
  "pier.OLYM.address": "Södra hamnen FIN-00140 Helsingfors",
  "pier.OLYM.title": "Olympiaterminalen",
  "pier.PALD.address": "Rae põik 10, EE-76806 Paldiski",
  "pier.PALD.title": "Paldiski",
  "pier.KAPE.address": "Hamnterminalen, 760 15 Gräddö",
  "pier.KAPE.title": "Kapellskär",
  "pier.RIGA.address": "3a Eksporta Str. Riga, LV-1010",
  "pier.RIGA.title": "Rigaterminalen",
  "pier.TSAT.address": "Slottsgatan 91, 20100 Åbo",
  "pier.TSAT.title": "Siljaterminalen",
  "pier.VHAM.address": "Hamnpirsvägen 10, 11574 Stockholm",
  "pier.VHAM.title": "Värtaterminalen",
  "pier.VISH.title": "Visby",
  "pier.VISH.address": "Färjeleden 2, 621 81 Visby",
  "pier.VSAA.address": "Nordsjö, Sejlorgatan 5, Helsingfors",
  "pier.VSAA.title": "Nordsjö hamn",
  "pier.MFAC.address": "Bereg Nevskoy gubi 1., V.O., S:t Petersburg",
  "pier.MFAC.title": "S:t Petersburg",
  "pier.SAS.title": "Sassnitz",
  "pier.SMA1.title": "Ösel",
  "pier.SMA1.address": "Ninase by, Mustjala, 93631, Ösel",
  "pier.KLJ1.title": "Klaipeda",
  "pier.KLJ1.address": "J.Zauerveino g. 18, LT-92122 Klaipeda, Litauen",
  "port.KAP": "Kapellskär",
  "port.PAL": "Paldiski",
  "port.KLJ": "Klaipeda",
  "port.YST": "Ystad",
  "port.PARTY": "Östersjön",
  "refresh": "Uppdatera",
  "reservation.travelPermitForYouth": "Du som är 15–17 år kan resa utan medföljande vuxen. Kom ihåg att ta med ditt <a href=\"https://se.tallink.com/documents/10192/65608302/RESETILLSTA%CC%8AND_15-17+a%CC%8Ar_2017.pdf/6252db8f-61e6-4e85-9830-c2368ceba7a6\" target=\"_blank\">resetillstånd</a>. Trevlig resa!",
  "send.email.failed": "E-postmeddelandet kunde inte skickas. Försök igen.",
  "send.sms.failed": "Sms:et kunde inte skickas. Försök igen.",
  "summary.confirm": "Bekräfta",
  "summary.dateTime.pattern": "d.m.Y <\\\\sp\\\\a\\\\n>\\\\k\\\\l</\\\\sp\\\\a\\\\n> H:i",
  "summary.extraServices": "Kostnad för extra tjänster läggs till på totalpriset. Se pdf som skickades dig via email för mer information.",
  "summary.freeMealPackages.title": "Gratis tillägg",
  "summary.refund.notification": "Var vänlig kontakta kundtjänst för hjälp med din återbetalning. Tel. {phoneLocal}",
  "summary.refund.notification.with.phoneInternational": "Var vänlig kontakta kundtjänst för hjälp med din återbetalning. Tel. {phoneLocal} / {phoneInternational}",
  "summary.refund.notification.phoneInternational.EE": " +372 640 9808",
  "summary.refund.notification.phoneInternational.SE": " +46 8 22 21 40",
  "summary.refund.notification.phoneLocal": " +49 (0)40 547 541 222",
  "summary.refund.notification.phoneLocal.FI": "(09) 887 53121",
  "summary.refund.notification.phoneLocal.EE": " 17 808",
  "summary.refund.notification.phoneLocal.SE": "08 22 21 40",
  "summary.refund.notification.phoneLocal.LV": " +371 670 997 00",
  "summary.refund.notification.phoneLocal.RU": " + 372 611 8801",
  "summary.clearChanges.title": "Ändrat dig?",
  "summary.clearChanges.link": "Radera ändringar",
  "summary.overnightPackage": "Övernattningspaket",
  "template.dateTime": "{date} <span>kl</span> {time}",
  "time.preposition.at": "kl",
  "validate.firstName": "Förnnamn bör endast innehålla latinska tecken.",
  "validate.lastName": "Efternamn bör endast innehålla latinska tecken.",
  "location.hotelCityCode.HAA": "Hapsal",
  "location.hotelCityCode.HEL": "Helsingfors",
  "location.hotelCityCode.JUR": "Jurmala",
  "location.hotelCityCode.KOM": "Kolmården",
  "location.hotelCityCode.KUR": "Kuressaare",
  "location.hotelCityCode.LAL": "Laulasmaa",
  "location.hotelCityCode.MHQ": "Mariehamn",
  "location.hotelCityCode.NAR": "Narva",
  "location.hotelCityCode.NRK": "Norrköping",
  "location.hotelCityCode.OTE": "Otepää",
  "location.hotelCityCode.PAR": "Pärnu",
  "location.hotelCityCode.RAK": "Rakvere",
  "location.hotelCityCode.RIX": "Riga",
  "location.hotelCityCode.SOE": "Södertälje",
  "location.hotelCityCode.STO": "Stockholm",
  "location.hotelCityCode.TAR": "Tartu",
  "location.hotelCityCode.TKU": "Åbo",
  "location.hotelCityCode.TLL": "Tallinn",
  "location.hotelCityCode.TMP": "Tammerfors",
  "location.hotelCityCode.UPP": "Uppsala",
  "location.hotelCityCode.VAN": "Vanda",
  "location.hotelCityCode.VIH": "Vihula",
  "vehicle.type.bicycle.title": "Cykel, elsparkcykel",
  "vehicle.type.car.title": "Personbil",
  "vehicle.type.car-xl.title": "Personbil",
  "vehicle.type.long-and-high.title": "Högt fordon med släp",
  "vehicle.type.long-and-low.title": "Personbil med släp",
  "vehicle.type.long-and-medium.title": "Skåpbil med släp",
  "vehicle.type.motorcycle.title": "Motorcykel/ moped",
  "vehicle.type.motorcycle-with-sidecar.title": "Motorcykel med sidovagn",
  "vehicle.type.motorcycle-with-sidecar.measures": "Upp till 1,9 m hög och upp till 4 m lång",
  "vehicle.type.van-high.title": "Hög skåpbil/ husbil",
  "vehicle.type.parked-car.title": "Parkerad bil",
  "vehicle.type.van.title": "Skåpbil",
  "vehicle.type.parked-van.title": "Parkerad skåpbil",
  "vehicle.type.shopper-car.title": "Bil för shopping",
  "vehicle.type.shopper-van.title": "Skåpbil för shopping",
  "vehicle.type.shopper-car.notices": "- Nära tillgång till bilen under resan<br>- Parkerad nära butikerna",
  "vehicle.type.shopper-van.notices": "- Nära tillgång till fordonet under resan<br>- Parkerad nära butikerna",
  "vehicle.type.parked-car.notices": "- Ingen tillgång till bilen under resan<br>\r\n- Fordon kan inte köras av vid destinationen",
  "vehicle.type.parked-van.notices": "- Ingen tillgång till bilen under resan<br>\r\n- Fordon kan inte köras av vid destinationen",
  "vehicle.type.shopper-car.noDisembark": "Fordon kan inte köras i land",
  "vehicle.type.shopper-van.noDisembark": "Fordon kan inte köras i land",
  "vehicle.type.parked-car.noDisembark": "Ingen tid i land",
  "vehicle.type.under.measures": "<span class=\"height\"></span> {height} m <span class=\"width\"></span> {length} m",
  "wifi.title": "WiFi",
  "common.language.FI": "Finska",
  "common.language.ET": "Estniska",
  "common.language.EN": "Engelska",
  "common.language.RU": "Ryska",
  "common.language.SV": "Svenska",
  "common.language.DE": "Tyska",
  "common.language.LV": "Lettiska",
  "common.language.LT": "Litauiska",
  "label.or": "eller",
  "routePanel.from": "Från",
  "routePanel.to": "Till",
  "port.ALA": "Åland",
  "port.HEL": "Helsingfors",
  "port.MUG": "Muuga",
  "port.RIG": "Riga",
  "port.STO": "Stockholm",
  "port.TAL": "Tallinn",
  "port.TUR": "Åbo",
  "port.VIS": "Visby",
  "port.VSS": "Nordsjö",
  "port.SPE": "S:t Petersburg",
  "port.SAS": "Sassnitz",
  "port.SMA": "Ösel",
  "port.VNT": "Ventspils",
  "port.HND": "Härnösand",
  "button.edit": "Ändra",
  "guests": "passagerare",
  "vehicles": "Fordon",
  "date": "Datum",
  "travelClass.title": "Hyttkategorier & lounger",
  "giftCard": "Presentkort",
  "SIGN_IN": "Logga in",
  "button.book.a.trip": "Boka resa",
  "price.total": "Totalt",
  "clubOne.points.price": "och {{count}} poäng",
  "error.title": "Fel",
  "button.close": "Stäng",
  "calendar.choose.date": "Välj datum",
  "itinerary.miniCruise": "5h kryssning",
  "TAL-HEL.CRUISE": "9h kryssning",
  "timetable.oneWay": "Enkel väg",
  "timetable.roundtrip": "Tur och retur",
  "button.done": "Välj",
  "pets": "husdjur",
  "label.see.details": "Se uppgifter",
  "common.language.KO": "Koreanska",
  "common.language.ZH": "Kinesiska",
  "common.language.JA": "Japanska",
  "header.chooseYourLanguage": "Välj språk",
  "pageNotFound.title": "Vi försökte verkligen hitta det du letade efter... ",
  "pageNotFound.subtitle": "Tyvärr finns inte sidan du letar efter.\n",
  "goBack": "Tillbaka",
  "label.info": "Info",
  "itinerary.title": "Din resa",
  "itinerary.description": "När vill du resa?",
  "extraServices.button.soldOut": "Slutsåld",
  "button.cancel": "Avbryt",
  "abbreviation.hour": "{{hour}} h",
  "cruise": "Kryssning",
  "HEL-TAL.CRUISE": "22h kryssning",
  "form.error.required": "Obligatoriskt fält",
  "form.error.min": "Minsta tillåtna värde är {{min}}",
  "form.error.max": "Största tillåtna värde är {{max}}",
  "form.error.minLength": "Minsta tillåtna längd är {{minLength}}",
  "form.error.maxLength": "Största tillåtna längd är {{maxLength}}",
  "sailLeg.sailTime": "{{date, eee', <b>'dd.MM' kl <br>'HH:mm'</b>'}}",
  "timetable.tripTypeAndDeparture": "Resetyp & avgång",
  "timetable.calendar": "Kalender",
  "timetable.table.departureAndArrival": "Avgång / ankomst",
  "timetable.table.duration": "Restid",
  "timetable.table.vessel": "Fartyg",
  "clubOne.slider.label": "Använd Club One-poäng",
  "button.proceed": "Gå vidare",
  "label.loading": "Laddar",
  "sailLeg.sailTime.short": "{{date, '<b>'dd.MM'</b> kl <b>'HH:mm'</b>'}}",
  "clubOne.slider.description": "Max antal poäng som kan användas beräknas dynamiskt utifrån produkter och tjänster i din bokning.",
  "specialCruise": "",
  "cabin": "hytt",
  "lounges": "lounger",
  "cabins": "hytter",
  "specialCabins": "specialhytter",
  "specialCabin.tag.handicap": "Tillgänglighetsanpassad",
  "specialCabin.tag.allergy": "Allergianpassad",
  "voucher": "Bokningskod",
  "serialTicket": "Seriebiljett",
  "summary": "Din resa",
  "contact": "Kontaktuppgifter",
  "booking": "Bokning",
  "payment": "Betalning",
  "free": "Gratis",
  "guest": "passagerare",
  "guest.count": "{count, plural, =0 {# passagerare} =1 {# passagerare} other {# passagerare}}",
  "cabin.count": "{count, plural, =0 {# hytter} =1 {# hytt} other {# hytter}}",
  "form.firstName": "Förnamn",
  "form.lastName": "Efternamn",
  "CO.number": "Club One-nummer",
  "dateOfBirth": "Födelsedatum",
  "gender": "Kön",
  "guest.details": "Passageraruppgifter",
  "nationality": "Nationalitet",
  "specialAssistance": "Särskild assistans",
  "payButton": "Betala ",
  "loading": "Vänligen vänta...",
  "male": "Man",
  "female": "Kvinna",
  "citizenship.estonian": "Estnisk",
  "notRequired": "Behövs inte",
  "ELECTRIC WHEELCHAIR": "Elrullstol",
  "VISUALLY IMPAIRED": "Synnedsättning",
  "HEARING IMPAIRED": "Hörselnedsättning",
  "OTHER REASON FOR ASSISTANCE": "Annat",
  "GUIDEDOG": "Ledarhund",
  "WHEELCHAIR": "Rullstol",
  "button.ok": "OK",
  "errorPage.title": "Ett fel inträffade!",
  "form.error.email": "Ogiltig e-postadress",
  "form.error.positiveInteger": "Ange endast siffror",
  "form.error.date": "Ogiltigt datum",
  "form.error.name": "Använd endast latinska tecken.",
  "form.error.clubOne": "Ogiltigt Club One-nummer",
  "clubOneApplied": "Medlemskap tillagt.",
  "form.signInToUseYourBonusPoints": "",
  "optional": "Valfritt",
  "form.error.positiveFloat": "Endast siffror eller decimaler tillåtna",
  "AD": "Andorra",
  "AE": "Förenade Arabemiraterna",
  "AF": "Afghanistan",
  "AG": "Antigua och Barbuda",
  "AI": "Anguilla",
  "AL": "Albanien",
  "AM": "Armenien",
  "AN": "Nederländska Antillerna",
  "AO": "Angola",
  "AQ": "Antarktis",
  "AR": "Argentina",
  "AS": "Amerikanska Samoa",
  "AT": "Österrike",
  "AU": "Australien",
  "AW": "Aruba",
  "AZ": "Azerbadjan",
  "BA": "Bosnien Hercegovina",
  "BB": "Barbados",
  "BD": "Bangladesh",
  "BE": "Belgien",
  "BF": "Burkina Faso",
  "BG": "Bulgarien",
  "BH": "Bahrain",
  "BI": "Burundi",
  "BJ": "Benin",
  "BM": "Bermuda",
  "BN": "Brunei Darussalam",
  "BO": "Bolivia",
  "BR": "Brasilien",
  "BS": "Bahamas",
  "BT": "Bhutan",
  "BW": "Botswana",
  "BY": "Vitryssland",
  "BZ": "Belize",
  "CA": "Kanada",
  "CC": "Cocosöarna",
  "CD": "Kongo",
  "CF": "Centralafrikanska republiken",
  "CG": "Kongo",
  "CH": "Schweiz",
  "CI": "Elfenbenskusten",
  "CK": "Cooköarna",
  "CL": "Chile",
  "CM": "Kamerun",
  "CN": "Kina",
  "CO": "Colombia",
  "CR": "Costa Rica",
  "CS": "Serbien",
  "CU": "Kuba",
  "CV": "Kap Verde",
  "CX": "Julöarna",
  "CY": "Cypern",
  "CZ": "Tjeckien",
  "DE": "Tyskland",
  "DJ": "Djibouti",
  "DK": "Danmark",
  "DM": "Dominica",
  "DO": "Dominikanska Republiken",
  "DZ": "Algeriet",
  "EC": "Ecuador",
  "EE": "Estland",
  "EG": "Egypten",
  "EH": "Västsahara",
  "ER": "Eritrea",
  "ES": "Spanien",
  "ET": "Etiopien",
  "FI": "Finland",
  "FJ": "Fiji",
  "FK": "Falklandsöarna",
  "FM": "Mikronesien",
  "FO": "Färöarna",
  "FR": "Frankrike",
  "GA": "Gabon",
  "GB": "Storbritannien",
  "GD": "Grenada",
  "GE": "Georgien",
  "GF": "Franska Guyana",
  "GH": "Ghana",
  "GI": "Gibraltar",
  "GL": "Grönland",
  "GM": "Gambia",
  "GN": "Guinea",
  "GP": "Guadeloupe",
  "GQ": "Ekvatorialguinea",
  "GR": "Grekland",
  "GS": "Sydgeorgien och Sydsandwichöarna",
  "GT": "Guatemala",
  "GU": "Guam",
  "GW": "Guinea-Bissau",
  "GY": "Guyana",
  "GZ": "Gazaremsan",
  "HK": "Hong Kong",
  "HM": "Heard- och McDonaldöarna",
  "HN": "Honduras",
  "HR": "Kroatien",
  "HT": "Haiti",
  "HU": "Ungern",
  "ID": "Indonesien",
  "IE": "Irland",
  "IL": "Israel",
  "IN": "Indien",
  "IO": "Indian Ocean Territory",
  "IQ": "Irak",
  "IR": "Iran",
  "IS": "Island",
  "IT": "Italien",
  "JM": "Jamaica",
  "JO": "Jordanien",
  "JP": "Japan",
  "KE": "Kenya",
  "KG": "Kirgizistan",
  "KH": "Kambodja",
  "KI": "Kiribati",
  "KM": "Komorerna",
  "KN": "Saint Kitts och Nevis",
  "KP": "Nordkorea",
  "KR": "Sydkorea",
  "KW": "Kuwait",
  "KY": "Caymanöarna",
  "KZ": "Kazakstan",
  "LA": "Laos",
  "LB": "Libanon",
  "LC": "Saint Lucia",
  "LI": "Lichtenstein",
  "LK": "Sri Lanka",
  "LR": "Liberia",
  "LS": "Lesotho",
  "LT": "Litauen",
  "LU": "Luxemburg",
  "LV": "Lettland",
  "LY": "Libyen",
  "MA": "Marocko",
  "MC": "Monaco",
  "MD": "Moldavien",
  "ME": "Montenegro",
  "MG": "Madagaskar",
  "MH": "Marshallöarna",
  "MK": "Makedonien",
  "ML": "Mali",
  "MM": "Myanmar",
  "MN": "Mongoliet",
  "MO": "Macau",
  "MP": "Nordmarianerna",
  "MQ": "Martinique",
  "MR": "Mauritanien",
  "MS": "Montserrat",
  "MT": "Malta",
  "MU": "Mauritius",
  "MV": "Maldiverna",
  "MW": "Malawi",
  "MX": "Mexiko",
  "MY": "Malaysia",
  "MZ": "Moçambique",
  "NC": "Nya Kaledonien",
  "NE": "Niger",
  "NF": "Norfolksöarna",
  "NG": "Nigeria",
  "NI": "Nicaragua",
  "NL": "Nederländerna",
  "NO": "Norge",
  "NP": "Nepal",
  "NR": "Nauru",
  "NU": "Niue",
  "NZ": "Nya Zeeland",
  "OM": "Oman",
  "OT": "Övriga",
  "PA": "Panama",
  "PE": "Peru",
  "PF": "Franska Polynesien",
  "PG": "Papua Nya Guinea",
  "PH": "Filippinerna",
  "PK": "Pakistan",
  "PL": "Polen",
  "PM": "Saint-Pierre och Miquelon",
  "PN": "Pitcairnöarna",
  "PR": "Puerto Rico",
  "PS": "Palestina",
  "PT": "Portugal",
  "PW": "Palau",
  "PY": "Paraguay",
  "QA": "Qatar",
  "RE": "Réunion",
  "RO": "Rumänien",
  "RS": "Serbien",
  "RU": "Ryssland",
  "RW": "Rwanda",
  "SA": "Saudiarabien",
  "SB": "Solomonöarna",
  "SC": "Seychellerna",
  "SD": "Sudan",
  "SE": "Sverige",
  "SG": "Singapore",
  "SH": "Sankta Helena",
  "SI": "Slovenien",
  "SJ": "Svalbard och Jan Mayen",
  "SK": "Slovakien",
  "SL": "Sierra Leone",
  "SM": "San Marino",
  "SN": "Senegal",
  "SO": "Somalia",
  "SR": "Surinam",
  "ST": "São Tomé och Príncipe",
  "SV": "El Salvador",
  "SY": "Syrien",
  "SZ": "Swaziland",
  "TA": "Tahiti",
  "TC": "Turks- och Caicosöarna",
  "TD": "Tchad",
  "TF": "French southern & Antarctic Lands",
  "TG": "Togo",
  "TH": "Thailand",
  "TJ": "Tadjikistan",
  "TK": "Tokelau",
  "TL": "Östtimor",
  "TM": "Turkmenistan",
  "TN": "Tunisien",
  "TO": "Tonga",
  "TR": "Turkiet",
  "TT": "Trinidad och Tobago",
  "TV": "Tuvalu",
  "TW": "Taiwan",
  "TZ": "Tanzania",
  "UA": "Ukraina",
  "UG": "Uganda",
  "UM": "United states minor outlying islands",
  "US": "USA",
  "UY": "Uruguay",
  "UZ": "Uzbekistan",
  "VA": "Vatikanstaten",
  "VC": "Saint Vincent och Grenadinerna",
  "VE": "Venezuela",
  "VG": "Brittiska Jungfruöarna",
  "VI": "Amerikanska Jungfruöarna",
  "VN": "Vietnam",
  "VU": "Vanuatu",
  "WE": "Västbanken",
  "WF": "Wallis and Futuna Islands",
  "WS": "Samoa",
  "XK": "Kosovo",
  "XZ": "Internationell Zon",
  "YE": "Jemen",
  "YT": "Mayotte",
  "YU": "",
  "ZA": "Sydafrika",
  "ZM": "Zambia",
  "ZR": "Zaire",
  "ZW": "Zimbabwe",
  "ZZ": "Till sjöss",
  "reservationFee": "Förboka ditt bord och njut mer ombord",
  "reserveTable": "Boka bord",
  "reserved": "Reserverad",
  "footer.copyright": "© AS Tallink Grupp {{year}}",
  "button.changeBooking": "Ändra bokning",
  "payment.unsuccessful.callCenter": "Ring kundservice <b><a href=\"tel:+46 8-22 21 40\"> +46 (0)8-22 21 40</a></b> mån- fre 09:00 - 18:00",
  "payment.klarnaAndSwish.title": "Klarna & Swish",
  "payment.klarna.description": "Faktura, delbetalning",
  "payment.onlineBank.title": "Digitala betalsätt",
  "payment.onlineBankAndCards.title": "Digitala betalsätt & bank-/kreditkort",
  "payment.cards.title": "Bankkort & kreditkort",
  "payment.onlineBanks.title": "Bank",
  "payment.BANK.description": "Banker",
  "payment.MOBILE_PAY.description": "Mobile Pay",
  "payment.GOOGLE_PAY.description": "Google Pay",
  "payment.APPLE_PAY.description": "Apple Pay",
  "payment.onlineBanks.description": "Internetbank",
  "errorPage.description": "Ett fel inträffade. Var vänlig ladda om sidan. Observera! Efter att du har laddat om sidan kommer vald data att försvinna. Om problemet kvarstår, kontakta Tallink Silja Lines kundservice via e-post <a href=\"mailto:info.sweden@tallinksilja.com\">info.sweden@tallinksilja.com</a> eller kontakta oss här",
  "payment.CARD.description": "Kort",
  "SERIAL COMFORT": "Resebiljetter till Comfort Lounge",
  "SERIAL PASSENGER": "Resebiljetter i Star Class",
  "SERIAL BUSINESS": "Biljetter till Business Lounge-resenärer",
  "SERIAL CAR/CAR XL": "Bilböter",
  "SERIAL VAN": "Biljetter för minibussar",
  "available.codes": "Tillgängliga koder",
  "used.codes": "Använda koder",
  "ticket.expiry.notice": "Följande biljetter går ut den",
  "vehicle.type.extra-long-and-high.title": "Bil med släpvagn",
  "accessibility": "Tillgänglighet",
  "cancelCover": "Avbryt omslag",
  "clubOneDiscount": "Club One-rabatt",
  "button.payNow": "Betala nu",
  "button.joinClubOne": "Bli medlem i Club One",
  "price.toBePaid": "Att betalas",
  "price.subtotal": "Delsumma",
  "price.alreadyPaid": "Redan betalt",
  "copy.coupon.to.clipboard.accessibility.label": "Kopiera kupongkoden till urklipp",
  "price.chargeFee": "Avgift för ändring av bokning",
  "expired.codes": "Utgångna koder",
  "button.buy.cta": "Köp seriebiljetter",
  "no.codes.available": "Du har inga koder tillgängliga att använda",
  "accessibility.icon.aria-label": "Läs vår tillgänglighetspolicy",
  "pet.count": "{count, plural, =0 {# husdjur} =1 {# husdjur} other {# husdjur}}",
  "accessibility.url": " https://www.tallink.com/sv/tillganglighet",
  "aLaCarteVoucher.withValue": " à la carte-kupong värd {{value}}",
  "timeOfDay": "{{date, HH:mm}}",
  "dayWithTimeOfDay": "{{date, eee' kl. 'HH:mm }}",
  "aLaCarteVoucher": "À la carte-kupong",
  "ticket.expired": "Biljetterna gick ut den",
  "tooltip.accessibility.label": "Öppna verktygstips",
  "couponPage.login.cta": "För att se köpta seriebiljetter, vänligen <login>logga in</login>.",
  "button.downloadFile": "Ladda ner fil ({{extension}})"
} },
lv: { translation: {
  "common.buyTickets": "Nopirkt",
  "common.cancel": "Atcelt",
  "common.done": "Pabeigt",
  "common.ok": "OK",
  "clubOne.level": "Club One {{level}}",
  "clubOne.points.points": "b.p.",
  "clubOne.points.hint": "Aicinām izmantot uzkrātos Club One bonusa punktus, lai daļēji norēķinātos par ceļojumu.",
  "clubOne.switchToCompanyCustomer.warning": "Iziet no Club One konta",
  "clubOne.switchToCompanyCustomer.title": "Pārslēgties uz uzņēmuma klienta kontu",
  "clubOne.loginLink": "Ievadiet savu Club One klienta numuru ",
  "clubOne.title": "Club One klients",
  "companyCustomer.agentId": "Aģenta ID",
  "companyCustomer.agentId.error": "Aģenta ID nav atrasts",
  "companyCustomer.agentId.pattern": "",
  "companyCustomer.error": "Uzņēmuma klients ar norādītajiem akreditācijas datiem nav atrasts",
  "companyCustomer.id": "Klienta numurs",
  "companyCustomer.login": "Autorizēties",
  "companyCustomer.title": "Uzņēmuma klients",
  "deliveryDetails.clubOneAnonymous.text": "Biļetes ir nosūtītas uz zemāk norādīto e-pasta adresi.",
  "deliveryDetails.clubOneLogged.text": "Biļetes ir nosūtītas uz zemāk norādīto e-pasta adresi.",
  "deliveryDetails.companyCustomerAnonymous.text": "Biļetes ir nosūtītas uz zemāk norādīto e-pasta adresi.",
  "deliveryDetails.companyCustomerLogged.text": "Biļetes ir nosūtītas uz zemāk norādīto e-pasta adresi.",
  "deliveryDetails.form.email.label": "e-pasts",
  "deliveryDetails.form.error.emailPattern": "E-pasta adrese nav derīga.",
  "deliveryDetails.form.error.namePattern": "Lai ievadītu vārdu, Jūs varat izmantot burtus, simbolus ' un -.",
  "deliveryDetails.form.error.required": "Šis lauks ir obligāts.",
  "deliveryDetails.form.firstName.label": "vārds",
  "deliveryDetails.form.lastName.label": "uzvārds",
  "deliveryDetails.title": "Piegādes informācija",
  "description.passenger": "Viena pasažiera abonementa biļete ir derīga viena pasažiera ceļojumam vienā virzienā. ",
  "description.vehicle": "Viena transportlīdzekļa pārvadājuma abonementa biļete ir derīga viena transportlīdzekļa pārvadājumam vienā virzienā, un tajā nav iekļauta pasažiera biļete.",
  "hero.mainTitle": "Abonementa biļetes",
  "hero.subtitle": "Viena abonementa biļete sniedz iespēju ceļot vienam pasažieriem vienā virzienā vai pārvadāt vienu transportlīdzekli vienā virzienā.",
  "hint.clubOne.error": "Radās kļūda. Lūdzu, atkārtoti lejupielādējiet lapu vai turpiniet bez autorizācijas sistēmā. Atvainojamies par sagādātajām neērtībām.",
  "hint.clubOne.text": "Club One klienti saņem papildu atlaides, kā arī par katru pirkumu pelna bonusa punktus, kurus var izmantot jaunu ceļojumu iegādei. <a href=\"https://www.tallink.lv/lv/club-one-programme\" target=\"_blank\"> Atklājiet vairāk par Club One un pievienojieties bez maksas </a>",
  "mainPage.title": "Abonementa biļetes",
  "mobile.back": "← Atpakaļ",
  "mobile.done": "Turpināt",
  "price.description": "Biļetes",
  "price.amount": "Skaits",
  "price.discount": "Atlaide",
  "price.price": "Cena",
  "price.regular": "Parastā cena",
  "price.giftCard": "Dāvanu karte",
  "serialTicketName.passenger.business": "Biļete Business Lounge klasē",
  "serialTicketName.passenger.comfort": "Biļete Comfort Lounge klasē",
  "serialTicketName.passenger.star": "Biļete Star klasē",
  "serialTicketName.vehicle.CAR": "biļete transportlīdzekļa pārvadāšanai (maks. ↔5 m ↕1,9 m)",
  "serialTicketName.vehicle.CAR XL": "biļete transportlīdzekļa pārvadāšanai (maks. ↔5,5 m ↕2,4 m)",
  "serialTicketName.vehicle.VAN": "biļete transportlīdzekļa pārvadāšanai (maks. ↔7 m ↕2,4 m)",
  "signIn.button": "Autorizēties",
  "signOut.link": "Iziet →",
  "signInWithCompanyId.link": "Autorizēties, izmantojot uzņēmuma konta ID →",
  "srt.termsAndConditions.title": "Abonementa biļešu noteikumi ",
  "termsAndConditions.text": "<li>Abonementa biļete ir derīga 8, 14 vai 24 ceļojumiem vienā virzienā, maršrutā Tallina – Helsinki vai Helsinki – Tallina.</li>\n<li>Abonementa biļetes nav personalizētas; biļešu kodus ir iespējams nodot citām personām.</li>\n<li>Viena pasažiera abonementa biļete ir derīga vienai personai ceļojumam vienā virzienā.</li>\n<li>Viena transportlīdzekļa pārvadājuma abonementa biļete derīga viena transportlīdzekļa pārvadāšanai vienā virzienā, un tajā nav iekļauta pasažiera biļete.</li>\n<li>Abonementa biļete ir derīga 12 mēnešus no iegādes brīža.</li>\n<li>Abonementa biļetes ir iespējams iegādāties Tallink klientu apkalpošanas centros un Tallink mājaslapā.</li>\n<li>Izmantojot abonementa biļeti, ir iespēja rezervēt ceļojumus Tallink klientu apkalpošanas centros un mājaslapā.</li>\n<li>Vienā rezervācijā var izmantot ne vairāk kā sešas abonementa biļetes.</li>\n<li>Veicot rezervāciju Tallink mājaslapā, izmantotā abonementa biļete vienmēr tiek pieņemta kā samaksa par pirmo reisu vienam pasažierim vai viena transportlīdzekļa pārvadāšanai vienā virzienā.</li>\n<li>Izmaiņas ceļojuma rezervācijā, kas veikta, izmantojot abonementa biļeti, var veikt bez maksas līdz ceļojuma dienai.</li>\n",
  "type.passenger": "pasažieru biļetes",
  "type.vehicle": "transportlīdzekļa pārvadājuma biļetes",
  "voucherPanel.header": "Atlaides un dāvanu kartes",
  "voucherPanel.link.addAnotherVoucher": "+ Pievienot vēl vienu atlaides kodu ",
  "voucherPanel.link.addVoucher": "Man ir atlaides kods vai dāvanu karte",
  "voucherPanel.voucher.button.add": "Pievienot",
  "voucherPanel.voucher.hint": "Dāvanu karti var izmantot vairākiem pirkumiem līdz brīdim, kamēr visi līdzekļi ir iztērēti.<br>\nDāvanu kartes atlikusī vērtība ir <b>{{amountLeft}} €</b>.<br>\nDāvanu kartes derīguma termiņš ir <b>{{expirationDate}}</b>.",
  "voucherPanel.voucher.label": "Dāvanu kartes atlaides kods",
  "voucherPanel.voucher.validate.callToCallCenter": "Lai izmantotu dāvanu karti, aicinām sazināties ar mums, zvanot +371 6709 9700 ",
  "voucherPanel.voucher.validate.error": "Lūdzu, pārbaudiet atlaides kodu ",
  "payment.unsuccessful.description": "Veicot maksājumu, radās problēma. Pārliecinieties, vai jūsu kartē ir pietiekami daudz līdzekļu un mēģiniet vēlreiz.",
  "payment.unsuccessful.title": "Maksājums neizdevās",
  "payment.cancelled.title": "Pasūtījums nav apmaksāts",
  "payment.title": "Maksājuma veids",
  "payment.paymentServiceMethods.title": "Bankas karte",
  "payment.paymentServiceMethods.combined.title": "Banka / Karte",
  "payment.disclaimer": "Apstiprinot maksājumu, Jūs piekrītat <a href=\"https://www.tallink.lv/good-to-know#1450532\" target=\"_blank\">maksājumu un rezervēšanas noteikumiem</a>. Pasažierus, kas jaunāki par 18 gadiem, aicinām iepazīties ar <a href=\"https://www.tallink.lv/good-to-know#6575502\" target=\"_blank\">vecuma ierobežojuma noteikumiem</a>. ",
  "payment.disclaimer.Extra.TallinkGrupp": "Pasažierus, kas jaunāki par 18 gadiem, aicinām iepazīties ar <a href=\"https://www.tallink.lv/good-to-know#6575502\" target=\"_blank\">vecuma ierobežojuma noteikumiem</a>. Apstiprinot maksājumu, Jūs piekrītat <a href=\"https://www.tallink.lv/good-to-know#1450532\" target=\"_blank\">maksājumu un rezervēšanas noteikumiem</a>.<br>\nJums piedāvātais ceļojumu pakalpojumu kopums ir komplekss pakalpojums Direktīvas (ES) 2015/2302 nozīmē.<br>\nTāpēc Jūs varēsiet izmantot visas ES tiesības, kas attiecas uz kompleksiem pakalpojumiem. Uzņēmums AS Tallink Grupp būs pilnībā atbildīgs (atbildīgi) par kompleksā pakalpojuma pienācīgu sniegšanu kopumā. <br>\nTurklāt saskaņā ar tiesību aktu prasībām uzņēmumam AS Tallink Grupp, lai maksātnespējas gadījumā atlīdzinātu Jūsu maksājumus un, ja kompleksajā pakalpojumā ir ietverts transports, – nodrošinātu Jūsu repatriāciju.<br>\n<a href=\"https://www.tallinksilja.com/packaged-tours-tallink-grupp\" target=\"_blank\">Skatiet ceļojumu pakalpojumu kopuma noteikumus šeit</a>.",
  "payment.disclaimer.Extra.TallinkSiljaOY": "Pasažierus, kas jaunāki par 18 gadiem, aicinām iepazīties ar <a href=\"https://www.tallink.lv/good-to-know#6575502\" target=\"_blank\">vecuma ierobežojuma noteikumiem</a>. Apstiprinot maksājumu, Jūs piekrītat <a href=\"https://www.tallink.lv/good-to-know#1450532\" target=\"_blank\">maksājumu un rezervēšanas noteikumiem</a>.<br>\nJums piedāvātais ceļojumu pakalpojumu kopums ir komplekss pakalpojums Direktīvas (ES) 2015/2302 nozīmē.<br>\nTāpēc Jūs varēsiet izmantot visas ES tiesības, kas attiecas uz kompleksiem pakalpojumiem. Uzņēmums Tallink Silja Oy būs pilnībā atbildīgs (atbildīgi) par kompleksā pakalpojuma pienācīgu sniegšanu kopumā. <br>\nTurklāt saskaņā ar tiesību aktu prasībām uzņēmumam Tallink Silja Oy, lai maksātnespējas gadījumā atlīdzinātu Jūsu maksājumus un, ja kompleksajā pakalpojumā ir ietverts transports, – nodrošinātu Jūsu repatriāciju.<br>\n<a href=\"https://lv.tallink.com/lv/celojumu-paketes-tallink-silja\" target=\"_blank\">Skatiet ceļojumu pakalpojumu kopuma noteikumus šeit</a>.",
  "passengerDistribution.errors.WITHOUT_ADULT": "Katrā kajītē ir jābūt vismaz vienam pieaugušajam",
  "passengerDistribution.errors.WITHOUT_CABIN": "Lūdzu, izmitiniet kajītēs {nrOfPassengersWithoutCabin, plural, one{pēdējo # pasažieri} other{pārējos # pasažierus}}.",
  "passengerDistribution.notification.childWithoutOwnBed": "Bērns bez atsevišķas gultas vietas.",
  "payment.klarna.title": "Klarna",
  "payment.onlineBanks.list.aktia": "Aktia",
  "payment.onlineBanks.list.alandsbanken": "Ålandsbanken",
  "payment.onlineBanks.list.coop": "COOP Pank",
  "payment.onlineBanks.list.danskebankEE": "Danske Bank",
  "payment.onlineBanks.list.danskebankFI": "Danske Bank",
  "payment.onlineBanks.list.handelsbanken": "Handelsbanken",
  "payment.onlineBanks.list.kultaraha": "Osuuspankki",
  "payment.onlineBanks.list.lahitapiola": "LähiTapiola",
  "payment.onlineBanks.list.lhv": "LHV",
  "payment.onlineBanks.list.luminor": "Luminor",
  "payment.onlineBanks.list.nordea": "Nordea",
  "payment.onlineBanks.list.saastopankki": "Säästöpankki",
  "payment.onlineBanks.list.seb": "SEB",
  "payment.onlineBanks.list.spankki": "S-Pankki",
  "payment.onlineBanks.list.swedbank": "Swedbank",
  "payment.invoice.title": "Maksāšanas veids",
  "payment.type.invoice": "Vēlos saņemt rēķinu ",
  "payment.reference.title": "Jūsu references numurs",
  "payment.reference.disclaimer": "Apstiprinot maksājumu, Jūs piekrītat <a href=\"https://www.tallink.lv/good-to-know#1450532\" target=\"_blank\">maksājumu un rezervēšanas noteikumiem</a>.",
  "payment.type.card": "Vēlos maksāt ar karti",
  "payment.klarna.options.title": "Pieejamai maksāšanas veids ir atkarīgas no Jūsu rezervācijas. Visizplatītākās iespējas ir šādas:",
  "payment.klarna.options.list": "<li>Rēķins</li><li>Daļēja apmaksa</li>",
  "payment.klarna.policy": "Apstiprinot šo rezervāciju, Jūs piekrītat, ka Jūsu rezervācijas dati tiks pārsūtīti Klarna, lai pārbaudītu pieejamās maksāšanas iespējas. Uzziniet vairāk <a href=\"https://cdn.klarna.com/1.0/shared/content/policy/data/en_fi/privacy_statement.pdf\" target=\"_blank\">kā Klarna izmantos Jūsu datus</a>.",
  "payment.klarna.mobile.title": "Izmantojot Klarna servisu, viegli un droši norēķinieties no sava mobilā tālruņa.",
  "paymentPage.total": "Kopā",
  "paymentPage.confirm.freeReservation": "",
  "paymentPage.confirm.onlyPayment": "Maksāt",
  "paymentPage.confirm.onlyPayment.withInvoice": "Apstiprināt",
  "confirmation.thankYouCallout.title": "Paldies par pirkumu! ",
  "confirmation.thankYouCallout.paidTotal": "Kopā samaksāts",
  "confirmation.thankYouCallout.message": "Maksājums ir apstiprināts. Jūsu rezervācijas apstiprinājums ir nosūtīts uz <b> {{email}} </b>.",
  "confirmation.orderConfirmation": "Rezervācijas apstiprinājums",
  "confirmation.summary.downloadPdf": "Lejupielādēt PDF",
  "confirmation.summary.bookTrip": "Rezervēt ceļojumu",
  "confirmation.summary.disclaimer": "Aicinām izmantot pirkumu un rezervēt ceļojumu tagad. ",
  "confirmation.summary.email": "E-pasts",
  "confirmation.summary.contactPerson": "Kontaktpersona",
  "confirmation.summary.securityCode": "Drošības kods",
  "confirmation.summary.orderNumber": "Rezervācijas numurs",
  "otherPaymentMethod": "Cits maksājuma veids",
  "paymentMethod": "Maksājuma veids",
  "remove": "Noņemt",
  "answer.yes": "Jā",
  "answer.no": "Nē",
  "button.send": "Nosūtīt",
  "button.withoutPrice.notChosen": "Izvēlēties",
  "button.withoutPrice.chosen": "Izvēlēts",
  "button.add": "Pievienot",
  "clubOne.level.BRONZE": "Bronze",
  "clubOne.level.SILVER": "Silver",
  "clubOne.level.GOLD": "Gold",
  "clubOne.level.title": "Club One",
  "currency.EUR": "€",
  "currency.LAT": "Ls",
  "currency.LVL": "Ls",
  "currency.RUB": "€",
  "currency.SEK": "kr",
  "dateFormat.dayOfWeekDayMonthAndTime": "{weekday} <b>{date}</b> plkst. <b>{time}</b>",
  "decimalSeparator": ",",
  "details.dayMonthAndTime.pattern": "d.m. p\\\\lk\\\\s\\\\t. H:i",
  "details.dayOfWeek.pattern": "l",
  "entertainment.title": "Izklaide uz kuģa",
  "entertainment.sitting": "Sēdvieta",
  "error.chromeframe.label": "Vai arī Jūs varat lejupielādēt interneta pārlūkā Google.",
  "entertainment.sittingGroup.premium.name\r\n": "Premium sēdvieta",
  "entertainment.sittingGroup.premium.description": "Iegādājoties premium sēdvietas, ir laba redzamība un cenā ir iekļautas uzkodas.",
  "entertainment.sittingGroup.basic.name\r\n": "Sēdvieta ar ierobežotu redzamību",
  "entertainment.sittingGroup.basic.description": "No šīs sēdvietas ir ierobežota redzamība uz skatuvi.",
  "entertainment.sittingGroup.basic.addOn.name\r\n": "No šīs sēdvietas ir ierobežota redzamība uz skatuvi.",
  "error.chromeframe.link": "Chrome Frame interneta pārlūkprogrammu.",
  "error.ie": "Jūs izmantojat novecojušu Internet Explorer versiju. Mēs iesakām atjaunināt drošāku un ātrāku interneta pārlūkprogrammu. Lūdzu, lejupielādējiet kādu no šādām interneta pārlūkprogrammām.",
  "error.notPossibleToChangeBookingOnline": "Diemžēl tiešsaistes sistēmā izmaiņas Jūsu rezervācijā veikt neizdevās.<br><br>Ja vēlaties veikt izmaiņas, lūdzam sazināties <a href=\"mailto:booking@tallink.lv\">pa e-pastu</a> vai pa tālruni +371 670 997 00.",
  "form.email": "E-Mail",
  "form.phone": "Telefon",
  "format.LocalDayMonth": "{{date, d.M.}}",
  "format.LocalShortWeekdayAndDayMonth": "D j.n.",
  "format.LocalLongWeekdayAndDayMonth": "l j.n.",
  "format.LocalShortWeekdayAndShortMonth": "MMM D",
  "format.LocalDayMonthYear": "j.n.Y",
  "header.bookingNumber": "Rezervācijas numurs",
  "header.logout": "Iziet",
  "header.myBooking": "Mana rezervācija",
  "header.pin": "Drošības numurs",
  "hotel.checkInTime": "Reģistrēšanās",
  "hotel.checkOutTime": "Izrakstīšanās",
  "nights": "naktis",
  "night": "nakts",
  "hotelsItinerary.returnTripIsNotAvailable": "Jūsu izvēlētajā atgriešanās datumā ceļojumi nav pieejami. Lūdzam samainiet rezervācijas datumus viesnīcā. ",
  "label.remove": "Entfernen",
  "landServices.title": "Izklaide krastā",
  "landService.ageCategory.base": "Pamatcenas biļete\r\n",
  "landService.ageCategory.child": "Bērni {ageCategory} gadi",
  "landService.dateTime.pattern": "d.m.Y",
  "meals.packages.choosePackage": "Izvēlies ēdināšanas piedāvājumu",
  "meals.packages.title": "Ēdināšanas piedāvājumi",
  "meals.packages.commonInfo": "Ēdināšanas piedāvājumi attiecas uz visu kruīza laiku.",
  "meals.packages.description": "Bērniem ir atlaide, un 0-5 gadus veci bērni var ēst bez maksas kopā ar vecāku.<br>Ja ēdienreizes ir izpārdotas, kuponi (tādā pašā vērtībā) tiks pievienoti rezervācijai. Ēdināšanas kuponus var izmantot kā maksājumu visos kuģa restorānos.",
  "meals.button.freeMealPackages": "Iekļauta",
  "meals.selectionMealBlockedByTime": "Ēdināšanas piedāvājumu ir iespējams izvēlēties ne vēlāk kā 4 stundas pirms kuģa atiešanas.",
  "onboardServices.title": "Pakalpojumi uz kuģa",
  "adults": "pieaugušajiem",
  "adult": "pieaugušais",
  "child": "bērns",
  "junior": "Junior",
  "youth": "Jaunatne",
  "children": "bērni",
  "guests.edit.accessibility.label": "Pasažieru dati",
  "pier.DTER.address": "Lootsi 13, 10151 Tallina",
  "pier.DTER.title": "D-Terminal",
  "pier.FHAM.address": "Frihamnen, Magasin 2, 10 253 Stokholma",
  "pier.FHAM.title": "Frihamnen",
  "pier.HND.title": "Härnösand",
  "pier.HND.address": "Skeppsbron 31, 871 80 Härnösand",
  "pier.LNAS.address": "Långnäsin termināls, 22630 Lumparland",
  "pier.LNAS.title": "Långnäs",
  "pier.LSA2.address": "West harbour, Helsinki",
  "pier.LSA2.title": "West terminal 2",
  "pier.LSA6.address": "Tyynenmerenkatu 8, 00220 Helsinki",
  "pier.LSA6.title": "West Terminal",
  "pier.LSAT.address": "Tyynenmerenkatu 8, 00220 Helsinki",
  "pier.LSAT.title": "West Terminal",
  "pier.MHAM.address": "Västra hamnen, 22100 Mariehamna",
  "pier.MHAM.title": "Mariehamna",
  "pier.MUUG.address": "Muuga sadam, Maardu Tee 65, Maardu",
  "pier.MUUG.title": "Mūgas Osta",
  "pier.OLYM.address": "Olympiaranta 1, 00140 Helsinki",
  "pier.OLYM.title": "Olympia Terminal",
  "pier.PALD.address": "Rae põik 10, EE-76806 Paldiski",
  "pier.PALD.title": "Paldiski",
  "pier.KAPE.address": "Hamnterminalen, 760 15 Gräddö",
  "pier.KAPE.title": "Kapellskär",
  "pier.RIGA.address": "Eksporta 3a, Riga, LV-1010",
  "pier.RIGA.title": "Rīgas Pasažieru osta",
  "pier.TSAT.address": "Linnankatu 91, 20100 Turku",
  "pier.TSAT.title": "Turku osta",
  "pier.VHAM.address": "Hamnpirsvägen 10, 11574 Stockholm",
  "pier.VHAM.title": "Värtahamnen",
  "pier.VISH.title": "Visbija",
  "pier.VISH.address": "Färjeleden 2, 621 81 Visby",
  "pier.VSAA.address": "Vuosaari, Seilorinkatu 5, Helsinki",
  "pier.VSAA.title": "Vuosāri Osta",
  "pier.MFAC.address": "Bereg Nevskoy gubi 1., V.O., St. Pēterburga",
  "pier.MFAC.title": "St.Pēterburga",
  "pier.SAS.title": "Zasnica",
  "pier.SMA1.title": "Sāremā",
  "pier.SMA1.address": "Ninase village, Mustjala, 93631, Sāremā",
  "pier.KLJ1.title": "Klaipēda",
  "pier.KLJ1.address": "J.Zauerveino 18, LT-92122 Klaipēda, Lietuva",
  "port.KAP": "Kapelšēra",
  "port.PAL": "Paldiski",
  "port.KLJ": "Klaipēda",
  "port.YST": "Ystad",
  "port.PARTY": "Baltijas jūra",
  "refresh": "Atjaunot",
  "reservation.travelPermitForYouth": "15-17 gadu vecumā atļauts ceļot bez pieaugušā pavadības. Neaizmirsti paņemt līdzi <a href=\"https://ee.tallink.com/documents/10192/65371006/Permission_to_travel_alone_15_17_EN.pdf/7a0c8141-c394-42b5-a6db-29469450ddc6\" target=\"_blank\">ceļošanas atļauju</a> . Drošus ceļojumus!",
  "send.email.failed": "E-pasts nav nosūtījies. Lūdzu, mēģiniet vēlreiz.",
  "send.sms.failed": "SMS nav nosūtījusies. Lūdzu, mēģiniet vēlreiz.",
  "summary.confirm": "Apstiprināt",
  "summary.dateTime.pattern": "d.m.Y <\\\\sp\\\\a\\\\n>\\\\p\\\\l\\\\k\\\\s\\\\t</\\\\sp\\\\a\\\\n>. H:i",
  "summary.extraServices": "Kopējai summa tika pievienota maksa par papildu pakalpojumiem. Lai saņemtu vairāk informācijas, lūdzu, skatiet pdf failu, kurš tika nosūtīts uz Jūsu e-pastu. ",
  "summary.freeMealPackages.title": "Bezmaksas papildu pakalpojumi",
  "summary.refund.notification": "Lai saņemtu informāciju par naudas atgriešanu, lūdzam sazināties ar Tallink klientu apkalpošanas personālu pa tālruni {phoneLocal}. ",
  "summary.refund.notification.with.phoneInternational": "Lūdzu, sazinieties ar klientu servisu par naudas atmaksu. Tel. {phoneLocal} / {phoneInternational}",
  "summary.refund.notification.phoneInternational.EE": " +372 640 9808",
  "summary.refund.notification.phoneInternational.SE": " +46 8 22 21 40",
  "summary.refund.notification.phoneLocal": " +49 (0)40 547 541 222",
  "summary.refund.notification.phoneLocal.FI": "(09) 887 53121",
  "summary.refund.notification.phoneLocal.EE": " 17 808",
  "summary.refund.notification.phoneLocal.SE": "08 22 21 40",
  "summary.refund.notification.phoneLocal.LV": " +371 670 997 00",
  "summary.refund.notification.phoneLocal.RU": " + 372 611 8801",
  "summary.clearChanges.title": "Pārdomājāt?",
  "summary.clearChanges.link": "Dzēst izmaiņas",
  "summary.overnightPackage": "Ceļojums ar nakšņošanu",
  "template.dateTime": "{date} <span>um</span> {time}",
  "time.preposition.at": "Plkst.",
  "validate.firstName": "Lūdzu, izmantojiet tikai latīņu burtus, bez mīkstinājuma zīmēm un garumzīmēm.",
  "validate.lastName": "Lūdzu, izmantojiet tikai latīņu burtus, bez mīkstinājuma zīmēm un garumzīmēm.",
  "location.hotelCityCode.HAA": "Hāpsalu",
  "location.hotelCityCode.HEL": "Helsinki",
  "location.hotelCityCode.JUR": "Jūrmala",
  "location.hotelCityCode.KOM": "Kolmardena",
  "location.hotelCityCode.KUR": "Kuresāre",
  "location.hotelCityCode.LAL": "Laulasmā",
  "location.hotelCityCode.MHQ": "Mariehamna",
  "location.hotelCityCode.NAR": "Narva",
  "location.hotelCityCode.NRK": "Noršēpinga",
  "location.hotelCityCode.OTE": "Otepē",
  "location.hotelCityCode.PAR": "Pērnava",
  "location.hotelCityCode.RAK": "Rakvere",
  "location.hotelCityCode.RIX": "Rīga",
  "location.hotelCityCode.SOE": "Sodertālje",
  "location.hotelCityCode.STO": "Stokholma",
  "location.hotelCityCode.TAR": "Tartu",
  "location.hotelCityCode.TKU": "Turku",
  "location.hotelCityCode.TLL": "Tallina",
  "location.hotelCityCode.TMP": "Tampere",
  "location.hotelCityCode.UPP": "Upsala",
  "location.hotelCityCode.VAN": "Vanta",
  "location.hotelCityCode.VIH": "Vihula",
  "vehicle.type.bicycle.title": "Velosipēds, elektriskais skrejritenis",
  "vehicle.type.car.title": "Vieglais auto",
  "vehicle.type.car-xl.title": "Vieglais auto",
  "vehicle.type.long-and-high.title": "Transportlīdzeklis ar piekabi",
  "vehicle.type.long-and-low.title": "Transportlīdzeklis ar piekabi",
  "vehicle.type.long-and-medium.title": "Transportlīdzeklis ar piekabi",
  "vehicle.type.motorcycle.title": "Motocikls",
  "vehicle.type.motorcycle-with-sidecar.title": "Motocikls ar blakusvāģi",
  "vehicle.type.motorcycle-with-sidecar.measures": "Augstums: līdz 1.90m un garums: līdz 4m",
  "vehicle.type.van-high.title": "Augsts autofurgons",
  "vehicle.type.parked-car.title": "Vieta transportlīdzeklim",
  "vehicle.type.van.title": "Autofurgons",
  "vehicle.type.parked-van.title": "Automašīna novietota stāvēšanai",
  "vehicle.type.shopper-car.title": "Pircēja auto",
  "vehicle.type.shopper-van.title": "Pircēja autofurgons",
  "vehicle.type.shopper-car.notices": "- Ērta un viegla piekļūšana savam auto ceļojuma laikā<br>- Novietots blakus veikaliem",
  "vehicle.type.shopper-van.notices": "- Ērta un viegla piekļūšana savam auto ceļojuma laikā<br>- Novietots blakus veikaliem",
  "vehicle.type.parked-car.notices": "- Bez piekļuves transportlīdzeklim ceļojuma laikā<br>\r\n- Bez iespējas nobraukt no kuģa galamērķī ",
  "vehicle.type.parked-van.notices": "- Bez piekļuves transportlīdzeklim ceļojuma laikā<br>\r\n- Bez iespējas nobraukt no kuģa galamērķī ",
  "vehicle.type.shopper-car.noDisembark": "Ar auto galamērķī izbraukt nevar",
  "vehicle.type.shopper-van.noDisembark": "Ar autofurgonu galamērķī izbraukt nevar",
  "vehicle.type.parked-car.noDisembark": "Bez iespējas nobraukt no kuģa galamērķī ",
  "vehicle.type.under.measures": "<span class=\"height\"></span> {height} m <span class=\"width\"></span> {length} m",
  "wifi.title": "WiFi",
  "common.language.FI": "Somu valoda",
  "common.language.ET": "Igauņu valoda",
  "common.language.EN": "Angļu valoda",
  "common.language.RU": "Krievu valoda",
  "common.language.SV": "Zviedru valoda",
  "common.language.DE": "Vācu valoda",
  "common.language.LV": "Latviešu valoda",
  "common.language.LT": "Lietuviešu valoda",
  "label.or": "vai",
  "routePanel.from": "No",
  "routePanel.to": "Uz",
  "port.ALA": "Ālandu salas",
  "port.HEL": "Helsinki",
  "port.MUG": "Mūga",
  "port.RIG": "Rīga",
  "port.STO": "Stokholma",
  "port.TAL": "Tallina",
  "port.TUR": "Turku",
  "port.VIS": "Visbija",
  "port.VSS": "Vuosāri",
  "port.SPE": "Pēterburga",
  "port.SAS": "Zasnica",
  "port.SMA": "Sāremā",
  "port.VNT": "Ventspils",
  "port.HND": "Härnösand",
  "button.edit": "Labot",
  "guests": "pasažieri",
  "vehicles": "Transportlīdzekļi",
  "date": "Datums",
  "travelClass.title": "Ceļošanas klase",
  "giftCard": "Dāvanu karte",
  "SIGN_IN": "Autorizēties ",
  "button.book.a.trip": "Rezervēt ceļojumu",
  "price.total": "Kopā",
  "clubOne.points.price": "un {{count}} punkti",
  "error.title": "Kļūda",
  "button.close": "Aizvērt",
  "calendar.choose.date": "Izvēlēties datumu",
  "itinerary.miniCruise": "5h kruīzs",
  "TAL-HEL.CRUISE": "9h kruīzs",
  "timetable.oneWay": "Vienā virzienā",
  "timetable.roundtrip": "Ceļojums turp un atpakaļ",
  "button.done": "Gatavs",
  "pets": "mājdzīvnieki",
  "label.see.details": "Apskatīt informāciju",
  "common.language.KO": "Korejiešu",
  "common.language.ZH": "Ķīniešu",
  "common.language.JA": "Japāņu",
  "header.chooseYourLanguage": "Izvēlēties valodu",
  "pageNotFound.title": "Mēs rūpīgi pārbaudījām visu mājaslapu...",
  "pageNotFound.subtitle": "Diemžēl, mums neizdevās atrast Jūsu meklēto lapu.",
  "goBack": "Atgriezties",
  "label.info": "Informācija",
  "itinerary.title": "Ceļojuma informācija",
  "itinerary.description": "",
  "extraServices.button.soldOut": "Izpārdots",
  "button.cancel": "Atcelt",
  "abbreviation.hour": "{{hour}}h",
  "cruise": "Kruīzs",
  "HEL-TAL.CRUISE": "22h kruīzs",
  "form.error.required": "Nepieciešama vērtība",
  "form.error.min": "Minimālā atļautā vērtība ir {{min}}",
  "form.error.max": "Maksimālā atļautā vērtība ir {{max}}",
  "form.error.minLength": "Minimālais atļautais garums ir {{minLength}}",
  "form.error.maxLength": "Maksimālais atļautais garums ir {{maxLength}}",
  "sailLeg.sailTime": "{{date, eee', <b>'dd.MM' plkst. <br>'HH:mm'</b>'}}",
  "timetable.tripTypeAndDeparture": "Ceļojuma veids un izbraukšanas laiks",
  "timetable.calendar": "Kalendārs",
  "timetable.table.departureAndArrival": "Atiešana & pienākšana",
  "timetable.table.duration": "Ilgums",
  "timetable.table.vessel": "Kuģis",
  "clubOne.slider.label": "",
  "button.proceed": "Turpināt",
  "label.loading": "Ielādē",
  "sailLeg.sailTime.short": "{{date, '<b>'dd.MM'</b> plkst. <b>'HH:mm'</b>'}}",
  "clubOne.slider.description": "Maksimālais punktu skaits, ko iespējams izmantot, tiek aprēķināts dinamiski, ņemot vērā rezervētos pakalpojumus. ",
  "specialCruise": "",
  "cabin": "kajīte",
  "lounges": "atpūtas telpas",
  "cabins": "kajītes",
  "specialCabins": "īpašas kajītes",
  "specialCabin.tag.handicap": "Pielāgotās",
  "specialCabin.tag.allergy": "Alerģiskiem pasažieriem",
  "voucher": "Ceļojumu karte",
  "serialTicket": "Abonementa biļete",
  "summary": "Kopsavilkums",
  "contact": "Kontaktpersona",
  "booking": "Rezervācija",
  "payment": "Apmaksa",
  "free": "Bez maksas",
  "guest": "pasažieris",
  "guest.count": "{count, plural, =0 {# pasažieri} =1 {# pasažieris} other {# pasažieri}}",
  "cabin.count": "{count, plural, =0 {# kajītes} =1 {# kajīte} other {# kajītes}}",
  "form.firstName": "",
  "form.lastName": "",
  "CO.number": "Club One numurs",
  "dateOfBirth": "Dzimšanas dati",
  "gender": "Dzimums",
  "guest.details": "Informācija par pasažieri",
  "nationality": "Tautība",
  "specialAssistance": "Palīdzība",
  "payButton": "Maksāt",
  "loading": "Lūdzu, uzgaidiet...",
  "male": "Vīrietis",
  "female": "Sieviete",
  "citizenship.estonian": "Igauņu",
  "notRequired": "Nav nepieciešama",
  "ELECTRIC WHEELCHAIR": "Elektriskajā ratiņkrēslā",
  "VISUALLY IMPAIRED": "Redzes traucējumi",
  "HEARING IMPAIRED": "Dzirdes traucējumi",
  "OTHER REASON FOR ASSISTANCE": "Cits",
  "GUIDEDOG": "Ar suni pavadoni",
  "WHEELCHAIR": "Ratiņkrēslā",
  "button.ok": "OK",
  "errorPage.title": "Radās kļūda! ",
  "form.error.email": "E-pasts nav derīgs",
  "form.error.positiveInteger": "Jāraksta tikai cipari",
  "form.error.date": "Datums nav pareizs",
  "form.error.name": "Vārds jāraksta latīņu burtiem",
  "form.error.clubOne": "Club One numurs nav derīgs",
  "clubOneApplied": "Club One numurs pievienots",
  "form.signInToUseYourBonusPoints": "",
  "optional": "Pēc izvēles",
  "form.error.positiveFloat": "Atļauti tikai skaitļi vai decimālvērtības",
  "AD": "ANDORA",
  "AE": "UNITED ARAB EMIRATES",
  "AF": "AFGHANISTAN",
  "AG": "ANTIGUA AND BARBUDA",
  "AI": "ANGUILLA",
  "AL": "ALBANIA",
  "AM": "ARMENIA",
  "AN": "NETHERLAND ANTILLES",
  "AO": "ANGOLA",
  "AQ": "ANTARCTICA",
  "AR": "ARGENTINA",
  "AS": "AMERICAN SAMOA",
  "AT": "AUSTRIA",
  "AU": "AUSTRALIA",
  "AW": "ARUBA",
  "AZ": "AZERBAIJAN",
  "BA": "BOSNIA HERCEGOVINA",
  "BB": "BARBADOS",
  "BD": "BANGLADESH",
  "BE": "BELGIUM",
  "BF": "BURKINA FASO",
  "BG": "BULGARIA",
  "BH": "BAHRAIN",
  "BI": "BURUNDI",
  "BJ": "BENIN",
  "BM": "BERMUDA",
  "BN": "BRUNEI DARUSSALAM",
  "BO": "BOLIVIA",
  "BR": "BRAZIL",
  "BS": "BAHAMAS",
  "BT": "BHUTAN",
  "BW": "BOTSWANA",
  "BY": "BELARUS",
  "BZ": "BELIZE",
  "CA": "CANADA",
  "CC": "COCOS (KEELING) ISLANDS",
  "CD": "CONGO, DEMOCRATIC REPUBLIC OF",
  "CF": "CENTRAL AFRICAN REPUBLIC",
  "CG": "CONGO",
  "CH": "SWITZERLAND",
  "CI": "COTE D'IVOIRE",
  "CK": "COOK ISLANDS",
  "CL": "CHILE",
  "CM": "CAMEROON",
  "CN": "CHINA",
  "CO": "COLOMBIA",
  "CR": "COSTA RICA",
  "CS": "SERBIA",
  "CU": "CUBA",
  "CV": "CAPE VERDE",
  "CX": "CHRISTMAS ISLANDS",
  "CY": "CYPRUS",
  "CZ": "CZECH REPUBLIC",
  "DE": "VĀCIJA",
  "DJ": "DJIBOUTI",
  "DK": "DĀNIJA",
  "DM": "DOMINICA",
  "DO": "DOMINICAN REPUBLIC",
  "DZ": "ALGERIA",
  "EC": "ECUADOR",
  "EE": "IGAUNIJA",
  "EG": "EGYPT",
  "EH": "WESTERN SAHARA",
  "ER": "ERITREA",
  "ES": "SPAIN",
  "ET": "ETHIOPIA",
  "FI": "SOMIJA",
  "FJ": "FIJI",
  "FK": "FALKLAND ISLANDS (MALVINAS)",
  "FM": "FEDERAL STATES OF MICRONESIA",
  "FO": "FAROE ISLANDS",
  "FR": "FRANCE",
  "GA": "GABON",
  "GB": "UNITED KINGDOM",
  "GD": "GRENADA",
  "GE": "GEORGIA",
  "GF": "FRENCH GUIANA",
  "GH": "GHANA",
  "GI": "GIBRALTAR",
  "GL": "GREENLAND",
  "GM": "GAMBIA",
  "GN": "GUINEA",
  "GP": "GUADELOUPE",
  "GQ": "EQUATORIAL GUINEA",
  "GR": "GREECE",
  "GS": "SOUTH GEORGIA AND SOUTH SANDWICH ISLANDS",
  "GT": "GUATEMALA",
  "GU": "GUAM",
  "GW": "GUINEA-BISSAU",
  "GY": "GUYANA",
  "GZ": "GAZA STRIP",
  "HK": "HONG KONG",
  "HM": "HEARD AND MCDONALD ISLANDS",
  "HN": "HONDURAS",
  "HR": "CROATIA",
  "HT": "HAITI",
  "HU": "HUNGARY",
  "ID": "INDONESIA",
  "IE": "IRELAND",
  "IL": "ISRAEL",
  "IN": "INDIA",
  "IO": "INDIAN OCEAN TERRITORY",
  "IQ": "IRAQ",
  "IR": "IRAN, ISLAMIC REPUBLIC OF",
  "IS": "ICELAND",
  "IT": "ITALY",
  "JM": "JAMAICA",
  "JO": "JORDAN",
  "JP": "JAPAN",
  "KE": "KENYA",
  "KG": "KYRGYZSTAN",
  "KH": "CAMBODIA",
  "KI": "KIRIBATI",
  "KM": "COMOROS",
  "KN": "SAINT KITTS - NEVIS",
  "KP": "KOREA, DEM. PEOPLE'S REPUBLIC OF (NORTH)",
  "KR": "KOREA, REPUBLIC OF (SOUTH)",
  "KW": "KUWAIT",
  "KY": "CAYMAN ISLANDS",
  "KZ": "KAZAKSTAN",
  "LA": "LAO PEOPLE'S DEMOCRATIC REPUBLIC",
  "LB": "LEBANON",
  "LC": "SAINT LUCIA",
  "LI": "LIECHTENSTEIN",
  "LK": "SRI LANKA",
  "LR": "LIBERIA",
  "LS": "LESOTHO",
  "LT": "LIETUVA",
  "LU": "LUXEMBOURG",
  "LV": "LATVIJA",
  "LY": "LIBYAN ARAB JAMAHIRIYA",
  "MA": "MOROCCO",
  "MC": "MONACO",
  "MD": "MOLDOVA",
  "ME": "Melnkalne",
  "MG": "MADAGASCAR",
  "MH": "MARSHALL ISLANDS",
  "MK": "MACEDONIA, F.Y.R.",
  "ML": "MALI",
  "MM": "MYANMAR (FORMER BURMA)",
  "MN": "MONGOLIA",
  "MO": "MACAU",
  "MP": "NORTHERN MARIANAS",
  "MQ": "MARTINIQUE",
  "MR": "MAURITANIA",
  "MS": "MONTSERRAT",
  "MT": "MALTA",
  "MU": "MAURITIUS",
  "MV": "MALDIVES",
  "MW": "MALAWI",
  "MX": "MEXICO",
  "MY": "MALAYSIA",
  "MZ": "MOZAMBIQUE",
  "NC": "NEW CALEDONIA",
  "NE": "NIGER",
  "NF": "NORFOLK ISLAND",
  "NG": "NIGERIA",
  "NI": "NICARAGUA",
  "NL": "NETHERLANDS",
  "NO": "NORVĒĢIJA",
  "NP": "NEPAL",
  "NR": "NAURU",
  "NU": "NIUE",
  "NZ": "NEW ZEALAND",
  "OM": "OMAN",
  "OT": "CITS",
  "PA": "PANAMA",
  "PE": "PERU",
  "PF": "FRENCH POLYNESIA",
  "PG": "PAPUA NEW GUINEA",
  "PH": "PHILIPPINES",
  "PK": "PAKISTAN",
  "PL": "POLAND",
  "PM": "ST. PIERRE AND MIQUELON",
  "PN": "PITCAIRN ISLAND",
  "PR": "PUERTO RICO",
  "PS": "PALESTINA",
  "PT": "PORTUGAL",
  "PW": "PALAU",
  "PY": "PARAGUAY",
  "QA": "QATAR",
  "RE": "REUNION",
  "RO": "ROMANIA",
  "RS": "",
  "RU": "KRIEVIJA",
  "RW": "RWANDA",
  "SA": "SAUDI ARABIA",
  "SB": "SOLOMON ISLANDS",
  "SC": "SEYCHELLES",
  "SD": "SUDAN",
  "SE": "ZVIEDRIJA",
  "SG": "SINGAPORE",
  "SH": "ST. HELENA",
  "SI": "SLOVENIA",
  "SJ": "SVALBARD AND JAN MAYEN",
  "SK": "SLOVAKIA",
  "SL": "SIERRA LEONE",
  "SM": "SAN MARINO",
  "SN": "SENEGAL",
  "SO": "SOMALIA",
  "SR": "SURINAME",
  "ST": "SAO TOME AND PRINCIPE",
  "SV": "EL SALVADOR",
  "SY": "SYRIAN ARAB REPUBLIC",
  "SZ": "SWAZILAND",
  "TA": "TAHITI",
  "TC": "TURKS AND CAICOS ISLANDS",
  "TD": "CHAD",
  "TF": "FRENCH SOUTHERN & ANTARCTIC LANDS",
  "TG": "TOGO",
  "TH": "THAILAND",
  "TJ": "TAJIKISTAN",
  "TK": "TOKELAU",
  "TL": "EAST TIMOR",
  "TM": "TURKMENISTAN",
  "TN": "TUNISIA",
  "TO": "TONGA",
  "TR": "TURKEY",
  "TT": "TRINIDAD AND TOBAGO",
  "TV": "TUVALU",
  "TW": "TAIWAN",
  "TZ": "TANZANIA, UNITED REPUBLIC OF",
  "UA": "UKRAINA",
  "UG": "UGANDA",
  "UM": "UNITED STATES MINOR OUTLYING ISLANDS",
  "US": "UNITED STATES",
  "UY": "URUGUAY",
  "UZ": "UZBEKISTAN",
  "VA": "VATICAN CITY STATE (HOLY SEE)",
  "VC": "SAINT VINCENT AND THE GRENADINES",
  "VE": "VENEZUELA",
  "VG": "BRITISH VIRGIN ISLANDS",
  "VI": "UNITED STATES VIRGIN ISLANDS",
  "VN": "VIET NAM",
  "VU": "VANUATU",
  "WE": "WEST BANK",
  "WF": "WALLIS AND FUTUNA ISLANDS",
  "WS": "SAMOA",
  "XK": "Kosovo",
  "XZ": "INTERNATIONAL ZONE",
  "YE": "YEMEN",
  "YT": "MAYOTTE",
  "YU": "",
  "ZA": "SOUTH AFRICA",
  "ZM": "ZAMBIA",
  "ZR": "ZAIRE = CONGO DEM.",
  "ZW": "ZIMBABWE",
  "ZZ": "Nav definēts",
  "reservationFee": "Rezervācijas maksa",
  "reserveTable": "Rezervēt galdiņu",
  "reserved": "Rezervēts",
  "footer.copyright": "© AS Tallink Grupp {{year}}",
  "button.changeBooking": "Mainīt rezervāciju",
  "payment.unsuccessful.callCenter": "Informācija un klientu atbalsts<b><a href=\"tel.:+371 6709 9700\">+371 6709 9700</a></b>. Darba laiks: P-Pk, no 10:00 līdz 15:00.",
  "payment.klarnaAndSwish.title": "Klarna & Swish",
  "payment.klarna.description": "Rēķins, daļēja apmaksa",
  "payment.onlineBank.title": "Internetbanka",
  "payment.onlineBankAndCards.title": "Internetbanka & Debetkarte/kredītkarte",
  "payment.cards.title": "Debetkarte/kredītkarte",
  "payment.onlineBanks.title": "Internetbanka",
  "payment.BANK.description": "Bankas",
  "payment.MOBILE_PAY.description": "MobilePay",
  "payment.GOOGLE_PAY.description": "Google Pay",
  "payment.APPLE_PAY.description": "Apple Pay",
  "payment.onlineBanks.description": "Pieejamās bankas",
  "errorPage.description": "Radās kļūda. Lūdzu, atjauniniet lapu un mēģiniet vēlreiz. Vēršam Jūsu uzmanību, ka atjauninot lapu, iepriekš norādītā informācija netiks saglabāta. Ja kļūda atkārtojas, aicinām sazināties ar klientu apkalpošanas centru, zvanot: +371 6709 9700 vai rakstot: booking@tallink.lv. <br> Mēs atvainojamies par sagādātajām neērtībām.",
  "payment.CARD.description": "Kartes",
  "SERIAL COMFORT": "Comfort Lounge biļetes pasažieriem",
  "SERIAL PASSENGER": "Star Class biļetes pasažieriem",
  "SERIAL BUSINESS": "Business Lounge biļetes pasažieriem",
  "SERIAL CAR/CAR XL": "Pasažieru automašīnas biļetes",
  "SERIAL VAN": "Mikroautobusu biļetes",
  "available.codes": "Pieejamie kodi",
  "used.codes": "Izmantotie kodi",
  "ticket.expiry.notice": "Biļetes, kam derīguma termiņš beidzas",
  "vehicle.type.extra-long-and-high.title": "Automašīna ar piekabi",
  "accessibility": "Pieejamība",
  "cancelCover": "Atcelt vāku",
  "clubOneDiscount": "Club One atlaide",
  "button.payNow": "Maksāt tūlīt",
  "button.joinClubOne": "Pievienojieties Club One",
  "price.toBePaid": "Jāmaksā",
  "price.subtotal": "Starpsumma",
  "price.alreadyPaid": "Jau apmaksāts",
  "copy.coupon.to.clipboard.accessibility.label": "Kopēt kupona kodu starpliktuvē",
  "price.chargeFee": "Rezervācijas maiņas maksa",
  "expired.codes": "Kodi, kam beidzies derīguma termiņš",
  "button.buy.cta": "Iegādāties abonementa biļetes",
  "no.codes.available": "Jums nav pieejamu kodu",
  "accessibility.icon.aria-label": "Izlasiet mūsu pieejamības paziņojumu",
  "pet.count": "{count, plural, =0 {# mājdzīvnieki} =1 {# mājdzīvnieks} other {# mājdzīvnieki}}",
  "accessibility.url": "https://www.tallink.com/lv/pieejamiba",
  "aLaCarteVoucher.withValue": "{{value}} À la carte kupons",
  "timeOfDay": "{{date, HH:mm}}",
  "dayWithTimeOfDay": "{{date, eee' plkst. 'HH:mm }}",
  "aLaCarteVoucher": "À la carte kupons",
  "ticket.expired": "Biļešu derīguma termiņš beidzies",
  "tooltip.accessibility.label": "Atvērt rīka padomu",
  "couponPage.login.cta": "Lai apskatītu iegādātās abonementa biļetes, lūdzu, <login>autorizējieties</login>.",
  "button.downloadFile": "Lejupielādēt failu ({{extension}})"
} },
lt: { translation: {
  "common.buyTickets": "Pirkti",
  "common.cancel": "Atšaukti",
  "common.done": "Parengta",
  "common.ok": "Gerai",
  "clubOne.level": "Club One {{level}}",
  "clubOne.points.points": "b.t.",
  "clubOne.points.hint": "Club One premijos taškus galite panaudoti iš dalies sumokėti už kelionę",
  "clubOne.switchToCompanyCustomer.warning": "Atsijungti nuo paskyros",
  "clubOne.switchToCompanyCustomer.title": "Prisijungti prie verslo kliento paskyros",
  "clubOne.loginLink": "Įveskite savo Club One numerį",
  "clubOne.title": "Club One klientas",
  "companyCustomer.agentId": "Agento ID numeris",
  "companyCustomer.agentId.error": "Agento ID numeris nerastas",
  "companyCustomer.agentId.pattern": "",
  "companyCustomer.error": "Neteisingas kliento numeris",
  "companyCustomer.id": "Kliento numeris",
  "companyCustomer.login": "Prisijungti",
  "companyCustomer.title": "Verslo klientas",
  "deliveryDetails.clubOneAnonymous.text": "Bilietai išsiųsti žemiau nurodytu elektroniniu paštu.",
  "deliveryDetails.clubOneLogged.text": "Bilietai išsiųsti žemiau nurodytu elektroniniu paštu.",
  "deliveryDetails.companyCustomerAnonymous.text": "Bilietai išsiųsti žemiau nurodytu elektroniniu paštu.",
  "deliveryDetails.companyCustomerLogged.text": "Bilietai išsiųsti žemiau nurodytu elektroniniu paštu.",
  "deliveryDetails.form.email.label": "El. paštas",
  "deliveryDetails.form.error.emailPattern": "Neteisingas el. pašto adresas",
  "deliveryDetails.form.error.namePattern": "Kurdami prisijungimo vardą, galite naudoti raides, simbolius ' ir -.",
  "deliveryDetails.form.error.required": "Šį lauką privaloma užpildyti.",
  "deliveryDetails.form.firstName.label": "Vardas",
  "deliveryDetails.form.lastName.label": "Pavardė",
  "deliveryDetails.title": "Pristatymo informacija",
  "description.passenger": "Vienas keleivio serijinis bilietas galioja vienam keleiviui viena kryptimi.",
  "description.vehicle": "Transporto priemonės serijinis bilietas galioja vienam automobiliui viena kryptimi. Į jį neįtraukta keleivio bilieto kaina.",
  "hero.mainTitle": "Serijiniai bilietai",
  "hero.subtitle": "Su vienu atitinkamu serijiniu bilietu keleiviui ir (arba) transporto priemonei leidžiama keliauti viena kryptimi pasirinktu maršrutu.",
  "hint.clubOne.error": "Jungiantis prie sistemos, įvyko klaida. Įkelkite puslapį iš naujo arba tęskite nesijungdami prie sistemos. Atsiprašome už nepatogumus.",
  "hint.clubOne.text": "Club One klientams suteikiamos nuolaidos ir galimybė kaupti premijos taškus, kuriuos vėliau galima panaudoti perkant naujus kelto bilietus. <a href=\"https://www.tallink.lv/lt/club-one-programme\" target=\"_blank\">Plačiau apie Club One</a>",
  "mainPage.title": "Serijiniai bilietai",
  "mobile.back": "← Atgal",
  "mobile.done": "Patvirtinu",
  "price.description": "Bilietai",
  "price.amount": "Kiekis",
  "price.discount": "Nuolaida",
  "price.price": "Kaina",
  "price.regular": "Įprasta kaina",
  "price.giftCard": "Dovanų kortelė",
  "serialTicketName.passenger.business": "Business Lounge klasės bilietai",
  "serialTicketName.passenger.comfort": "Comfort Lounge klasės bilietai",
  "serialTicketName.passenger.star": "Star Class klasės bilietai",
  "serialTicketName.vehicle.CAR": "Keleivio bilietas su transporto priemone \n (iki ↔ 5 m ↕1,9 m)",
  "serialTicketName.vehicle.CAR XL": "Keleivio bilietas su transporto priemone \n (iki ↔ 5,5 m ↕ 2,4 m)",
  "serialTicketName.vehicle.VAN": "Mikroautobuso bilietas\n (iki ↔ 7 m ↕ 2,4 m)",
  "signIn.button": "Prisijungti",
  "signOut.link": "Atsijungti →",
  "signInWithCompanyId.link": "Prisijungti su kliento ID →",
  "srt.termsAndConditions.title": "Serijinių bilietų sąlygos",
  "termsAndConditions.text": "<li>Serijinis bilietas galioja 8, 14 arba 24 kelionėms viena kryptimi, keliaujant šiais maršrutais: Helsinkis–Talinas ir Talinas–Helsinkis.</li>\n<li>Serijiniai bilietai nėra vardiniai, todėl bilietais gali naudotis jūsų draugai, šeimos nariai, kolegos ir kt. </li>\n<li>Vienas keleivio serijinis bilietas skirtas vienam keleiviui vienai kelionei viena kryptimi.</li>\n<li>Vienas transporto priemonių serijinis bilietas skirtas vienam automobiliui. Į jo kainą neįskaičiuotas keleivio bilietas.</li>\n<li>Serijinis bilietas galioja vienerius metus.</li>\n<li>Serijinį bilietą galima įsigyti oficialiose atstovybėse, klientų aptarnavimo skyriuose ir kompanijos Tallink svetainės elektroninėje sistemoje.</li>\n<li>Rezervuoti kelionę naudojant serijinį bilietą galima oficialiose atstovybėse, klientų aptarnavimo skyriuose ir kompanijos Tallink svetainės elektroninėje sistemoje.</li>\n<li>Vienos rezervacijos metu galima panaudoti ne daugiau, nei šešis serijinius bilietus vienu metu.</li>\n<li>VRezervuojant internetu, serijinio bilieto galiojimo laikas pradedamas skaičiuoti nuo pirmosios kelionės.</li>\n<li>Pakeitus įsigytų serijinių bilietų išvykimo laiką, netesybų mokestis neskaičiuojamas. Keitimus galima atlikti iki registracijos pabaigos (check-in).</li>\n",
  "type.passenger": "Keleivių bilietai",
  "type.vehicle": "Transporto priemonių bilietai",
  "voucherPanel.header": "Nuolaidos ir nuolaidų kodai",
  "voucherPanel.link.addAnotherVoucher": "+ pridėti dar vieną nuolaidos kodą",
  "voucherPanel.link.addVoucher": "Turiu nuolaidos kodą arba dovanų kortelę",
  "voucherPanel.voucher.button.add": "Pridėti",
  "voucherPanel.voucher.hint": "Dovanų kortelę galite naudoti keletui pirkinių, kol išnaudosite joje esančias lėšas.<br>\n Dovanų kortelės sąskaitoje yra <b>{{amountLeft}} €</b>.<br>\n Dovanų kortelė galioja iki <b>{{expirationDate}}</b>.",
  "voucherPanel.voucher.label": "Nuolaidos kodas",
  "voucherPanel.voucher.validate.callToCallCenter": "Norėdami pasinaudoti dovanų kortele, susisiekite su klientų aptarnavimo skyriumi telefonu +371 6709 9700 ",
  "voucherPanel.voucher.validate.error": "Prašome patikrinti, ar nuolaidos kodas teisingas",
  "payment.unsuccessful.description": "Mokėjimo metu įvyko klaida. Įsitikinkite, kad jūsų kortelės sąskaitoje pakanka lėšų ir bandykite dar kartą.",
  "payment.unsuccessful.title": "Mokėjimas nepavyko",
  "payment.cancelled.title": "This order has not been paid",
  "payment.title": "Mokėjimas",
  "payment.paymentServiceMethods.title": "Kortelė",
  "payment.paymentServiceMethods.combined.title": "Kortelė & bankas",
  "payment.disclaimer": "Jei esate jaunesnis nei 18 metų, susipažinkite su <a href=\"https://www.tallinksilja.com/good-to-know#16658622\" target=\"_blank\"> ribojimais dėl amžiaus</a>. Spustelėję mokėjimo mygtuką sutinkate su <a href=\"https://www.tallinksilja.com/good-to-know\" target=\"_blank\">mokėjimo ir anuliavimo sąlygomis</a>.",
  "payment.disclaimer.Extra.TallinkGrupp": "Jei esate jaunesnis nei 18 metų, susipažinkite su <a href=\"https://www.tallinksilja.com/good-to-know#16658622\" target=\"_blank\">ribojimais dėl amžiaus</a>. Spustelėję mokėjimo mygtuką, sutinkate su <a href=\"https://www.tallinksilja.com/good-to-know\" target=\"_blank\">mokėjimo ir anuliavimo sąlygomis</a>.<br>\nSiūlome turistinių paslaugų paketą – tai kelionių paketas pagal (ES) 2015/2302 direktyvą. Taigi, įsigiję kelionių paketą, turėsite visas ES įstatymuose numatytas keleivio teises. AS Tallink Grupp visiškai atsako už kelionių paketus ir už bendrą tinkamą paslaugų teikimą.<br>\nBe to, pagal įstatymus reikalaujama, kad AS Tallink Grupp turėtų garantiją tuo atveju, jei bendrovė negalės įvykdyti savo įsipareigojimų dėl mokumo, grąžinti jūsų sumokėtų lėšų ir, jei į kelionių paketą įskaičiuotas keleivių pavežėjimas, užtikrinti jūsų pavežėjimą į išvykimo tašką ar kitą sutartą vietą.<br>\n<a href=\"https://www.tallinksilja.com/packaged-tours-tallink-grupp\" target=\"_blank\">Susipažinti su kelionių paketų sąlygomis</a>.",
  "payment.disclaimer.Extra.TallinkSiljaOY": "Jei esate jaunesnis nei 18 metų, susipažinkite su <a href=\"https://www.tallinksilja.com/good-to-know#16658622\" target=\"_blank\">ribojimais dėl amžiaus</a>. Spustelėję mokėjimo mygtuką, sutinkate su <a href=\"https://www.tallinksilja.com/good-to-know\" target=\"_blank\">mokėjimo ir anuliavimo sąlygomis</a>.<br>\nSiūlome turistinių paslaugų paketą – tai kelionių paketas pagal (ES) 2015/2302 direktyvą. Taigi, įsigiję kelionių paketą, turėsite visas ES įstatymuose numatytas keleivio teises. Tallink Silja Oy visiškai atsako už kelionių paketus ir už bendrą tinkamą paslaugų teikimą.<br>\nBe to, pagal įstatymus reikalaujama, kad Tallink Silja Oy turėtų garantiją tuo atveju, jei bendrovė negalės įvykdyti savo įsipareigojimų dėl mokumo, grąžinti jūsų sumokėtų lėšų ir, jei į kelionių paketą įskaičiuotas keleivių pavežėjimas, užtikrinti jūsų pavežėjimą į išvykimo tašką ar kitą sutartą vietą.<br>\n<a href=\"https://lv.tallink.com/lt/celojumu-paketes-tallink-silja\" target=\"_blank\">Susipažinti su kelionių paketų sąlygomis</a>.",
  "passengerDistribution.errors.WITHOUT_ADULT": "Kajutėje turi būti mažiausiai vienas suaugęs žmogus.",
  "passengerDistribution.errors.WITHOUT_CABIN": "Prašome apgyvendinti kajutėse {nrOfPassengersWithoutCabin, plural, one{likusį # keleivį} other{likusius # keleivius}}.",
  "passengerDistribution.notification.childWithoutOwnBed": "Vaikas neturi atskiros miegamosios vietos.",
  "payment.klarna.title": "Klarna",
  "payment.onlineBanks.list.aktia": "Aktia",
  "payment.onlineBanks.list.alandsbanken": "Ålandsbanken",
  "payment.onlineBanks.list.coop": "COOP Pank",
  "payment.onlineBanks.list.danskebankEE": "Danske Bank",
  "payment.onlineBanks.list.danskebankFI": "Danske Bank",
  "payment.onlineBanks.list.handelsbanken": "Handelsbanken",
  "payment.onlineBanks.list.kultaraha": "Osuuspankki",
  "payment.onlineBanks.list.lahitapiola": "LähiTapiola",
  "payment.onlineBanks.list.lhv": "LHV",
  "payment.onlineBanks.list.luminor": "Luminor",
  "payment.onlineBanks.list.nordea": "Nordea",
  "payment.onlineBanks.list.saastopankki": "Säästöpankki",
  "payment.onlineBanks.list.seb": "SEB",
  "payment.onlineBanks.list.spankki": "S-Pankki",
  "payment.onlineBanks.list.swedbank": "Swedbank",
  "payment.invoice.title": "Mokėjimo būdas",
  "payment.type.invoice": "Išrašyti sąskaitą apmokėjimui",
  "payment.reference.title": "Jūsų nuorodos numeris",
  "payment.reference.disclaimer": "Spustelėję mokėjimo mygtuką, sutinkate su <a href=\"https://www.tallinksilja.com/good-to-know\" target=\"_blank\">taisyklėmis ir sąlygomis</a>.",
  "payment.type.card": "Mokėti kortele",
  "payment.klarna.options.title": "Mokėjimo būdas priklauso nuo jūsų rezervacijos. Populiariausi būdai:",
  "payment.klarna.options.list": "<li>Sąskaita</li><li>Dalinis mokėjimas</li>",
  "payment.klarna.policy": "Patvirtindami rezervaciją, jūs sutinkate, kad rezervacijos informacija būtų perduota Klarna priežiūros sistemai. Išsamesnė informacija<a href=\"https://cdn.klarna.com/1.0/shared/content/policy/data/en_fi/privacy_statement.pdf\" target=\"_blank\">svetainėje </a>.",
  "payment.klarna.mobile.title": "Naudodamiesi Klarna priežiūros sistema, mobiliuoju telefonu mokėkite lengvai ir saugiai.",
  "paymentPage.total": "Iš viso",
  "paymentPage.confirm.freeReservation": "",
  "paymentPage.confirm.onlyPayment": "Mokėti",
  "paymentPage.confirm.onlyPayment.withInvoice": "Patvirtinti",
  "confirmation.thankYouCallout.title": "Dėkojame, kad pirkote!",
  "confirmation.thankYouCallout.paidTotal": "Sumokėta iš viso",
  "confirmation.thankYouCallout.message": "Mokėjimas atliktas sėkmingai ir užsakymas patvirtintas. Jūsų rezervacijos patvirtinimas ir detalizuotas užsakymas išsiųstas adresu <b>{{email}}</b>.",
  "confirmation.orderConfirmation": "Užsakymo patvirtinimas",
  "confirmation.summary.downloadPdf": "Atsisiųsti PDF",
  "confirmation.summary.bookTrip": "Rezervuoti kelionę",
  "confirmation.summary.disclaimer": "Galite iš karto pasinaudoti pirkiniu. Rezervuokite savo kelionę dabar.",
  "confirmation.summary.email": "El. paštas",
  "confirmation.summary.contactPerson": "Kontaktinis asmuo",
  "confirmation.summary.securityCode": "Saugos kodas",
  "confirmation.summary.orderNumber": "Užsakymo numeris",
  "otherPaymentMethod": "Kitas mokėjimo būdas",
  "paymentMethod": "Mokėjimo būdas",
  "remove": "Pašalinti",
  "answer.yes": "Taip",
  "answer.no": "Ne",
  "button.send": "Išsiųsta",
  "button.withoutPrice.notChosen": "Pasirinkite",
  "button.withoutPrice.chosen": "Pašalinti",
  "button.add": "Pridėti",
  "clubOne.level.BRONZE": "Bronze",
  "clubOne.level.SILVER": "Silver",
  "clubOne.level.GOLD": "Gold",
  "clubOne.level.title": "Club One",
  "currency.EUR": "€",
  "currency.LAT": "Ls",
  "currency.LVL": "Ls",
  "currency.RUB": "€",
  "currency.SEK": "kr",
  "dateFormat.dayOfWeekDayMonthAndTime": "{weekday} <b>{date}</b> val. <b>{time}</b>",
  "decimalSeparator": ",",
  "details.dayMonthAndTime.pattern": "d.m k\\\\l H:i",
  "details.dayOfWeek.pattern": "l",
  "entertainment.title": "Pramogos laive",
  "entertainment.sitting": "vietos",
  "error.chromeframe.label": "Arba galite įdiegti į dabartinę naršyklę Google",
  "entertainment.sittingGroup.premium.name\r\n": "Premium sėdimosios vietos",
  "entertainment.sittingGroup.premium.description": "Premium sėdimosios vietos apima maitinimą bei geriausias vietas norint pamatyti šou pasirodymus",
  "entertainment.sittingGroup.basic.name\r\n": "Ribotos sėdimosios vietos",
  "entertainment.sittingGroup.basic.description": "Standartinė sėdimoji vieta negarantuoja gero vaizdo į sceną",
  "entertainment.sittingGroup.basic.addOn.name\r\n": "Sėdimosios vietos su ribotu vaizdu į sceną",
  "error.chromeframe.link": "Chrome Frame papildinys",
  "error.ie": "Jūs naudojate pasenusią Internet Explorer versiją, dėl kurios gali kilti problemų naudojantis Tallink internetinio užsakymo tinklapiu. Rekomenduojame atnaujinti dabartinę naršyklę vienu iš šių būdų:",
  "error.notPossibleToChangeBookingOnline": "Deja, užsakymo metu negalima atlikti pakeitimų internete. <br> <br> Jei jums reikės bet kokių pakeitimų, prašome rašyti į mūsų <a href=\"mailto:booking@tallink.lv\"> klientų aptarnavimą </a> arba skambinkite +371 67099700. <br> Jei esate užsienyje, skambinkite +371 67099700",
  "form.email": "Elektoninis paštas",
  "form.phone": "Telefonas",
  "format.LocalDayMonth": "{{date, d.M}}",
  "format.LocalShortWeekdayAndDayMonth": "D d.m",
  "format.LocalLongWeekdayAndDayMonth": "I d.m",
  "format.LocalShortWeekdayAndShortMonth": "MMM D",
  "format.LocalDayMonthYear": "d.m.Y",
  "header.bookingNumber": "Užsakymo numeris",
  "header.logout": "Išeiti iš sistemos",
  "header.myBooking": "Rezervacija",
  "header.pin": "Apsaugos kodas",
  "hotel.checkInTime": "Registruokitės",
  "hotel.checkOutTime": "Išvykimas",
  "nights": "Naktys",
  "night": "Naktis",
  "hotelsItinerary.returnTripIsNotAvailable": "Grįžimo kelionė yra išparduota. Prašome pasirinkti kitą kelionės datą. ",
  "label.remove": "Pašalinti",
  "landServices.title": "Pramogos krante",
  "landService.ageCategory.base": "Reguliarus bilietas",
  "landService.ageCategory.child": "Vaikai {ageCategory}  metai",
  "landService.dateTime.pattern": "j.n.Y",
  "meals.packages.choosePackage": "Pasirink maisto paketą",
  "meals.packages.title": "Maitinimosi pasiūlymai",
  "meals.packages.commonInfo": "Maisto paketas apima maitinimą visos kelionės metu",
  "meals.packages.description": "Vaikai gauna nuolaidą, o 0–5 metų amžiaus vaikai nemokamai gauna maitinimą keliaujant su tėvais. <br> Jei maitinimo pasiūlymai yra išparduoti, į rezervaciją bus įtraukti tos pačios vertės kuponai. Maitinimo kuponus taip pat galima naudoti kaip mokėjimą visuose laivo restoranuose.",
  "meals.button.freeMealPackages": "Įskaičiuota",
  "meals.selectionMealBlockedByTime": "Išankstinė maisto rezervacija baigta. Jeigu atsirastų poreikis papildomam maitinimui jį galite įsigyti laive",
  "onboardServices.title": "Paslaugos laive",
  "adults": "suaugusieji",
  "adult": "suaugęs",
  "child": "vaikas",
  "junior": "Jaunesnysis",
  "youth": "Jaunimas",
  "children": "vaikai",
  "guests.edit.accessibility.label": "Keleivių duomenys",
  "pier.DTER.address": "Lootsi 13, 10151 Talinas",
  "pier.DTER.title": "D-Terminalas",
  "pier.FHAM.address": "Frihamnen, Magasin 2, 10 253 Stokholmas",
  "pier.FHAM.title": "Frihamnen",
  "pier.HND.title": "Härnösand",
  "pier.HND.address": "Skeppsbron 31, 871 80 Härnösand",
  "pier.LNAS.address": "Långnäs terminalas, Lumparland",
  "pier.LNAS.title": "Långnäs",
  "pier.LSA2.address": "Vakarinis uostas, Helsinkis",
  "pier.LSA2.title": "Vakarinis terminalas 2",
  "pier.LSA6.address": "Tyynenmerenkatu 8, 00220 Helsinkis",
  "pier.LSA6.title": "Vakarinis terminalas",
  "pier.LSAT.address": "Tyynenmerenkatu 8, 00220 Helsinkis",
  "pier.LSAT.title": "Vakarinis terminalas",
  "pier.MHAM.address": "Västra hamnen, 22100 Mariehamna",
  "pier.MHAM.title": "Mariehamnas",
  "pier.MUUG.address": "Muuga sadam, Maardu Tee 65, Maardu",
  "pier.MUUG.title": "Muuga Uostas",
  "pier.OLYM.address": "Olympiaranta 1, 00140 Helsinkis",
  "pier.OLYM.title": "Olympia Terminalas",
  "pier.PALD.address": "Rae põik 10, EE-76806 Paldiski",
  "pier.PALD.title": "Paldiski",
  "pier.KAPE.address": "Hamnterminalen, 760 15 Gräddö",
  "pier.KAPE.title": "Kapellskär",
  "pier.RIGA.address": "Eksporta 3a, Ryga, LV-1010",
  "pier.RIGA.title": "Rygos terminalas",
  "pier.TSAT.address": "Linnankatu 91, 20100 Turku",
  "pier.TSAT.title": "Turku",
  "pier.VHAM.address": "Hamnpirsvägen 10, 11574 Stokholmas",
  "pier.VHAM.title": "Värtahamnen",
  "pier.VISH.title": "Visbis",
  "pier.VISH.address": "Färjeleden 2, 62181, Visbis",
  "pier.VSAA.address": "Vuosaari, Seilorinkatu 5, Helsinkis",
  "pier.VSAA.title": "Vuosaari Uostas",
  "pier.MFAC.address": "Bereg Nevskoy gubi 1., V.O., St. Petersburg",
  "pier.MFAC.title": "St.Peterburgas",
  "pier.SAS.title": "Sassnitz",
  "pier.SMA1.title": "Sarema",
  "pier.SMA1.address": "Ninase village, Mustjala, 93631, Saaremaa",
  "pier.KLJ1.title": "Klaipėda",
  "pier.KLJ1.address": "J.Zauerveino str. 18, LT-92122 Klaipeda, Lithuania",
  "port.KAP": "Kapellskär",
  "port.PAL": "Paldiski",
  "port.KLJ": "Klaipėda",
  "port.YST": "Ystad",
  "port.PARTY": "Šventė baltijos jūroje",
  "refresh": "Atnaujinti",
  "reservation.travelPermitForYouth": "Jei esate 15–17 metų amžiaus, galite keliauti vieni į vieną pusę arba vieną dieną. Būtinai pasiimkite <a target=\"_blank\" href=https://ee.tallink.com/documents/10192/65371006/Permission_to_travel_alone_15_17_EN.pdf/7a0c8141-c394-42b5-a6db-29469450ddc6> leidimas keliauti</a>. Saugios kelionės!",
  "send.email.failed": "Nepavyko išsiųsti el. laiško. Prašome, pabandyti dar kartą.",
  "send.sms.failed": "Nepavyko išsiųsti SMS žinutės. Prašome, pabandyti dar kartą.",
  "summary.confirm": "Patvritinkite",
  "summary.dateTime.pattern": "j.n.Y <\\\\sp\\\\a\\\\n>\\\\a\\\\t</\\\\sp\\\\a\\\\n> H:i",
  "summary.extraServices": "Papildomų paslaugų kaina įtraukta į bendrą kainą. Visa reikalinga informacija pateikiama PDF formatu, bus išsiųsta jums elektroniniu paštu. ",
  "summary.freeMealPackages.title": "Nemokamos papildomos paslaugos",
  "summary.refund.notification": "Dėl lėšų grąžinimo kreipkitės į klientų aptarnavimo centrą adresu {phoneLocal}.",
  "summary.refund.notification.with.phoneInternational": "Norėdami grąžinti pinigus, kreipkitės į klientų aptarnavimo centrą adresu {phoneLocal} / {phoneInternational}",
  "summary.refund.notification.phoneInternational.EE": " +372 640 9808",
  "summary.refund.notification.phoneInternational.SE": " +46 8 22 21 40",
  "summary.refund.notification.phoneLocal": " +49 (0)40 547 541 222",
  "summary.refund.notification.phoneLocal.FI": "(09) 887 53121",
  "summary.refund.notification.phoneLocal.EE": " 17 808",
  "summary.refund.notification.phoneLocal.SE": "08 22 21 40",
  "summary.refund.notification.phoneLocal.LV": " +371 670 997 00",
  "summary.refund.notification.phoneLocal.RU": " + 372 611 8801",
  "summary.clearChanges.title": "Apsigalvojote?",
  "summary.clearChanges.link": "Atšaukti pakeitimus",
  "summary.overnightPackage": "Nakvynė laive",
  "template.dateTime": "{date} <span>val.</span> {time}",
  "time.preposition.at": "val",
  "validate.firstName": "Įveskite vardą, prašome naudoti tik lotyniškas raides",
  "validate.lastName": "Įveskite pavardę, prašome naudoti tik lotyniškas raides",
  "location.hotelCityCode.HAA": "Haapsalu",
  "location.hotelCityCode.HEL": "Helsinkis",
  "location.hotelCityCode.JUR": "Jūrmala",
  "location.hotelCityCode.KOM": "Kolmården",
  "location.hotelCityCode.KUR": "Kuressaare",
  "location.hotelCityCode.LAL": "Laulasmaa",
  "location.hotelCityCode.MHQ": "Marienhamnas",
  "location.hotelCityCode.NAR": "Norva",
  "location.hotelCityCode.NRK": "Norrkopingas",
  "location.hotelCityCode.OTE": "Otepa",
  "location.hotelCityCode.PAR": "Parnu",
  "location.hotelCityCode.RAK": "Rakverė",
  "location.hotelCityCode.RIX": "Ryga",
  "location.hotelCityCode.SOE": "Sodertalje",
  "location.hotelCityCode.STO": "Stokholmas",
  "location.hotelCityCode.TAR": "Tartu",
  "location.hotelCityCode.TKU": "Turku",
  "location.hotelCityCode.TLL": "Talinas",
  "location.hotelCityCode.TMP": "Tamperė",
  "location.hotelCityCode.UPP": "Upsala",
  "location.hotelCityCode.VAN": "Vanta",
  "location.hotelCityCode.VIH": "Vihula",
  "vehicle.type.bicycle.title": "Dviratis, el. paspirtukas",
  "vehicle.type.car.title": "Lengvasis automobilis",
  "vehicle.type.car-xl.title": "Lengvasis automobilis",
  "vehicle.type.long-and-high.title": "Automobilis su priekaba",
  "vehicle.type.long-and-low.title": "Automobilis su priekaba",
  "vehicle.type.long-and-medium.title": "Automobilis su priekaba",
  "vehicle.type.motorcycle.title": "Motociklas",
  "vehicle.type.motorcycle-with-sidecar.title": "Motociklas su priekaba",
  "vehicle.type.motorcycle-with-sidecar.measures": "Iki 1,9 m aukščio, iki 4 m ilgio",
  "vehicle.type.van-high.title": "Autobusas",
  "vehicle.type.parked-car.title": "Priparkuotas automobilis",
  "vehicle.type.van.title": "Autobusas",
  "vehicle.type.parked-van.title": "Priparkuotas autobusiukas",
  "vehicle.type.shopper-car.title": "Pirkėjo auto",
  "vehicle.type.shopper-van.title": "Pirkėjo autobusas",
  "vehicle.type.shopper-car.notices": "- Lengva patekti į jūsų automobilį kelionės metu. - Parkuojama šalia parduotuvių",
  "vehicle.type.shopper-van.notices": "- Lengva patekti į jūsų automobilį kelionės metu. - Parkuojama šalia parduotuvių",
  "vehicle.type.parked-car.notices": "- Nėra galimybės naudotis transporto priemone (t/p) kelionės metu<br>\r\n- Nėra galimybės išvažiuoti iš laivo paskirties vietoje",
  "vehicle.type.parked-van.notices": "- Nėra galimybės naudotis transporto priemone (t/p) kelionės metu<br>\r\n- Nėra galimybės išvažiuoti iš laivo paskirties vietoje",
  "vehicle.type.shopper-car.noDisembark": "Negalima palikti automobilio ant kranto",
  "vehicle.type.shopper-van.noDisembark": "Negalima palikti automobilio ant kranto",
  "vehicle.type.parked-car.noDisembark": "Išėjimo į krantą nėra",
  "vehicle.type.under.measures": "<span class=\"height\"></span> {height} m <span class=\"width\"></span> {length} m",
  "wifi.title": "WiFi",
  "common.language.FI": "Suomių kalba",
  "common.language.ET": "Estų kalba",
  "common.language.EN": "Anglų kalba",
  "common.language.RU": "Rusų kalba",
  "common.language.SV": "Švedų kalba",
  "common.language.DE": "Vokiečių kalba",
  "common.language.LV": "Latvių kalba",
  "common.language.LT": "Lietuvių kalba",
  "label.or": "arba",
  "routePanel.from": "iš",
  "routePanel.to": "į",
  "port.ALA": "Alandų salos",
  "port.HEL": "Helsinkis",
  "port.MUG": "Muuga",
  "port.RIG": "Ryga",
  "port.STO": "Stokholmas",
  "port.TAL": "Talinas",
  "port.TUR": "Turku",
  "port.VIS": "Visbis",
  "port.VSS": "Vuosaari",
  "port.SPE": "Peterburgas",
  "port.SAS": "Sassnitz",
  "port.SMA": "Sarema",
  "port.VNT": "Ventspils",
  "port.HND": "Härnösand",
  "button.edit": "Keisti",
  "guests": "keleiviai",
  "vehicles": "Transporto sistemos",
  "date": "Data",
  "travelClass.title": "",
  "giftCard": "Dovanų kortelė",
  "SIGN_IN": "Prisijungti",
  "button.book.a.trip": "Užsisakykite kelionę",
  "price.total": "Iš viso",
  "clubOne.points.price": "ir {{count}} taškus",
  "error.title": "Klaida",
  "button.close": "Uždaryti",
  "calendar.choose.date": "Pasirinkti datą",
  "itinerary.miniCruise": "5h kruizas",
  "TAL-HEL.CRUISE": "9h kruizas",
  "timetable.oneWay": "Į vieną pusę",
  "timetable.roundtrip": "Kelionė į bai puses",
  "button.done": "Įvykdyta",
  "pets": "augintiniai",
  "label.see.details": "Žiūrėti išsamią informaciją",
  "common.language.KO": "Korėjiečių",
  "common.language.ZH": "Kinų",
  "common.language.JA": "Japonų",
  "header.chooseYourLanguage": "Pasirinkite kalbą",
  "pageNotFound.title": "Kruopščiai ištyrinėjome kiekvieną svetainės kampelį...",
  "pageNotFound.subtitle": "Deja, neradome puslapio, kurio ieškojote.",
  "goBack": "Atgal",
  "label.info": "",
  "itinerary.title": "Kelionių informacija",
  "itinerary.description": "",
  "extraServices.button.soldOut": "Parduotas",
  "button.cancel": "Atšaukti",
  "abbreviation.hour": "{{hour}} h",
  "cruise": "Kruizas",
  "HEL-TAL.CRUISE": "22h kruizas",
  "form.error.required": "Vertė yra privaloma",
  "form.error.min": "Mažiausia leistina vertė yra {{min}}",
  "form.error.max": "Didžiausia leistina vertė yra {{max}}",
  "form.error.minLength": "Mažiausias leistinas ilgis yra {{minLength}}",
  "form.error.maxLength": "Didžiausias leistinas ilgis yra {{maxLength}}",
  "sailLeg.sailTime": "{{date, eee', <b>'dd.MM' <br>'HH:mm'</b>'}} val",
  "timetable.tripTypeAndDeparture": "Kelionės tipas ir išvykimas",
  "timetable.calendar": "Kalendorius",
  "timetable.table.departureAndArrival": "Išvykimas & atvykimas",
  "timetable.table.duration": "Trukmė",
  "timetable.table.vessel": "Keltas",
  "clubOne.slider.label": "Naudokite „Club One“ taškus",
  "button.proceed": "Tęsti ",
  "label.loading": "Atsisiunčiu duomenis",
  "sailLeg.sailTime.short": "{{date, '<b>'dd.MM'</b> <b>'HH:mm'</b>'}} val",
  "clubOne.slider.description": "",
  "specialCruise": "",
  "cabin": "kajutė",
  "lounges": "poilsio kambariai",
  "cabins": "kajutės",
  "specialCabins": "specialios kajutės",
  "specialCabin.tag.handicap": "Prieinama neįgaliesiems",
  "specialCabin.tag.allergy": "Tinka alergiškiems",
  "voucher": "Kuponas",
  "serialTicket": "Serijinis bilietas",
  "summary": "",
  "contact": "",
  "booking": "",
  "payment": "",
  "free": "",
  "guest": "keleivis",
  "guest.count": "",
  "cabin.count": "",
  "form.firstName": "",
  "form.lastName": "",
  "CO.number": "",
  "dateOfBirth": "",
  "gender": "",
  "guest.details": "",
  "nationality": "",
  "specialAssistance": "",
  "payButton": "Mokėti",
  "loading": "Palaukite...",
  "male": "",
  "female": "",
  "citizenship.estonian": "",
  "notRequired": "",
  "ELECTRIC WHEELCHAIR": "",
  "VISUALLY IMPAIRED": "",
  "HEARING IMPAIRED": "",
  "OTHER REASON FOR ASSISTANCE": "",
  "GUIDEDOG": "",
  "WHEELCHAIR": "",
  "button.ok": "OK",
  "errorPage.title": "An error occured!",
  "form.error.email": "",
  "form.error.positiveInteger": "Leidžiami tik skaičiai",
  "form.error.date": "Data neteisinga",
  "form.error.name": "",
  "form.error.clubOne": "",
  "clubOneApplied": "",
  "optional": "Neprivaloma",
  "form.error.positiveFloat": "Leidžiami tik skaičiai arba dešimtainės vertės",
  "AD": "Andorra",
  "AE": "JUNGTINIAI ARABŲ EMYRATAI",
  "AF": "AFGANISTANAS",
  "AG": "ANTIGUA AND BARBUDA",
  "AI": "ANGUILLA",
  "AL": "ALBANIJA",
  "AM": "ARMĖNIJA",
  "AN": "NYDERLANDŲ ANTILIAI",
  "AO": "ANGOLA",
  "AQ": "ANTARKTIDA",
  "AR": "ARGENTINA",
  "AS": "AMERICAN SAMOA",
  "AT": "AUSTRIJA",
  "AU": "AUSTRALIJA",
  "AW": "ARUBA",
  "AZ": "AZERBAIDŽANAS",
  "BA": "BOSNIJA IR HERCOGOVINA",
  "BB": "BARBADOSAS",
  "BD": "BANGLADEŠAS",
  "BE": "BELGIJA",
  "BF": "BURKINA FASO",
  "BG": "BULGARIJA",
  "BH": "BAHRAINAS",
  "BI": "BURUNDIS",
  "BJ": "BENIN",
  "BM": "BERMUDAI",
  "BN": "BRUNEI DARUSSALAM",
  "BO": "BOLIVIJA",
  "BR": "BRAZILIJA",
  "BS": "BAHAMAI",
  "BT": "BHUTAN",
  "BW": "BOTSVANA",
  "BY": "BALTARUSIJA",
  "BZ": "BELIZE",
  "CA": "KANADA",
  "CC": "COCOS (KEELING) SALOS",
  "CD": "CONGO, DOMINYKOS RESPUBLIKA",
  "CF": "CENTRINĖ AFRIKOS RESPUBLIKA",
  "CG": "KONGAS",
  "CH": "ŠVEICARIJA",
  "CI": "COTE D'IVOIRE",
  "CK": "COOK SALOS",
  "CL": "ČILĖ",
  "CM": "KAMERŪNAS",
  "CN": "KINIJA",
  "CO": "KOLUMBIJA",
  "CR": "KOSTA RIKA",
  "CS": "SERBIJA",
  "CU": "KUBA",
  "CV": "CAPE VERDE",
  "CX": "KALĖDŲ SALOS",
  "CY": "KIPRAS",
  "CZ": "ČEKIJOS RESPUBLIKA",
  "DE": "VOKIETIJA",
  "DJ": "DJIBOUTI",
  "DK": "DANIJA",
  "DM": "DOMINYKA",
  "DO": "DOMINYKOS RESPUBLIKA",
  "DZ": "ALGERIJA",
  "EC": "EKVADORAS",
  "EE": "ESTIJA",
  "EG": "EGIPTAS",
  "EH": "VAKARŲ SACHARA",
  "ER": "ERITRĖJA",
  "ES": "ISPANIJA",
  "ET": "ETIOPIJA",
  "FI": "SUOMIJA",
  "FJ": "FIDŽIS",
  "FK": "FALKLAND SALOS (MALVINAS)",
  "FM": "MICRONESIJOS FEDERACINĖS VALSTIJOS",
  "FO": "FARERŲ SALOS",
  "FR": "PRANCŪZIJA",
  "GA": "GABON",
  "GB": "JUNGTINĖ KARALYSTĖ",
  "GD": "GRENADA",
  "GE": "GRUZIJA",
  "GF": "FRENCH GUIANA",
  "GH": "GHANA",
  "GI": "GIBRALTARAS",
  "GL": "GREENLAND",
  "GM": "GAMBIJA",
  "GN": "GUINEA",
  "GP": "GVADALUPĖ",
  "GQ": "EQUATORIAL GUINEA",
  "GR": "GRAIKIJA",
  "GS": "PIETŲ GRUZIJA IR PIETŲ SANDVIKO SALOS",
  "GT": "GVATEMALA",
  "GU": "GUAM",
  "GW": "GUINEA-BISSAU",
  "GY": "GUYANA",
  "GZ": "GAZA STRIP",
  "HK": "HONG KONGAS",
  "HM": "HEARD AND MCDONALD SALOS",
  "HN": "HONDŪRAS",
  "HR": "KROATIJA",
  "HT": "HAITIS",
  "HU": "BULGARIJA",
  "ID": "INDONEZIJA",
  "IE": "AIRIJA",
  "IL": "IZRAELIS",
  "IN": "INDIJA",
  "IO": "INDIJOS VANDENYNO TERITORIJA",
  "IQ": "IRAKAS",
  "IR": "IRANAS, ISLAMO RESPUBLIKA",
  "IS": "ISLANDIJA",
  "IT": "ITALIJA",
  "JM": "JAMAIKA",
  "JO": "JORDANIJA",
  "JP": "JAPONIJA",
  "KE": "KENIJA",
  "KG": "KIRGIZSTANAS",
  "KH": "KAMBODŽA",
  "KI": "KIRIBATIS",
  "KM": "COMOROS",
  "KN": "SAINT KITTS - NEVIS",
  "KP": "KORĖJA, DEM. LIAUDIES RESPUBLIKA (ŠIAURĖS)",
  "KR": "KOREJOS RESPUBLIKA (PIETŲ)",
  "KW": "KUVEITAS",
  "KY": "KAIMANŲ SALOS",
  "KZ": "KAZAKSTANAS",
  "LA": "LAO TAUTOS DEMOKRATINĖ RESPUBLIKA",
  "LB": "LEBANONAS",
  "LC": "SENT LUSIJA",
  "LI": "LICHTENŠTEINAS",
  "LK": "ŠRI LANKA",
  "LR": "LIBERIJA",
  "LS": "LESOTHO",
  "LT": "LIETUVA",
  "LU": "LIUKSEMBURGAS",
  "LV": "LATVIJA",
  "LY": "LIBYAN ARAB JAMAHIRIYA",
  "MA": "MAROKAS",
  "MC": "MONAKAS",
  "MD": "MOLDAVIJA",
  "ME": "MONTENEGRO",
  "MG": "MADAGASKARAS",
  "MH": "MARŠALO SALOS",
  "MK": "MAKEDONIJA",
  "ML": "MALIS",
  "MM": "MYANMAR (FORMER BURMA)",
  "MN": "MONGOLIJA",
  "MO": "MAKAO",
  "MP": "ŠIAURĖS MARIANAS",
  "MQ": "MARTINIKA",
  "MR": "MAURITANIJA",
  "MS": "MONTSERRAT",
  "MT": "MALTA",
  "MU": "MAURICIJUS",
  "MV": "MALDYVAI",
  "MW": "MALAWI",
  "MX": "MEKSIKAS",
  "MY": "MALAIZIJA",
  "MZ": "MOZAMBIKAS",
  "NC": "NAUJOJI KALEDONIJA",
  "NE": "NIGERIJA",
  "NF": "NORFOLKO SALOS",
  "NG": "NIGERIJA",
  "NI": "NIKARAGVA",
  "NL": "OLANDIJA",
  "NO": "NORVEGIJA",
  "NP": "NEPALAS",
  "NR": "NAURU",
  "NU": "NIUE",
  "NZ": "NAUJOJI ZALANDIJA",
  "OM": "OMANAS",
  "OT": "KITAS",
  "PA": "PANAMA",
  "PE": "PERU",
  "PF": "PRANCŪZIJOS POLINEZIJA",
  "PG": "PAPUA NAUJOJI GRIVNĖJA",
  "PH": "FILIPINAI",
  "PK": "PAKISTANAS",
  "PL": "LENKIJA",
  "PM": "ST. PIERRE AND MIQUELON",
  "PN": "PITCAIRNO SALOS",
  "PR": "PUERTO RIKAS",
  "PS": "PALESTINA",
  "PT": "PORTUGALIJA",
  "PW": "PALAU",
  "PY": "PARAGVAJUS",
  "QA": "KATARAS",
  "RE": "REUNION",
  "RO": "RUMŪNIJA",
  "RS": "SERBIJA",
  "RU": "RUSIJOS REDERACIJA",
  "RW": "RWANDA",
  "SA": "SAUDO ARABIJA",
  "SB": "SALIAMONO SALOS",
  "SC": "SEIŠĖLIAI",
  "SD": "SUDANAS",
  "SE": "ŠVEDIJA",
  "SG": "SINGAPŪRAS",
  "SH": "ST. HELENA",
  "SI": "SLOVĖNIJA",
  "SJ": "SVALBARD IR JAN MAYEN",
  "SK": "SLOVAKIJA",
  "SL": "SIERA LEONĖ",
  "SM": "SAN MARINAS",
  "SN": "SENEGALAS",
  "SO": "SOMALIS",
  "SR": "PAVARDĖ",
  "ST": "SAO TOME AND PRINCIPE",
  "SV": "EL SALVADORAS",
  "SY": "SIRIJOS ARABIŠKA RESPUBLIKA",
  "SZ": "SWAZILAND",
  "TA": "TAITIS",
  "TC": "TURKS AND CAICOS ISLANDS",
  "TD": "ČADAS",
  "TF": "PRANCŪZIJOS PIETŲ ir ANTARKTŲ ŽEMĖS",
  "TG": "TOGAS",
  "TH": "TAILANDAS",
  "TJ": "TADŽIKISTANAS",
  "TK": "TOKELAU",
  "TL": "RYTŲ TIMŪRAS",
  "TM": "TURKMĖNIJA",
  "TN": "TUNISAS",
  "TO": "TONGA",
  "TR": "TURKIJA",
  "TT": "TRINIDADAS IR TOBAGAS",
  "TV": "TUVALU",
  "TW": "TAIVANAS",
  "TZ": "TANZANIJOS RESPUBLIKA",
  "UA": "UKRAINA",
  "UG": "UGANDA",
  "UM": "JUNGTINIŲ VALSTIJŲ MINOR OUTLYING SALOS",
  "US": "JUNGTINĖS AMERIKOS VALSTIJOS",
  "UY": "URUGVAJUS",
  "UZ": "UZBEKISTANAS",
  "VA": "VATICAN CITY STATE (HOLY SEE)",
  "VC": "SAINT VINCENT IR GRENADINES",
  "VE": "VENESUELA",
  "VG": "BRITANIJOS MERGELIŲ SALOS",
  "VI": "JUNGTINĖS VALSTIJOS MERGELIŲ SALOS",
  "VN": "VIETNAMAS",
  "VU": "VANUATU",
  "WE": "VAKARŲ BANKAS",
  "WF": "WALLIS IR FUTUNA SALOS",
  "WS": "SAMOA",
  "XK": "KOSOVAS",
  "XZ": "INTERNACIONALINĖ ZONA",
  "YE": "JEMENAS",
  "YT": "MAYOTTE",
  "YU": "",
  "ZA": "PIETŲ AFRIJA",
  "ZM": "ZAMBIJA",
  "ZR": "ZAIRE = CONGO DEM.",
  "ZW": "ZIMBABVĖ",
  "ZZ": "JŪROJE",
  "reservationFee": "Rezervacijos mokestis",
  "reserveTable": "Rezervuoti staliuką",
  "reserved": "Rezervuota",
  "footer.copyright": "© AS Tallink Grupp {{year}}",
  "button.changeBooking": "Keisti užsakymą",
  "payment.unsuccessful.callCenter": "Klientų aptarnavimas telefonu <b><a href=\"tel:+371 6709 9700 \">+371 6709 9700</a></b>, darbo laikas nuo pirmadienio iki penktadienio nuo 10.00 iki 15.00 val.",
  "payment.klarnaAndSwish.title": "Klarna & Swish",
  "payment.klarna.description": "Sąskaita faktūra, dalinis mokėjimas",
  "payment.onlineBank.title": "Interneto bankas",
  "payment.onlineBankAndCards.title": "Interneto bankas & debeto/kredito kortelę",
  "payment.cards.title": "Debeto/kredito kortelę",
  "payment.onlineBanks.title": "Bankas",
  "payment.BANK.description": "Bankai",
  "payment.MOBILE_PAY.description": "MobilePay",
  "payment.GOOGLE_PAY.description": "Google Pay",
  "payment.APPLE_PAY.description": "Apple Pay",
  "payment.onlineBanks.description": "Visi galimi bankai",
  "errorPage.description": "Įvyko klaida. Prašome įkelti puslapį iš naujo. Dėmesio! Atnaujinant puslapį, visa anksčiau nurodyta informacija nebus išsaugota. Jei klaida kartojasi, susisiekite su klientų aptarnavimo skyriumi telefonu +371 6709 9700.<br> Atsiprašome už galimus nepatogumus.",
  "payment.CARD.description": "Kortelių",
  "SERIAL COMFORT": "„Comfort Lounge“ keliautojų bilietai",
  "SERIAL PASSENGER": "Žvaigždžių klasės keliautojų bilietai",
  "SERIAL BUSINESS": "Verslo klubo keliautojų bilietai",
  "SERIAL CAR/CAR XL": "Baudos už automobilį",
  "SERIAL VAN": "Mikroautobusų bilietai",
  "available.codes": "Galimi kodai",
  "used.codes": "Naudoti kodai",
  "ticket.expiry.notice": "Šie bilietai galioja iki",
  "vehicle.type.extra-long-and-high.title": "Automobilis su priekaba",
  "accessibility": "Prieinamumas",
  "cancelCover": "Atšaukti viršelį",
  "clubOneDiscount": "„Club One“ nuolaida",
  "button.payNow": "Mokėti dabar",
  "button.joinClubOne": "",
  "copy.coupon.to.clipboard.accessibility.label": "Nukopijuokite kupono kodą į iškarpinę",
  "expired.codes": "Nebegaliojantys kodai",
  "button.buy.cta": "Pirkite serijinius bilietus",
  "no.codes.available": "Neturite jokių kodų, kuriuos galėtumėte naudoti",
  "accessibility.icon.aria-label": "Perskaitykite mūsų prieinamumo pareiškimą",
  "pet.count": "",
  "accessibility.url": "https://www.tallink.com/en/accessibility",
  "aLaCarteVoucher.withValue": "{{value}} kuponas pagal užsakymą",
  "timeOfDay": "{{date, HH:mm}}",
  "dayWithTimeOfDay": "{{data, eee HH:mm }}",
  "aLaCarteVoucher": "Kuponas pagal užsakymą",
  "ticket.expired": "Bilietai galiojo iki",
  "tooltip.accessibility.label": "Atidaryti patarimą",
  "couponPage.login.cta": "Norėdami peržiūrėti įsigytus serijinius bilietus, <login>prisijunkite</login>.",
  "button.downloadFile": "Atsisiųsti failą ({{extension}})"
} }
}
